import { create as e } from "xmlbuilder2";
//#region \0rolldown/runtime.js
var t = Object.defineProperty, n = (e, t) => () => (e && (t = e(e = 0)), t), r = (e, n) => {
	let r = {};
	for (var i in e) t(r, i, {
		get: e[i],
		enumerable: !0
	});
	return n || t(r, Symbol.toStringTag, { value: "Module" }), r;
}, i = /* @__PURE__ */ ((e) => typeof require < "u" ? require : typeof Proxy < "u" ? new Proxy(e, { get: (e, t) => (typeof require < "u" ? require : e)[t] }) : e)(function(e) {
	if (typeof require < "u") return require.apply(this, arguments);
	throw Error("Calling `require` for \"" + e + "\" in an environment that doesn't expose the `require` function. See https://rolldown.rs/in-depth/bundling-cjs#require-external-modules for more details.");
});
//#endregion
//#region src/model.ts
function a(e, t) {
	for (; t !== 0;) [e, t] = [t, e % t];
	return e === 0 ? 1 : e;
}
var o, s, c, l, u, d, f, p, m, h, g, _, v = n((() => {
	o = class e {
		constructor(e, t = 1) {
			if (t === 0) throw Error("Denominator cannot be zero");
			let n = t < 0 ? -1 : 1, r = n * e, i = n * t, o = a(Math.abs(r), i);
			this.numerator = r / o, this.denominator = i / o;
		}
		toNumber() {
			return this.numerator / this.denominator;
		}
		add(t) {
			return new e(this.numerator * t.denominator + t.numerator * this.denominator, this.denominator * t.denominator);
		}
		subtract(t) {
			return new e(this.numerator * t.denominator - t.numerator * this.denominator, this.denominator * t.denominator);
		}
		multiply(t) {
			return typeof t == "number" ? new e(this.numerator * t, this.denominator) : new e(this.numerator * t.numerator, this.denominator * t.denominator);
		}
		divide(t) {
			return typeof t == "number" ? new e(this.numerator, this.denominator * t) : new e(this.numerator * t.denominator, this.denominator * t.numerator);
		}
		lessThan(e) {
			return this.numerator * e.denominator < e.numerator * this.denominator;
		}
		lessOrEqual(e) {
			return this.numerator * e.denominator <= e.numerator * this.denominator;
		}
		greaterThan(e) {
			return this.numerator * e.denominator > e.numerator * this.denominator;
		}
		equals(e) {
			return this.numerator * e.denominator === e.numerator * this.denominator;
		}
		static fromNumber(t) {
			let n = 1e6;
			return new e(Math.round(t * n), n);
		}
		static {
			this.ZERO = new e(0);
		}
		static {
			this.ONE = new e(1);
		}
	}, s = /* @__PURE__ */ function(e) {
		return e.DEFAULT = "default", e.PRESERVE = "preserve", e;
	}({}), c = class {
		constructor(e) {
			this._doc = null, this._id = null, this._begin = null, this._end = null, this._styles = /* @__PURE__ */ new Map(), this._animation = [], this._space = null, this._lang = null, this._firstChild = null, this._lastChild = null, this._nextSibling = null, this._previousSibling = null, this._parent = null, this._doc = e ?? null;
		}
		setDoc(e) {
			this._doc = e;
		}
		getDoc() {
			return this._doc;
		}
		setId(e) {
			this._id = e;
		}
		getId() {
			return this._id;
		}
		setBegin(e) {
			this._begin = e;
		}
		getBegin() {
			return this._begin;
		}
		setEnd(e) {
			this._end = e;
		}
		getEnd() {
			return this._end;
		}
		setStyle(e, t) {
			this._styles.set(e, t);
		}
		getStyle(e) {
			return this._styles.get(e);
		}
		iterStyles() {
			return this._styles.keys();
		}
		setSpace(e) {
			this._space = e;
		}
		getSpace() {
			return this._space;
		}
		setLang(e) {
			this._lang = e;
		}
		getLang() {
			return this._lang;
		}
		addAnimationStep(e) {
			this._animation.push(e);
		}
		iterAnimationSteps() {
			return this._animation;
		}
		pushChild(e) {
			e._parent = this, e._nextSibling = null, e._previousSibling = this._lastChild, this._lastChild !== null && (this._lastChild._nextSibling = e), this._lastChild = e, this._firstChild === null && (this._firstChild = e);
		}
		getFirstChild() {
			return this._firstChild;
		}
		getLastChild() {
			return this._lastChild;
		}
		getNextSibling() {
			return this._nextSibling;
		}
		getPreviousSibling() {
			return this._previousSibling;
		}
		getParent() {
			return this._parent;
		}
		*iterChildren() {
			let e = this._firstChild;
			for (; e !== null;) yield e, e = e._nextSibling;
		}
		*dfsIterator() {
			yield this;
			for (let e of this.iterChildren()) yield* e.dfsIterator();
		}
	}, l = class extends c {}, u = class extends c {}, d = class extends c {
		constructor(...e) {
			super(...e), this._region = null;
		}
		setRegion(e) {
			this._region = e;
		}
		getRegion() {
			return this._region;
		}
	}, f = class extends c {}, p = class extends c {
		constructor(e) {
			super(e);
		}
	}, m = class extends c {
		constructor(e, t) {
			super(e), this._text = t;
		}
		getText() {
			return this._text;
		}
		setText(e) {
			this._text = e;
		}
	}, h = class extends c {
		constructor(e, t) {
			super(t), this._id = e;
		}
	}, g = class {
		constructor() {
			this._lang = "", this._cellResolution = {
				rows: 15,
				columns: 32
			}, this._pxResolution = null, this._activeArea = null, this._displayAspectRatio = null;
		}
		setLang(e) {
			this._lang = e;
		}
		getLang() {
			return this._lang;
		}
		setCellResolution(e) {
			e !== null && (this._cellResolution = e);
		}
		getCellResolution() {
			return this._cellResolution;
		}
		setPxResolution(e) {
			this._pxResolution = e;
		}
		getPxResolution() {
			return this._pxResolution;
		}
		setActiveArea(e) {
			this._activeArea = e;
		}
		getActiveArea() {
			return this._activeArea;
		}
		setDisplayAspectRatio(e) {
			this._displayAspectRatio = e;
		}
		getDisplayAspectRatio() {
			return this._displayAspectRatio;
		}
	}, _ = class extends g {
		constructor(...e) {
			super(...e), this._body = null, this._regions = /* @__PURE__ */ new Map(), this._contentProfiles = null, this._initialValues = /* @__PURE__ */ new Map();
		}
		setBody(e) {
			this._body = e;
		}
		getBody() {
			return this._body;
		}
		setInitialValue(e, t) {
			this._initialValues.set(e, t);
		}
		getInitialValue(e) {
			return this._initialValues.get(e);
		}
		*iterInitialValues() {
			yield* this._initialValues.entries();
		}
		putRegion(e) {
			let t = e.getId();
			t !== null && this._regions.set(t, e);
		}
		getRegion(e) {
			return this._regions.get(e);
		}
		*iterRegions() {
			yield* this._regions.values();
		}
		setContentProfiles(e) {
			this._contentProfiles = e;
		}
		getContentProfiles() {
			return this._contentProfiles;
		}
	};
})), y = /* @__PURE__ */ r({
	DirectionType: () => ie,
	DisplayAlignType: () => O,
	DisplayType: () => ee,
	FillLineGapType: () => fe,
	FontStyleType: () => E,
	FontVariantType: () => ae,
	FontWeightType: () => T,
	LengthUnits: () => C,
	MultiRowAlignType: () => de,
	NamedColors: () => w,
	OverflowType: () => j,
	RubyAlignType: () => ue,
	RubyPositionType: () => le,
	RubyType: () => M,
	ShowBackgroundType: () => ne,
	StyleProperties: () => P,
	StylePropertyKey: () => N,
	TextAlignType: () => D,
	TextCombineType: () => ce,
	TextEmphasisColor: () => se,
	TextEmphasisStyle: () => oe,
	UnicodeBidiType: () => re,
	VisibilityType: () => A,
	WrapOptionType: () => te,
	WritingModeType: () => k,
	makeColor: () => x,
	makeLengthType: () => b,
	makeTextDecoration: () => S
});
function b(e, t) {
	return {
		value: e,
		units: t
	};
}
function x(e, t, n, r = 255) {
	return {
		r: e,
		g: t,
		b: n,
		a: r
	};
}
function S(e = !1, t = !1, n = !1) {
	return {
		underline: e,
		overline: t,
		lineThrough: n
	};
}
var C, w, T, E, D, O, k, ee, A, j, te, ne, re, ie, ae, oe, se, ce, M, le, ue, de, fe, N, P, F = n((() => {
	C = /* @__PURE__ */ function(e) {
		return e.em = "em", e.pct = "%", e.rh = "rh", e.rw = "rw", e.c = "c", e.px = "px", e;
	}({}), w = {
		white: x(255, 255, 255, 255),
		silver: x(192, 192, 192, 255),
		gray: x(128, 128, 128, 255),
		black: x(0, 0, 0, 255),
		maroon: x(128, 0, 0, 255),
		red: x(255, 0, 0, 255),
		fuchsia: x(255, 0, 255, 255),
		purple: x(128, 0, 128, 255),
		lime: x(0, 255, 0, 255),
		green: x(0, 128, 0, 255),
		olive: x(128, 128, 0, 255),
		yellow: x(255, 255, 0, 255),
		navy: x(0, 0, 128, 255),
		blue: x(0, 0, 255, 255),
		teal: x(0, 128, 128, 255),
		aqua: x(0, 255, 255, 255),
		cyan: x(0, 255, 255, 255),
		magenta: x(255, 0, 255, 255),
		transparent: x(0, 0, 0, 0)
	}, T = /* @__PURE__ */ function(e) {
		return e.normal = "normal", e.bold = "bold", e;
	}({}), E = /* @__PURE__ */ function(e) {
		return e.normal = "normal", e.italic = "italic", e.oblique = "oblique", e;
	}({}), D = /* @__PURE__ */ function(e) {
		return e.left = "left", e.center = "center", e.right = "right", e.start = "start", e.end = "end", e.justify = "justify", e;
	}({}), O = /* @__PURE__ */ function(e) {
		return e.before = "before", e.center = "center", e.after = "after", e;
	}({}), k = /* @__PURE__ */ function(e) {
		return e.lrtb = "lrtb", e.rltb = "rltb", e.tbrl = "tbrl", e.tblr = "tblr", e;
	}({}), ee = /* @__PURE__ */ function(e) {
		return e.none = "none", e.auto = "auto", e;
	}({}), A = /* @__PURE__ */ function(e) {
		return e.hidden = "hidden", e.visible = "visible", e;
	}({}), j = /* @__PURE__ */ function(e) {
		return e.hidden = "hidden", e.visible = "visible", e;
	}({}), te = /* @__PURE__ */ function(e) {
		return e.noWrap = "noWrap", e.wrap = "wrap", e;
	}({}), ne = /* @__PURE__ */ function(e) {
		return e.always = "always", e.whenActive = "whenActive", e;
	}({}), re = /* @__PURE__ */ function(e) {
		return e.normal = "normal", e.embed = "embed", e.bidiOverride = "bidiOverride", e;
	}({}), ie = /* @__PURE__ */ function(e) {
		return e.ltr = "ltr", e.rtl = "rtl", e;
	}({}), ae = /* @__PURE__ */ function(e) {
		return e.normal = "normal", e.superscript = "super", e.subscript = "sub", e;
	}({}), oe = /* @__PURE__ */ function(e) {
		return e.none = "none", e.dot = "dot", e.circle = "circle", e.triangle = "triangle", e.sesame = "sesame", e.auto = "auto", e;
	}({}), se = /* @__PURE__ */ function(e) {
		return e.current = "current", e;
	}({}), ce = /* @__PURE__ */ function(e) {
		return e.none = "none", e.all = "all", e;
	}({}), M = /* @__PURE__ */ function(e) {
		return e.none = "none", e.container = "container", e.baseContainer = "baseContainer", e.base = "base", e.textContainer = "textContainer", e.text = "text", e.delimiter = "delimiter", e;
	}({}), le = /* @__PURE__ */ function(e) {
		return e.before = "before", e.after = "after", e.outside = "outside", e;
	}({}), ue = /* @__PURE__ */ function(e) {
		return e.start = "start", e.center = "center", e.spaceAround = "spaceAround", e.spaceBetween = "spaceBetween", e;
	}({}), de = /* @__PURE__ */ function(e) {
		return e.auto = "auto", e.start = "start", e.center = "center", e.end = "end", e;
	}({}), fe = /* @__PURE__ */ function(e) {
		return e.true = "true", e.false = "false", e;
	}({}), N = {
		BackgroundColor: "BackgroundColor",
		Color: "Color",
		Direction: "Direction",
		Display: "Display",
		DisplayAlign: "DisplayAlign",
		Extent: "Extent",
		FillLineGap: "FillLineGap",
		FontFamily: "FontFamily",
		FontSize: "FontSize",
		FontStyle: "FontStyle",
		FontVariant: "FontVariant",
		FontWeight: "FontWeight",
		LineHeight: "LineHeight",
		LinePadding: "LinePadding",
		LuminanceGain: "LuminanceGain",
		MultiRowAlign: "MultiRowAlign",
		Opacity: "Opacity",
		Origin: "Origin",
		Overflow: "Overflow",
		Padding: "Padding",
		Position: "Position",
		Ruby: "Ruby",
		RubyAlign: "RubyAlign",
		RubyPosition: "RubyPosition",
		RubyReserve: "RubyReserve",
		Shear: "Shear",
		ShowBackground: "ShowBackground",
		TextAlign: "TextAlign",
		TextCombine: "TextCombine",
		TextDecoration: "TextDecoration",
		TextEmphasis: "TextEmphasis",
		TextOutline: "TextOutline",
		TextShadow: "TextShadow",
		UnicodeBidi: "UnicodeBidi",
		Visibility: "Visibility",
		WrapOption: "WrapOption",
		WritingMode: "WritingMode"
	}, (function(e) {
		let t = e.BackgroundColor = N.BackgroundColor, n = e.Color = N.Color, r = e.Direction = N.Direction, i = e.Display = N.Display, a = e.DisplayAlign = N.DisplayAlign;
		e.Extent = N.Extent;
		let o = e.FillLineGap = N.FillLineGap, s = e.FontFamily = N.FontFamily, c = e.FontSize = N.FontSize, l = e.FontStyle = N.FontStyle, u = e.FontVariant = N.FontVariant, d = e.FontWeight = N.FontWeight, f = e.LineHeight = N.LineHeight, p = e.LinePadding = N.LinePadding, m = e.LuminanceGain = N.LuminanceGain, h = e.MultiRowAlign = N.MultiRowAlign, g = e.Opacity = N.Opacity;
		e.Origin = N.Origin;
		let _ = e.Overflow = N.Overflow;
		e.Padding = N.Padding, e.Position = N.Position, e.Ruby = N.Ruby;
		let v = e.RubyAlign = N.RubyAlign, y = e.RubyPosition = N.RubyPosition;
		e.RubyReserve = N.RubyReserve;
		let b = e.Shear = N.Shear, x = e.ShowBackground = N.ShowBackground, S = e.TextAlign = N.TextAlign, C = e.TextCombine = N.TextCombine, oe = e.TextDecoration = N.TextDecoration, se = e.TextEmphasis = N.TextEmphasis, M = e.TextOutline = N.TextOutline, P = e.TextShadow = N.TextShadow, F = e.UnicodeBidi = N.UnicodeBidi, pe = e.Visibility = N.Visibility, me = e.WrapOption = N.WrapOption, he = e.WritingMode = N.WritingMode;
		e.INITIAL_VALUES = {
			[t]: {
				r: 0,
				g: 0,
				b: 0,
				a: 0
			},
			[n]: w.white,
			[r]: ie.ltr,
			[i]: ee.auto,
			[a]: O.before,
			[o]: fe.false,
			[l]: E.normal,
			[u]: ae.normal,
			[d]: T.normal,
			[f]: "normal",
			[m]: 1,
			[h]: de.auto,
			[g]: 1,
			[v]: ue.center,
			[y]: le.outside,
			[b]: 0,
			[x]: ne.always,
			[S]: D.start,
			[C]: ce.none,
			[oe]: {
				underline: !1,
				overline: !1,
				lineThrough: !1
			},
			[se]: "none",
			[M]: "none",
			[P]: "none",
			[F]: re.normal,
			[pe]: A.visible,
			[_]: j.hidden,
			[me]: te.wrap,
			[he]: k.lrtb
		}, e.INHERITED = new Set([
			n,
			r,
			s,
			c,
			l,
			u,
			d,
			f,
			S,
			oe,
			M,
			P,
			F,
			pe,
			me,
			he,
			h,
			v,
			y,
			b,
			m,
			p,
			o
		]);
	})(P ||= {});
}));
//#endregion
//#region src/timeCode.ts
function pe(e) {
	let t = Math.floor(e);
	return Math.abs(e - t - .5) < 1e-9 ? t % 2 == 0 ? t : t + 1 : Math.round(e);
}
var me, he, ge, _e, ve, ye, be, xe, Se, Ce, we = n((() => {
	v(), me = new o(24e3, 1001), he = new o(24, 1), ge = new o(25, 1), _e = new o(3e4, 1001), ve = new o(30, 1), ye = new o(50, 1), be = new o(6e4, 1001), xe = new o(60, 1), Se = class e {
		constructor(e, t, n, r) {
			this.separator = ".", this.hours = e, this.minutes = t, this.seconds = n, this.milliseconds = r;
		}
		static fromSeconds(t) {
			let n = pe(typeof t == "number" ? t * 1e3 : t.toNumber() * 1e3), r = n % 1e3, i = Math.floor(n / 1e3), a = i % 60, o = Math.floor(i / 60), s = o % 60;
			return new e(Math.floor(o / 60), s, a, r);
		}
		static parse(t) {
			let n = t.match(/^(\d+):(\d{2}):(\d{2})[.,](\d{3})$/);
			return n ? new e(parseInt(n[1]), parseInt(n[2]), parseInt(n[3]), parseInt(n[4])) : null;
		}
		setSeparator(e) {
			this.separator = e;
		}
		toSeconds() {
			return this.hours * 3600 + this.minutes * 60 + this.seconds + this.milliseconds / 1e3;
		}
		toFraction() {
			return new o(this.hours * 36e5 + this.minutes * 6e4 + this.seconds * 1e3 + this.milliseconds, 1e3);
		}
		toString() {
			let e = String(this.hours).padStart(2, "0"), t = String(this.minutes).padStart(2, "0"), n = String(this.seconds).padStart(2, "0"), r = String(this.milliseconds).padStart(3, "0");
			return `${e}:${t}:${n}${this.separator}${r}`;
		}
	}, Ce = class e {
		constructor(e, t, n, r, i, a = !1) {
			this.hours = e, this.minutes = t, this.seconds = n, this.frames = r, this.frameRate = i, this.dropFrame = a;
		}
		static parse(t, n) {
			let r = !1, i = t.match(/^(\d+)[;:](\d{2})[;:](\d{2})[;:](\d{2})$/);
			return i ||= t.match(/^(\d+):(\d{2}):(\d{2})\.(\d{2})$/), i ? (r = t.includes(";"), new e(parseInt(i[1]), parseInt(i[2]), parseInt(i[3]), parseInt(i[4]), n, r)) : null;
		}
		static fromFrames(t, n, r = !1) {
			let i = Math.ceil(n.toNumber()), a = t;
			if (r) {
				let e = 60 * n.toNumber(), t = Math.round(10 * e), r = Math.round(60 * (i - n.toNumber())), o = Math.floor(a / t), s = Math.round(a % t), c = r * 9 * o, l = Math.floor((s - r) / Math.round(e));
				l < 0 && (l = 0), a += c + l * r;
			}
			return new e(Math.floor(a / (3600 * i)), Math.floor(a / (60 * i)) % 60, Math.floor(a / i) % 60, Math.ceil(a % i), n, r);
		}
		toFrames() {
			let e = Math.round(this.frameRate.toNumber());
			if (this.dropFrame) {
				let t = Math.round(this.frameRate.toNumber() * .066666), n = 60 * this.hours + this.minutes;
				return e * 3600 * this.hours + e * 60 * this.minutes + e * this.seconds + this.frames - t * (n - Math.floor(n / 10));
			} else return e * 3600 * this.hours + e * 60 * this.minutes + e * this.seconds + this.frames;
		}
		toSeconds() {
			return this.toTemporalOffset();
		}
		toTemporalOffset() {
			let e = this.toFrames();
			return this.dropFrame ? new o(e, 1).divide(this.frameRate) : new o(e, Math.ceil(this.frameRate.toNumber()));
		}
		static fromSeconds(t, n, r = !1) {
			let i = Math.round(t.multiply(n).toNumber());
			return e.fromFrames(i, n, r);
		}
		addFrames(t) {
			return e.fromFrames(this.toFrames() + t, this.frameRate, this.dropFrame);
		}
		getHours() {
			return this.hours;
		}
		getMinutes() {
			return this.minutes;
		}
		getSeconds() {
			return this.seconds;
		}
		getFrames() {
			return this.frames;
		}
		getFrameRate() {
			return this.frameRate;
		}
		isDropFrame() {
			return this.dropFrame;
		}
		toString() {
			let e = String(this.hours).padStart(2, "0"), t = String(this.minutes).padStart(2, "0"), n = String(this.seconds).padStart(2, "0"), r = String(this.frames).padStart(2, "0");
			return `${e}:${t}:${n}${this.dropFrame ? ";" : ":"}${r}`;
		}
	};
})), I, Te, Ee = n((() => {
	F(), w.white, w.green, w.blue, w.cyan, w.red, w.yellow, w.magenta, w.white, I = /* @__PURE__ */ function(e) {
		return e[e.CHANNEL_1 = 1] = "CHANNEL_1", e[e.CHANNEL_2 = 2] = "CHANNEL_2", e;
	}({}), Te = {
		32: " ",
		33: "!",
		34: "\"",
		35: "#",
		36: "$",
		37: "%",
		38: "&",
		39: "'",
		40: "(",
		41: ")",
		42: "á",
		43: "+",
		44: ",",
		45: "-",
		46: ".",
		47: "/",
		48: "0",
		49: "1",
		50: "2",
		51: "3",
		52: "4",
		53: "5",
		54: "6",
		55: "7",
		56: "8",
		57: "9",
		58: ":",
		59: ";",
		60: "<",
		61: "=",
		62: ">",
		63: "?",
		64: "@",
		65: "A",
		66: "B",
		67: "C",
		68: "D",
		69: "E",
		70: "F",
		71: "G",
		72: "H",
		73: "I",
		74: "J",
		75: "K",
		76: "L",
		77: "M",
		78: "N",
		79: "O",
		80: "P",
		81: "Q",
		82: "R",
		83: "S",
		84: "T",
		85: "U",
		86: "V",
		87: "W",
		88: "X",
		89: "Y",
		90: "Z",
		91: "[",
		92: "é",
		93: "]",
		94: "í",
		95: "ó",
		96: "ú",
		97: "a",
		98: "b",
		99: "c",
		100: "d",
		101: "e",
		102: "f",
		103: "g",
		104: "h",
		105: "i",
		106: "j",
		107: "k",
		108: "l",
		109: "m",
		110: "n",
		111: "o",
		112: "p",
		113: "q",
		114: "r",
		115: "s",
		116: "t",
		117: "u",
		118: "v",
		119: "w",
		120: "x",
		121: "y",
		122: "z",
		123: "ç",
		124: "÷",
		125: "Ñ",
		126: "ñ",
		127: "▒"
	};
}));
//#endregion
//#region src/scc/codes/controlCodes.ts
function L(e, t, n, r) {
	Oe.set(e << 8 | t, {
		code: n,
		channel: r
	});
}
function De(e, t) {
	return Oe.get(e << 8 | t) ?? null;
}
var R, Oe, ke = n((() => {
	Ee(), R = /* @__PURE__ */ function(e) {
		return e.RCL = "RCL", e.RDC = "RDC", e.RU2 = "RU2", e.RU3 = "RU3", e.RU4 = "RU4", e.EOC = "EOC", e.EDM = "EDM", e.ENM = "ENM", e.CR = "CR", e.DER = "DER", e.BS = "BS", e.TO1 = "TO1", e.TO2 = "TO2", e.TO3 = "TO3", e.TR = "TR", e.RTD = "RTD", e.FON = "FON", e.AOF = "AOF", e.AON = "AON", e;
	}({}), Oe = /* @__PURE__ */ new Map(), L(20, 32, R.RCL, I.CHANNEL_1), L(20, 37, R.RU2, I.CHANNEL_1), L(20, 38, R.RU3, I.CHANNEL_1), L(20, 39, R.RU4, I.CHANNEL_1), L(20, 41, R.RDC, I.CHANNEL_1), L(20, 42, R.TR, I.CHANNEL_1), L(20, 43, R.RTD, I.CHANNEL_1), L(20, 44, R.EDM, I.CHANNEL_1), L(20, 45, R.CR, I.CHANNEL_1), L(20, 46, R.ENM, I.CHANNEL_1), L(20, 47, R.EOC, I.CHANNEL_1), L(20, 33, R.BS, I.CHANNEL_1), L(20, 35, R.DER, I.CHANNEL_1), L(20, 36, R.RU2, I.CHANNEL_1), L(20, 40, R.FON, I.CHANNEL_1), L(23, 33, R.TO1, I.CHANNEL_1), L(23, 34, R.TO2, I.CHANNEL_1), L(23, 35, R.TO3, I.CHANNEL_1), L(20, 34, R.AOF, I.CHANNEL_1), L(20, 48, R.AON, I.CHANNEL_1), L(28, 32, R.RCL, I.CHANNEL_2), L(28, 37, R.RU2, I.CHANNEL_2), L(28, 38, R.RU3, I.CHANNEL_2), L(28, 39, R.RU4, I.CHANNEL_2), L(28, 41, R.RDC, I.CHANNEL_2), L(28, 42, R.TR, I.CHANNEL_2), L(28, 43, R.RTD, I.CHANNEL_2), L(28, 44, R.EDM, I.CHANNEL_2), L(28, 45, R.CR, I.CHANNEL_2), L(28, 46, R.ENM, I.CHANNEL_2), L(28, 47, R.EOC, I.CHANNEL_2), L(28, 33, R.BS, I.CHANNEL_2), L(28, 35, R.DER, I.CHANNEL_2), L(28, 40, R.FON, I.CHANNEL_2), L(31, 33, R.TO1, I.CHANNEL_2), L(31, 34, R.TO2, I.CHANNEL_2), L(31, 35, R.TO3, I.CHANNEL_2), L(21, 32, R.RCL, I.CHANNEL_1), L(21, 37, R.RU2, I.CHANNEL_1), L(21, 38, R.RU3, I.CHANNEL_1), L(21, 39, R.RU4, I.CHANNEL_1), L(21, 41, R.RDC, I.CHANNEL_1), L(21, 44, R.EDM, I.CHANNEL_1), L(21, 45, R.CR, I.CHANNEL_1), L(21, 46, R.ENM, I.CHANNEL_1), L(21, 47, R.EOC, I.CHANNEL_1), L(21, 33, R.BS, I.CHANNEL_1), L(21, 35, R.DER, I.CHANNEL_1), L(24, 33, R.TO1, I.CHANNEL_1), L(24, 34, R.TO2, I.CHANNEL_1), L(24, 35, R.TO3, I.CHANNEL_1), L(29, 32, R.RCL, I.CHANNEL_2), L(29, 37, R.RU2, I.CHANNEL_2), L(29, 38, R.RU3, I.CHANNEL_2), L(29, 39, R.RU4, I.CHANNEL_2), L(29, 41, R.RDC, I.CHANNEL_2), L(29, 44, R.EDM, I.CHANNEL_2), L(29, 45, R.CR, I.CHANNEL_2), L(29, 46, R.ENM, I.CHANNEL_2), L(29, 47, R.EOC, I.CHANNEL_2), L(29, 33, R.BS, I.CHANNEL_2), L(29, 35, R.DER, I.CHANNEL_2), L(30, 33, R.TO1, I.CHANNEL_2), L(30, 34, R.TO2, I.CHANNEL_2), L(30, 35, R.TO3, I.CHANNEL_2);
}));
//#endregion
//#region src/scc/codes/preambleAddressCodes.ts
function Ae(e, t) {
	if (e < 16 || e > 31 || t < 64 || t > 127) return null;
	let n = t & 127;
	if (n < 64 || n > 127) return null;
	let r = e & 8 ? I.CHANNEL_2 : I.CHANNEL_1, i = je[`${e & 7}_${t & 32 ? 1 : 0}`];
	if (i === void 0) return null;
	let a = t & 31, o = 0, s = null, c = !1, l = !1;
	if (l = (t & 1) != 0, a >= 16) o = ((a & 14) >> 1) * 4, s = null;
	else {
		let e = (a & 14) >> 1;
		e === 7 ? (c = !0, s = w.white) : s = Me[e] ?? w.white;
	}
	return {
		row: i,
		color: s,
		indent: o,
		italic: c,
		underline: l,
		channel: r
	};
}
var je, Me, Ne = n((() => {
	Ee(), F(), je = {
		"1_0": 1,
		"1_1": 2,
		"2_0": 3,
		"2_1": 4,
		"5_0": 5,
		"5_1": 6,
		"6_0": 7,
		"6_1": 8,
		"7_0": 9,
		"7_1": 10,
		"0_0": 11,
		"3_0": 12,
		"3_1": 13,
		"4_0": 14,
		"4_1": 15
	}, Me = [
		w.white,
		w.green,
		w.blue,
		w.cyan,
		w.red,
		w.yellow,
		w.magenta,
		w.white
	];
}));
//#endregion
//#region src/scc/codes/midRowCodes.ts
function Pe(e, t) {
	let n = e === 17, r = e === 25;
	if (!n && !r || t < 32 || t > 47) return null;
	let i = r ? I.CHANNEL_2 : I.CHANNEL_1, a = (t & 14) >> 1, o = (t & 1) != 0, s = Fe[a] ?? null, c = null, l = null;
	return a === 7 && (c = E.italic, s = null), o && (l = S(!0)), {
		color: s,
		fontStyle: c,
		textDecoration: l,
		channel: i
	};
}
var Fe, Ie = n((() => {
	Ee(), F(), Fe = [
		w.white,
		w.green,
		w.blue,
		w.cyan,
		w.red,
		w.yellow,
		w.magenta,
		null
	];
}));
//#endregion
//#region src/scc/codes/attributeCodes.ts
function Le(e, t, n, r, i, a) {
	ze.set(e << 8 | t, {
		isBackground: n,
		color: r,
		textDecoration: S(i),
		channel: a
	});
}
function Re(e, t) {
	return ze.get(e << 8 | t) ?? null;
}
var ze, Be, Ve = n((() => {
	Ee(), F(), ze = /* @__PURE__ */ new Map(), Be = [
		w.white,
		x(255, 255, 255, 136),
		x(0, 255, 0, 255),
		x(0, 255, 0, 136),
		w.blue,
		x(0, 0, 255, 136),
		w.cyan,
		x(0, 255, 255, 136),
		w.red,
		x(255, 0, 0, 136),
		w.yellow,
		x(255, 255, 0, 136),
		w.magenta,
		x(255, 0, 255, 136),
		w.black,
		x(0, 0, 0, 136)
	];
	for (let e = 0; e < Be.length; e++) {
		let t = 32 + e;
		Le(16, t, !0, Be[e], !1, I.CHANNEL_1), Le(24, t, !0, Be[e], !1, I.CHANNEL_2);
	}
	Le(23, 45, !0, w.transparent, !1, I.CHANNEL_1), Le(31, 45, !0, w.transparent, !1, I.CHANNEL_2), Le(23, 46, !1, w.black, !1, I.CHANNEL_1), Le(31, 46, !1, w.black, !1, I.CHANNEL_2), Le(23, 47, !1, w.black, !0, I.CHANNEL_1), Le(31, 47, !1, w.black, !0, I.CHANNEL_2);
}));
//#endregion
//#region src/scc/codes/specialCharacters.ts
function He(e, t, n) {
	We.set(e << 8 | t, n);
}
function Ue(e, t) {
	return We.get(e << 8 | t) ?? null;
}
var We, Ge = n((() => {
	We = /* @__PURE__ */ new Map();
	for (let [e, t] of [
		[48, "®"],
		[49, "°"],
		[50, "½"],
		[51, "¿"],
		[52, "™"],
		[53, "¢"],
		[54, "£"],
		[55, "♪"],
		[56, "à"],
		[57, "\xA0"],
		[58, "è"],
		[59, "â"],
		[60, "ê"],
		[61, "î"],
		[62, "ô"],
		[63, "û"]
	]) He(17, e, t), He(25, e, t);
}));
//#endregion
//#region src/scc/codes/extendedCharacters.ts
function Ke(e, t, n) {
	Je.set(e << 8 | t, n);
}
function qe(e, t) {
	return Je.get(e << 8 | t) ?? null;
}
var Je, Ye, Xe, Ze, Qe, $e, et = n((() => {
	Je = /* @__PURE__ */ new Map(), Ye = [
		[32, "Á"],
		[33, "É"],
		[34, "Ó"],
		[35, "Ú"],
		[36, "Ü"],
		[37, "ü"],
		[38, "‘"],
		[39, "¡"],
		[40, "*"],
		[41, "'"],
		[42, "━"],
		[43, "©"],
		[44, "℠"],
		[45, "•"],
		[46, "“"],
		[47, "”"]
	], Xe = [
		[48, "À"],
		[49, "Â"],
		[50, "Ç"],
		[51, "È"],
		[52, "Ê"],
		[53, "Ë"],
		[54, "ë"],
		[55, "Î"],
		[56, "Ï"],
		[57, "ï"],
		[58, "Ô"],
		[59, "Ù"],
		[60, "ù"],
		[61, "Û"],
		[62, "«"],
		[63, "»"]
	];
	for (let [e, t] of [...Ye, ...Xe]) Ke(18, e, t), Ke(26, e, t);
	Ze = [
		[32, "Ã"],
		[33, "ã"],
		[34, "Í"],
		[35, "Ì"],
		[36, "ì"],
		[37, "Ò"],
		[38, "ò"],
		[39, "Õ"],
		[40, "õ"],
		[41, "{"],
		[42, "}"],
		[43, "\\"],
		[44, "ʌ"],
		[45, "_"],
		[46, "|"],
		[47, "~"]
	], Qe = [
		[48, "Ä"],
		[49, "ä"],
		[50, "Ö"],
		[51, "ö"],
		[52, "ß"],
		[53, "¥"],
		[54, "¤"],
		[55, "┃"]
	], $e = [
		[56, "Å"],
		[57, "å"],
		[58, "Ø"],
		[59, "ø"],
		[60, "┏"],
		[61, "┓"],
		[62, "┗"],
		[63, "┛"]
	];
	for (let [e, t] of [
		...Ze,
		...Qe,
		...$e
	]) Ke(19, e, t), Ke(27, e, t);
})), tt, nt, rt = n((() => {
	Ee(), ke(), Ne(), Ie(), Ve(), Ge(), et(), tt = 127, nt = class e {
		constructor(e, t) {
			this.byte1 = e & tt, this.byte2 = t & tt, this.value = this.byte1 << 8 | this.byte2;
		}
		static fromStr(t) {
			if (t = t.trim(), t.length !== 4) return null;
			let n = parseInt(t.slice(0, 2), 16), r = parseInt(t.slice(2, 4), 16);
			return isNaN(n) || isNaN(r) ? null : new e(n, r);
		}
		static fromBytes(t, n) {
			return new e(t, n);
		}
		isCode() {
			return this.byte1 >= 16 && this.byte1 <= 31;
		}
		isNull() {
			return this.byte1 === 0 && this.byte2 === 0;
		}
		findCode() {
			let e = De(this.byte1, this.byte2);
			if (e) return {
				type: "control",
				value: e
			};
			let t = Ae(this.byte1, this.byte2);
			if (t) return {
				type: "pac",
				value: t
			};
			let n = Pe(this.byte1, this.byte2);
			if (n) return {
				type: "midrow",
				value: n
			};
			let r = Re(this.byte1, this.byte2);
			if (r) return {
				type: "attribute",
				value: r
			};
			let i = Ue(this.byte1, this.byte2);
			if (i !== null) return {
				type: "special",
				value: i
			};
			let a = qe(this.byte1, this.byte2);
			return a === null ? null : {
				type: "extended",
				value: a
			};
		}
		toText() {
			let e = "";
			return this.byte1 > 0 && this.byte1 !== 13 && (e += Te[this.byte1] ?? String.fromCharCode(this.byte1)), this.byte2 > 0 && this.byte2 !== 13 && (e += Te[this.byte2] ?? String.fromCharCode(this.byte2)), e;
		}
	};
})), z, it = n((() => {
	z = /* @__PURE__ */ function(e) {
		return e.Unknown = "Unknown", e.PopOn = "PopOn", e.RollUp = "RollUp", e.PaintOn = "PaintOn", e;
	}({}), (function(e) {
		function t() {
			return z.Unknown;
		}
		e.default_ = t;
	})(z ||= {});
})), at, ot, st, ct = n((() => {
	rt(), we(), it(), ke(), at = /^(\d{2}):(\d{2}):(\d{2}):(\d{2})/, ot = /^(\d{2}):(\d{2}):(\d{2});(\d{2})/, st = class e {
		constructor(e, t) {
			this.timeCode = e, this.words = t;
		}
		static fromStr(t, n = _e) {
			if (t = t.trim(), !t) return null;
			let r = t.match(at), i = !1;
			if (r || (r = t.match(ot), r && (i = !0)), !r) return null;
			let a = new Ce(parseInt(r[1]), parseInt(r[2]), parseInt(r[3]), parseInt(r[4]), n, i), o = t.indexOf("	");
			if (o === -1) return new e(a, []);
			let s = t.slice(o + 1).trim().split(/\s+/), c = [];
			for (let e of s) {
				if (!e || e.length !== 4) continue;
				let t = nt.fromStr(e);
				t && c.push(t);
			}
			return new e(a, c);
		}
		getStyle() {
			for (let e of this.words) {
				if (!e.isCode()) continue;
				let t = e.findCode();
				if (t?.type === "control") {
					let e = t.value.code;
					if (e === R.RU2 || e === R.RU3 || e === R.RU4) return z.RollUp;
					if (e === R.RDC) return z.PaintOn;
					if (e === R.RCL) return z.PopOn;
				}
			}
			return z.Unknown;
		}
		process(e) {
			let t = this.timeCode;
			for (let n of this.words) {
				if (n.isNull()) {
					t = t.addFrames(1);
					continue;
				}
				if (n.isCode()) {
					let r = n.findCode();
					if (r) {
						if (e.previousWord && e.previousWord.value === n.value && e.previousWordType === r.type) {
							t = t.addFrames(1), e.previousWord = null;
							continue;
						}
						switch (r.type) {
							case "control":
								e.processControlCode(r.value.code, t);
								break;
							case "pac":
								e.processPreambleAddressCode(r.value, t);
								break;
							case "midrow":
								e.processMidRowCode(r.value, t);
								break;
							case "attribute":
								e.processAttributeCode(r.value, t);
								break;
							case "special":
								e.processText(r.value, t);
								break;
							case "extended":
								e.backspace(t), e.processText(r.value, t);
								break;
						}
						e.previousWord = n, e.previousWordType = r.type;
					} else e.previousWord = n, e.previousWordType = "unknown";
				} else {
					e.previousWord = null, e.previousWordType = null;
					let r = n.toText();
					r && e.processText(r, t);
				}
				t = t.addFrames(1);
			}
		}
	};
})), lt, ut = n((() => {
	lt = class {
		constructor(e = "") {
			this._text = "", this._cursor = 0, this._begin = null, this._end = null, this._styleProperties = /* @__PURE__ */ new Map(), this._text = e, this._cursor = e.length;
		}
		getText() {
			return this._text;
		}
		isEmpty() {
			return this._text.length === 0;
		}
		getCursor() {
			return this._cursor;
		}
		getBegin() {
			return this._begin;
		}
		setBegin(e) {
			this._begin = e;
		}
		getEnd() {
			return this._end;
		}
		setEnd(e) {
			this._end = e;
		}
		addStyleProperty(e, t) {
			t !== null && this._styleProperties.set(e, t);
		}
		getStyleProperties() {
			return this._styleProperties;
		}
		append(e) {
			let t = this._text.slice(0, this._cursor), n = this._text.slice(this._cursor + e.length);
			this._text = t + e + n, this._cursor += e.length;
		}
		setCursorAt(e) {
			this._cursor = e;
		}
		backspace() {
			if (this._cursor > 0) {
				let e = this._text.slice(0, this._cursor - 1), t = this._text.slice(this._cursor);
				this._text = e + t, this._cursor--;
			}
		}
	};
})), dt, ft = n((() => {
	ut(), dt = class {
		constructor(e, t = 0) {
			this._cursor = 0, this._texts = [], this._row = e, this._indent = t, this._currentText = new lt(), this._texts.push(this._currentText);
		}
		getRow() {
			return this._row;
		}
		setRow(e) {
			this._row = e;
		}
		getIndent() {
			return this._indent;
		}
		indent(e) {
			this._indent += e, this._indent < 0 && (this._indent = 0);
		}
		getCursor() {
			return this._cursor;
		}
		setCursor(e) {
			let t = this.getLength();
			e > t && (e = t), e < 0 && (e = 0), this._cursor = e;
			let n = e;
			for (let e = 0; e < this._texts.length; e++) {
				let t = this._texts[e], r = e === this._texts.length - 1;
				if (n > t.getText().length || n === t.getText().length && !r) n -= t.getText().length;
				else {
					this._currentText = t, t.setCursorAt(n);
					return;
				}
			}
		}
		getCurrentText() {
			return this._currentText;
		}
		getTexts() {
			return this._texts;
		}
		_appendText(e) {
			this._currentText.append(e), this._cursor < 0 && (this._cursor = 0), this.setCursor(this._cursor + e.length);
		}
		addText(e) {
			if (typeof e == "string") {
				let t = e;
				for (; this._currentText !== this._texts[this._texts.length - 1] && t.length > 0;) {
					let e = this._currentText.getText().length - this._currentText.getCursor(), n = t.slice(0, e);
					this._appendText(n), t = t.slice(e);
				}
				t.length > 0 && this._appendText(t);
			} else this._texts.push(e), this._currentText = e, this._cursor = this.getLength();
		}
		getLength() {
			return this._texts.reduce((e, t) => e + t.getText().length, 0);
		}
		isEmpty() {
			return this._texts.every((e) => e.isEmpty());
		}
		clear() {
			this._texts = [new lt()], this._currentText = this._texts[0], this._cursor = 0;
		}
		getLeadingSpaces() {
			let e = this._texts.find((e) => !e.isEmpty());
			if (!e) return 0;
			let t = e.getText();
			return t.length - t.trimStart().length;
		}
		getTrailingSpaces() {
			let e = this._texts.filter((e) => !e.isEmpty());
			if (e.length === 0) return 0;
			let t = e[e.length - 1].getText();
			return t.length - t.trimEnd().length;
		}
	};
}));
//#endregion
//#region src/scc/utils.ts
function pt(e, t, n = C.c) {
	return {
		x: b(e, n),
		y: b(t, n)
	};
}
function mt(e, t, n = C.c) {
	return {
		width: b(e, n),
		height: b(t, n)
	};
}
function ht(e) {
	let t = Math.floor(e);
	return Math.abs(e - t - .5) < 1e-9 ? t % 2 == 0 ? t : t + 1 : Math.round(e);
}
function gt(e, t) {
	if ("x" in e && "y" in e) return {
		x: b(ht(e.x.value / t.columns * 100), C.pct),
		y: b(ht(e.y.value / t.rows * 100), C.pct)
	};
	{
		let n = e;
		return {
			width: b(ht(n.width.value / t.columns * 100), C.pct),
			height: b(ht(n.height.value / t.rows * 100), C.pct)
		};
	}
}
var _t = n((() => {
	F();
})), vt, yt, bt, xt, St, Ct = n((() => {
	ft(), ut(), it(), _t(), F(), v(), vt = 15, yt = 32, Math.ceil(vt / .8), bt = Math.ceil(yt / .8), xt = class {
		constructor(e = 0, t = 0, n = z.Unknown) {
			this._captionId = "", this._begin = null, this._end = null, this._cursor = [0, 0], this._captionLines = /* @__PURE__ */ new Map(), this._styleProperties = /* @__PURE__ */ new Map(), this._safeAreaXOffset = e, this._safeAreaYOffset = t, this._columnOffset = e, this._rowOffset = t, this._captionStyle = n;
			let r = new dt(0, 0);
			this._captionLines.set(0, r), this._currentLine = r;
		}
		setId(e) {
			this._captionId = e;
		}
		getId() {
			return this._captionId;
		}
		setBegin(e) {
			this._begin = e ? Object.assign(Object.create(Object.getPrototypeOf(e)), e) : null;
		}
		getBegin() {
			return this._begin;
		}
		setEnd(e) {
			this._end = e ? Object.assign(Object.create(Object.getPrototypeOf(e)), e) : null;
		}
		getEnd() {
			return this._end;
		}
		getSafeAreaXOffset() {
			return this._safeAreaXOffset;
		}
		getSafeAreaYOffset() {
			return this._safeAreaYOffset;
		}
		setCaptionStyle(e) {
			this._captionStyle = e;
		}
		getCaptionStyle() {
			return this._captionStyle;
		}
		getCurrentLine() {
			return this._currentLine;
		}
		getCurrentText() {
			return this._currentLine.getCurrentText();
		}
		appendText(e) {
			this.getCurrentLine().addText(e), this._cursor = [this._cursor[0], this._cursor[1] + e.length];
		}
		setLines(e) {
			if (Array.isArray(e)) for (let t of e) this._captionLines.set(t.getRow(), t);
			else this._captionLines = new Map(e);
		}
		getStyleProperties() {
			return this._styleProperties;
		}
		addStyleProperty(e, t) {
			t !== null && this._styleProperties.set(e, t);
		}
		getStyleProperty(e) {
			return this._styleProperties.get(e);
		}
		setCursorAt(e, t) {
			let n = this._cursor[0], r = this._captionLines.get(n);
			r && r.isEmpty() && this._captionLines.delete(n), this._cursor = [e, t ?? 0], this._captionLines.has(e) || this.newCaptionLine(), this._currentLine = this._captionLines.get(e), t !== void 0 && this._updateCurrentLineCursor();
		}
		getCursor() {
			return this._cursor;
		}
		indentCursor(e) {
			this._cursor = [this._cursor[0], this._cursor[1] + e], this._currentLine.isEmpty() ? this._currentLine.indent(e) : this._updateCurrentLineCursor();
		}
		_updateCurrentLineCursor() {
			let e = this._cursor[1] - this._currentLine.getIndent();
			e < 0 && (this._currentLine.clear(), this._currentLine.indent(e)), this._currentLine.setCursor(Math.max(0, e));
		}
		getLines() {
			return this._captionLines;
		}
		isEmpty() {
			return this._getLength() === 0;
		}
		_getLength() {
			return Array.from(this._captionLines.values()).reduce((e, t) => e + t.getLength(), 0);
		}
		copyLines() {
			let e = /* @__PURE__ */ new Map();
			for (let [t, n] of this._captionLines) {
				let r = new dt(n.getRow(), n.getIndent());
				for (let e of n.getTexts()) {
					let t = new lt(e.getText());
					for (let [n, r] of e.getStyleProperties()) t.addStyleProperty(n, r);
					r.addText(t);
				}
				e.set(t, r);
			}
			return e;
		}
		newCaptionText() {
			this._currentLine.addText(new lt());
		}
		newCaptionLine() {
			let e = new dt(this._cursor[0], this._cursor[1]);
			this._captionLines.set(this._cursor[0], e), this._currentLine = e;
		}
		rollUp() {
			if (this._captionStyle !== z.RollUp) throw Error(`Cannot roll-up ${this._captionStyle}-styled caption`);
			let e = Array.from(this._captionLines.keys()).sort((e, t) => e - t), t = /* @__PURE__ */ new Map();
			for (let n of e) {
				let e = this._captionLines.get(n);
				n !== 0 && (e.setRow(n - 1), t.set(n - 1, e));
			}
			this._captionLines = t;
		}
		getOrigin() {
			if (!this.isEmpty()) {
				let e = Array.from(this._captionLines.values()).map((e) => e.getIndent()), t = Array.from(this._captionLines.values()).map((e) => e.getRow() - 1);
				return pt(Math.min(...e) + this._safeAreaXOffset, Math.min(...t) + this._safeAreaYOffset);
			}
			return pt(this._safeAreaXOffset, this._safeAreaYOffset);
		}
		getExtent() {
			if (this.isEmpty()) return mt(0, 0);
			let e = Array.from(this._captionLines.keys()), t = Math.max(...e) - Math.min(...e) + 1;
			return mt(Math.max(...Array.from(this._captionLines.values()).map((e) => e.getLength())), t);
		}
		getLastCaptionLines(e) {
			return e <= 0 ? [] : Array.from(this._captionLines.entries()).sort((e, t) => e[0] - t[0]).map(([e, t]) => t).slice(-e);
		}
		guessTextAlignment() {
			if (this.isEmpty()) return D.start;
			let e = Array.from(this._captionLines.values()).reduce((e, t) => e.getLength() >= t.getLength() ? e : t), t = (e) => bt - (e.getIndent() + e.getLength()), n = e.getIndent() + e.getLeadingSpaces(), r = t(e) + e.getTrailingSpaces(), i = Array.from(this._captionLines.values());
			return i.every((e) => e.getIndent() + e.getLeadingSpaces() - n === 0) ? D.start : i.every((e) => t(e) + e.getTrailingSpaces() - r === 0) ? D.end : i.every((e) => Math.abs(e.getIndent() + e.getLeadingSpaces() - n - (t(e) + e.getTrailingSpaces() - r)) < 2) ? D.center : D.start;
		}
		toParagraph(e) {
			let t = new d(e);
			t.setDoc(e), t.setId(this._captionId), this._begin !== null && t.setBegin(this._begin.toTemporalOffset()), this._end !== null && t.setEnd(this._end.toTemporalOffset());
			let n = new St(this, e).getRegion();
			t.setRegion(n);
			for (let [e, n] of this._styleProperties) t.setStyle(e, n);
			let r = null, i = Array.from(this._captionLines.entries()).sort((e, t) => e[0] - t[0]);
			for (let [n, a] of i) {
				if (r !== null) {
					let i = Math.abs(r - n);
					for (let n = 0; n < i; n++) t.pushChild(new p(e));
				}
				r = n;
				for (let n of a.getTexts()) {
					if (n.isEmpty()) continue;
					let r = new f(e);
					if (n.getBegin() !== null) {
						let e = n.getBegin().toTemporalOffset();
						this._captionStyle === z.PaintOn && this._begin !== null && (e = e.subtract(this._begin.toTemporalOffset())), r.setBegin(e);
					}
					if (n.getEnd() !== null) {
						let e = n.getEnd().toTemporalOffset();
						this._captionStyle === z.PaintOn && this._end !== null && (e = e.subtract(this._end.toTemporalOffset())), r.setEnd(e);
					}
					for (let [e, t] of n.getStyleProperties()) r.setStyle(e, t);
					n.getStyleProperties().has(P.BackgroundColor) || r.setStyle(P.BackgroundColor, w.black), r.pushChild(new m(e, n.getText())), t.pushChild(r);
				}
			}
			return t;
		}
	}, St = class {
		constructor(e, t) {
			this._paragraph = e, this._doc = t;
			let n = t.getCellResolution(), r = e.getSafeAreaXOffset(), i = e.getSafeAreaYOffset();
			this._left = r, this._top = i, this._right = n.columns - r, this._bottom = n.rows - i + 1;
		}
		getRegion() {
			let e = this._findMatchingRegion();
			return e === null ? e = this._createMatchingRegion() : this._extendRegionToParagraph(e), e;
		}
		_getRegionPrefix() {
			return this._paragraph.getCaptionStyle() === z.PaintOn ? "paint" : this._paragraph.getCaptionStyle() === z.PopOn ? "pop" : this._paragraph.getCaptionStyle() === z.RollUp ? "rollup" : "region";
		}
		_hasSameOriginAsRegion(e) {
			let t = e.getStyle(P.Origin);
			if (!t) return !1;
			let n = gt(this._paragraph.getOrigin(), this._doc.getCellResolution()), r = this._paragraph.getCaptionStyle();
			return r === z.RollUp || r === z.PaintOn ? t.x.units === n.x.units && t.y.units === n.y.units && Math.abs(t.x.value - n.x.value) < .001 && t.y.value <= n.y.value : t.x.units === n.x.units && t.y.units === n.y.units && Math.abs(t.x.value - n.x.value) < .001 && Math.abs(t.y.value - n.y.value) < .001;
		}
		_findMatchingRegion() {
			let e = this._getRegionPrefix();
			for (let t of this._doc.iterRegions()) {
				let n = t.getId() ?? "";
				if (this._hasSameOriginAsRegion(t) && n.startsWith(e)) return t;
			}
			return null;
		}
		_extendRegionToParagraph(e) {
			let t = e.getStyle(P.Extent);
			if (!t) return;
			let n = gt(this._paragraph.getExtent(), this._doc.getCellResolution());
			if (n.width.value > t.width.value) {
				let r = e.getStyle(P.Origin), i = this._right / this._doc.getCellResolution().columns * 100 - r.x.value, a = Math.round(Math.min(n.width.value, i));
				e.setStyle(P.Extent, {
					width: b(a, C.pct),
					height: t.height
				});
			}
		}
		_createMatchingRegion() {
			let e = Array.from(this._doc.iterRegions()), t = this._paragraph.getOrigin(), n = new h(this._getRegionPrefix() + (e.length + 1), this._doc), r = this._doc.getCellResolution(), i;
			i = this._paragraph.getCaptionStyle() === z.RollUp ? gt(pt(t.x.value, this._top), r) : gt(t, r), n.setStyle(P.Origin, i);
			let a = this._paragraph.getExtent(), o = this._right - Math.floor(t.x.value), s = Math.min(a.width.value, o), c;
			this._paragraph.getCaptionStyle() === z.RollUp ? (c = this._bottom - (this._top + 1), n.setStyle(P.DisplayAlign, O.after)) : (c = this._bottom - Math.floor(t.y.value) - 1, n.setStyle(P.DisplayAlign, O.before));
			let l = gt(mt(s, c), r);
			return n.setStyle(P.Extent, l), n.setStyle(P.ShowBackground, ne.whenActive), this._doc.putRegion(n), n;
		}
	};
})), wt, Tt, Et, Dt = n((() => {
	Ct(), it(), Ee(), ke(), F(), wt = 15, Tt = /* @__PURE__ */ function(e) {
		return e.AUTO = "auto", e.LEFT = "left", e.CENTER = "center", e.RIGHT = "right", e;
	}({}), Et = class {
		constructor(e, t, n) {
			this.div = null, this.count = 0, this.previousWord = null, this.previousWordType = null, this.currentStyle = z.Unknown, this.activeCaption = null, this.currentChannel = I.CHANNEL_1, this.rollUpDepth = 0, this.activeCursor = [0, 0], this.currentTextDecoration = null, this.currentColor = null, this.currentFontStyle = null, this.safeAreaXOffset = e, this.safeAreaYOffset = t, this.textAlignment = n?.textAlign ?? Tt.AUTO, this.bufferedCaption = new xt(e, t, z.PopOn);
		}
		newActiveCaption(e, t = z.Unknown) {
			this.activeCaption = new xt(this.safeAreaXOffset, this.safeAreaYOffset, t), this.count++, this.activeCaption.setId("caption" + this.count), this.activeCaption.setBegin(e);
		}
		newBufferedCaption() {
			this.bufferedCaption = new xt(this.safeAreaXOffset, this.safeAreaYOffset, z.PopOn);
		}
		getCaptionToProcess(e) {
			return this.currentStyle === z.PaintOn || this.currentStyle === z.RollUp ? (this.hasActiveCaption() || this.newActiveCaption(e, this.currentStyle), this.activeCaption) : this.currentStyle === z.PopOn ? this.bufferedCaption : null;
		}
		hasActiveCaption() {
			return this.activeCaption !== null;
		}
		flipBufferedToActiveCaptions(e) {
			let t = null;
			this.hasActiveCaption() && (t = this.activeCaption, e !== void 0 && this.pushActiveCaptionToModel(e)), this.bufferedCaption.getId() || (this.count++, this.bufferedCaption.setId("caption" + this.count)), this.activeCaption = this.bufferedCaption, this.newBufferedCaption(), t !== null && (this.bufferedCaption = t);
		}
		pushActiveCaptionToModel(e, t = !0) {
			if (this.hasActiveCaption()) {
				this.activeCursor = this.activeCaption.getCursor();
				let n = this.activeCaption;
				n.setEnd(e), t && (this.activeCaption = null), !n.isEmpty() && this.div !== null && this.div.pushChild(n.toParagraph(this.div.getDoc()));
			}
		}
		backspace(e) {
			let t = this.getCaptionToProcess(e);
			if (!t) return;
			t.getCurrentText().backspace();
			let [n, r] = t.getCursor();
			t.setCursorAt(n, Math.max(r - 1, 0));
		}
		paintOnActiveCaption(e) {
			let t = z.PaintOn, n = this.activeCursor, r = this.activeCaption ? this.activeCaption.copyLines() : /* @__PURE__ */ new Map();
			this.hasActiveCaption() && (t = this.activeCaption.getCaptionStyle(), n = this.activeCaption.getCursor(), this.pushActiveCaptionToModel(e)), this.newActiveCaption(e, t), r.size > 0 && this.activeCaption.setLines(r), this.activeCaption.setCursorAt(n[0], n[1]);
		}
		processPreambleAddressCode(e, t) {
			let n = e.row, r = e.indent;
			if (this.currentStyle === z.PaintOn) {
				this.paintOnActiveCaption(t);
				let e = this.activeCaption.getLines().get(n);
				e && e.clear(), this.activeCaption.setCursorAt(n, r);
			} else if (this.currentStyle === z.RollUp) {
				if (this.hasActiveCaption() || this.newActiveCaption(t, z.RollUp), this.activeCaption.getBegin() === null && this.activeCaption.setBegin(t), n >= 5 && n <= 11) {
					this.activeCaption.setCursorAt(wt), this.activeCaption.newCaptionText();
					return;
				}
				this.activeCaption.setCursorAt(wt, r), this.activeCaption.newCaptionText();
			} else this.currentStyle === z.PopOn && this.bufferedCaption.setCursorAt(n, r);
			this.currentColor = e.color, this.currentFontStyle = e.italic ? E.italic : null, this.currentTextDecoration = e.underline ? {
				underline: !0,
				overline: !1,
				lineThrough: !1
			} : null, this.hasActiveCaption() && (this.activeCursor = this.activeCaption.getCursor());
		}
		processMidRowCode(e, t) {
			let n = this.getCaptionToProcess(t), { color: r, fontStyle: i, textDecoration: a } = e;
			this.previousWordType === "midrow" ? (r !== null && (this.currentColor = r), i !== null && (this.currentFontStyle = i), a !== null && (this.currentTextDecoration = a), n !== null && (n.appendText(" "), n.newCaptionText())) : (n !== null && n.getCurrentText() !== null && !n.getCurrentText().isEmpty() ? this.currentStyle === z.PaintOn && n.getCurrentLine().getCursor() < n.getCurrentLine().getLength() ? n.appendText(" ") : a === null ? (n.newCaptionText(), n.appendText(" ")) : (n.appendText(" "), n.newCaptionText()) : n !== null && n.appendText(" "), this.currentColor = r, this.currentFontStyle = i, this.currentTextDecoration = a), n !== null && n.getCaptionStyle() === z.PaintOn && n.getCurrentText().setBegin(t);
		}
		processAttributeCode(e, t) {
			let n = this.getCaptionToProcess(t);
			n !== null && (n.getCurrentText().getText() && n.newCaptionText(), e.isBackground ? n.getCurrentText().addStyleProperty(P.BackgroundColor, e.color) : n.getCurrentText().addStyleProperty(P.Color, e.color), n.getCurrentText().addStyleProperty(P.TextDecoration, e.textDecoration));
		}
		processControlCode(e, t) {
			switch (e) {
				case R.RCL:
					this.currentStyle = z.PopOn;
					break;
				case R.RDC:
					this.currentStyle = z.PaintOn;
					break;
				case R.RU2:
				case R.RU3:
				case R.RU4:
					this.currentStyle = z.RollUp, this.rollUpDepth = e === R.RU2 ? 2 : e === R.RU3 ? 3 : 4, this.hasActiveCaption() || (this.newActiveCaption(t, z.RollUp), this.activeCaption.setCaptionStyle(z.RollUp), this.activeCaption.setCursorAt(wt, 0), this.activeCaption.newCaptionLine(), this.activeCaption.newCaptionText(), this.activeCursor = this.activeCaption.getCursor());
					break;
				case R.EOC:
					if (this.bufferedCaption.setBegin(t), this.flipBufferedToActiveCaptions(t), this.hasActiveCaption()) {
						let e;
						this.textAlignment === Tt.AUTO ? e = this.activeCaption.guessTextAlignment() : (Promise.resolve().then(() => (F(), y)), e = this.textAlignment), this.activeCaption.addStyleProperty(P.TextAlign, e);
					}
					break;
				case R.EDM:
					this.hasActiveCaption() && this.pushActiveCaptionToModel(t);
					break;
				case R.ENM:
					this.newBufferedCaption();
					break;
				case R.TO1:
					this.getCaptionToProcess(t)?.indentCursor(1);
					break;
				case R.TO2:
					this.getCaptionToProcess(t)?.indentCursor(2);
					break;
				case R.TO3:
					this.getCaptionToProcess(t)?.indentCursor(3);
					break;
				case R.CR:
					if (this.hasActiveCaption()) {
						if (this.activeCaption.getCaptionStyle() !== z.RollUp) {
							this.pushActiveCaptionToModel(t);
							return;
						}
						if (this.activeCaption.getCurrentText().isEmpty()) this.activeCaption.setBegin(t), this.activeCaption.setCursorAt(wt);
						else {
							this.pushActiveCaptionToModel(t, !1), this.activeCaption.rollUp();
							let e = this.activeCaption.getLastCaptionLines(this.rollUpDepth - 1);
							this.newActiveCaption(t, z.RollUp), this.activeCaption.setLines(e), this.activeCaption.setCursorAt(wt);
						}
					}
					break;
				case R.DER: break;
				case R.BS:
					this.backspace(t);
					break;
			}
		}
		processText(e, t) {
			this.currentStyle === z.PaintOn ? (this.hasActiveCaption() || this.paintOnActiveCaption(t), e.startsWith(" ") ? this.activeCaption.getCaptionStyle() === z.PaintOn ? (this.activeCaption.newCaptionText(), this.activeCaption.appendText(e), this.activeCaption.getCurrentText().setBegin(t)) : (this.paintOnActiveCaption(t), this.activeCaption.appendText(e)) : e.endsWith(" ") ? (this.activeCaption.appendText(e), this.activeCaption.getCaptionStyle() === z.PaintOn ? (this.activeCaption.newCaptionText(), this.activeCaption.getCurrentText().setBegin(t)) : this.paintOnActiveCaption(t)) : (this.hasActiveCaption() || this.paintOnActiveCaption(t), this.activeCaption.appendText(e)), this.activeCaption.getCurrentText().addStyleProperty(P.Color, this.currentColor), this.activeCaption.getCurrentText().addStyleProperty(P.FontStyle, this.currentFontStyle), this.activeCaption.getCurrentText().addStyleProperty(P.TextDecoration, this.currentTextDecoration)) : this.currentStyle === z.RollUp ? (this.hasActiveCaption() || this.newActiveCaption(t, this.currentStyle), this.activeCaption.appendText(e), this.activeCaption.getCurrentText().addStyleProperty(P.Color, this.currentColor), this.activeCaption.getCurrentText().addStyleProperty(P.FontStyle, this.currentFontStyle), this.activeCaption.getCurrentText().addStyleProperty(P.TextDecoration, this.currentTextDecoration)) : this.currentStyle === z.PopOn && (this.bufferedCaption.appendText(e), this.bufferedCaption.getCurrentText().addStyleProperty(P.Color, this.currentColor), this.bufferedCaption.getCurrentText().addStyleProperty(P.FontStyle, this.currentFontStyle), this.bufferedCaption.getCurrentText().addStyleProperty(P.TextDecoration, this.currentTextDecoration)), this.hasActiveCaption() && (this.activeCursor = this.activeCaption.getCursor());
		}
		flush(e) {
			this.hasActiveCaption() && this.pushActiveCaptionToModel(e ?? null), this.newBufferedCaption();
		}
	};
})), Ot = /* @__PURE__ */ r({ sccToModel: () => kt });
function kt(e, t, n) {
	let r = new _();
	r.setLang(""), r.setCellResolution({
		rows: Mt,
		columns: Nt
	}), r.setActiveArea({
		leftOffset: Pt / Nt * 100,
		topOffset: Ft / Mt * 100,
		width: (Nt - Pt * 2) / Nt * 100,
		height: (Mt - Ft * 2) / Mt * 100
	});
	let i = new l(r);
	i.setStyle(P.FontFamily, [
		"Consolas",
		"Monaco",
		"monospace"
	]), i.setStyle(P.LineHeight, b(100, C.pct)), i.setStyle(P.LinePadding, b(.25, C.c)), r.setBody(i);
	let a = new u(r);
	i.pushChild(a);
	let o = new Et(Pt, Ft, t);
	o.div = a;
	let s = e.split("\n"), c = 0;
	for (let e of s) {
		let t = e.trim();
		if (!t || t.startsWith("Scenarist_SCC V1.0")) continue;
		let r = st.fromStr(t, _e);
		r && r.process(o), c++, n && c % 100 == 0 && n(c / s.length);
	}
	return o.flush(), n && n(1), r;
}
var At, jt, Mt, Nt, Pt, Ft, It = n((() => {
	v(), F(), we(), ct(), Dt(), At = 15, jt = 32, Mt = Math.ceil(At / .8), Nt = Math.ceil(jt / .8), Pt = Math.ceil((Nt - jt) / 2), Ft = Math.ceil((Mt - At) / 2);
}));
//#endregion
//#region src/stl/iso6937.ts
function Lt(e) {
	let t = "", n = 0;
	for (; n < e.length;) {
		let r = e[n];
		if (r < 32) {
			n++;
			continue;
		}
		if (r >= 32 && r <= 126) {
			t += String.fromCharCode(r), n++;
			continue;
		}
		if (r >= 193 && r <= 207) {
			let i = zt[r];
			if (i && n + 1 < e.length) {
				let r = i[e[n + 1]];
				if (r) {
					t += r, n += 2;
					continue;
				}
			}
			n++;
			continue;
		}
		let i = Rt[r];
		i && (t += i), n++;
	}
	return t;
}
var Rt, zt, Bt = n((() => {
	Rt = {
		160: "\xA0",
		161: "¡",
		162: "¢",
		163: "£",
		164: "$",
		165: "¥",
		166: "#",
		167: "§",
		168: "¤",
		169: "‘",
		170: "\"",
		171: "«",
		172: "←",
		173: "↑",
		174: "→",
		175: "↓",
		176: "°",
		177: "±",
		178: "²",
		179: "³",
		180: "×",
		181: "µ",
		182: "¶",
		183: "·",
		184: "÷",
		185: "’",
		186: "\"",
		187: "»",
		188: "¼",
		189: "½",
		190: "¾",
		191: "¿",
		208: "─",
		209: "¹",
		210: "®",
		211: "©",
		212: "™",
		213: "♪",
		214: "¬",
		215: "¦",
		220: "⅛",
		221: "⅜",
		222: "⅝",
		223: "⅞",
		224: "Ω",
		225: "Æ",
		226: "Ð",
		227: "ª",
		228: "Ħ",
		230: "Ĳ",
		231: "Ŀ",
		232: "Ł",
		233: "Ø",
		234: "Œ",
		235: "º",
		236: "Þ",
		237: "Ŧ",
		238: "Ŋ",
		239: "ŉ",
		240: "ĸ",
		241: "æ",
		242: "đ",
		243: "ð",
		244: "ħ",
		245: "ı",
		246: "ĳ",
		247: "ŀ",
		248: "ł",
		249: "ø",
		250: "œ",
		251: "ß",
		252: "þ",
		253: "ŧ",
		254: "ŋ",
		255: "­"
	}, zt = {
		193: {
			65: "À",
			69: "È",
			73: "Ì",
			79: "Ò",
			85: "Ù",
			97: "à",
			101: "è",
			105: "ì",
			111: "ò",
			117: "ù"
		},
		194: {
			65: "Á",
			67: "Ć",
			69: "É",
			73: "Í",
			76: "Ĺ",
			78: "Ń",
			79: "Ó",
			82: "Ŕ",
			83: "Ś",
			85: "Ú",
			89: "Ý",
			90: "Ź",
			97: "á",
			99: "ć",
			101: "é",
			105: "í",
			108: "ĺ",
			110: "ń",
			111: "ó",
			114: "ŕ",
			115: "ś",
			117: "ú",
			121: "ý",
			122: "ź"
		},
		195: {
			65: "Â",
			67: "Ĉ",
			69: "Ê",
			71: "Ĝ",
			72: "Ĥ",
			73: "Î",
			74: "Ĵ",
			79: "Ô",
			83: "Ŝ",
			85: "Û",
			87: "Ŵ",
			89: "Ŷ",
			97: "â",
			99: "ĉ",
			101: "ê",
			103: "ĝ",
			104: "ĥ",
			105: "î",
			106: "ĵ",
			111: "ô",
			115: "ŝ",
			117: "û",
			119: "ŵ",
			121: "ŷ"
		},
		196: {
			65: "Ã",
			73: "Ĩ",
			78: "Ñ",
			79: "Õ",
			85: "Ũ",
			97: "ã",
			105: "ĩ",
			110: "ñ",
			111: "õ",
			117: "ũ"
		},
		197: {
			65: "Ā",
			69: "Ē",
			73: "Ī",
			79: "Ō",
			85: "Ū",
			97: "ā",
			101: "ē",
			105: "ī",
			111: "ō",
			117: "ū"
		},
		198: {
			65: "Ă",
			69: "Ĕ",
			71: "Ğ",
			73: "Ĭ",
			79: "Ŏ",
			85: "Ŭ",
			97: "ă",
			101: "ĕ",
			103: "ğ",
			105: "ĭ",
			111: "ŏ",
			117: "ŭ"
		},
		199: {
			67: "Ċ",
			69: "Ė",
			71: "Ġ",
			73: "İ",
			90: "Ż",
			99: "ċ",
			101: "ė",
			103: "ġ",
			122: "ż"
		},
		200: {
			65: "Ä",
			69: "Ë",
			73: "Ï",
			79: "Ö",
			85: "Ü",
			89: "Ÿ",
			97: "ä",
			101: "ë",
			105: "ï",
			111: "ö",
			117: "ü",
			121: "ÿ"
		},
		202: {
			65: "Å",
			85: "Ů",
			97: "å",
			117: "ů"
		},
		203: {
			67: "Ç",
			71: "Ģ",
			75: "Ķ",
			76: "Ļ",
			78: "Ņ",
			82: "Ŗ",
			83: "Ş",
			84: "Ţ",
			99: "ç",
			103: "ģ",
			107: "ķ",
			108: "ļ",
			110: "ņ",
			114: "ŗ",
			115: "ş",
			116: "ţ"
		},
		205: {
			79: "Ő",
			85: "Ű",
			111: "ő",
			117: "ű"
		},
		206: {
			65: "Ą",
			69: "Ę",
			73: "Į",
			85: "Ų",
			97: "ą",
			101: "ę",
			105: "į",
			117: "ų"
		},
		207: {
			67: "Č",
			68: "Ď",
			69: "Ě",
			76: "Ľ",
			78: "Ň",
			82: "Ř",
			83: "Š",
			84: "Ť",
			90: "Ž",
			99: "č",
			100: "ď",
			101: "ě",
			108: "ľ",
			110: "ň",
			114: "ř",
			115: "š",
			116: "ť",
			122: "ž"
		}
	};
}));
//#endregion
//#region src/stl/tf.ts
function Vt(e) {
	for (let t = 0; t < e.length; t++) if (e[t] === 13) return !0;
	return !1;
}
function Ht(e, t) {
	let n = 0, r = !1;
	for (let i = 0; i < e.length; i++) e[i] === 138 ? t && r ? r = !1 : (n++, r = !0) : r = !1;
	return n + 1;
}
function Ut(e, t, n, r) {
	let i = w.white, a = t ? w.black : w.transparent, o = !1, s = !1, c = e.getDoc ? e.getDoc() : null, l = typeof n == "string" ? n.trim() : n.toString("ascii").trim(), u = [];
	function d() {
		if (u.length === 0) return;
		let t = new Uint8Array(u);
		u = [];
		let n;
		if (n = l === "00" ? Lt(t) : l === "01" ? Buffer.from(t).toString("latin1") : Buffer.from(t).toString("utf8"), !n) return;
		let r = new f(c);
		r.setStyle(P.BackgroundColor, a), r.setStyle(P.Color, i), o && r.setStyle(P.FontStyle, E.italic), s && r.setStyle(P.TextDecoration, S(!0)), r.pushChild(new m(c, n)), e.pushChild(r);
	}
	function h() {
		i = w.white, a = t ? w.black : w.transparent, o = !1, s = !1;
	}
	let g = r instanceof Buffer ? new Uint8Array(r) : r, _ = 0;
	for (; _ < g.length;) {
		let n = g[_];
		if (n === 143) break;
		if (n >= 32 && n <= 127 || n >= 160) {
			let e = _ > 0 ? g[_ - 1] : 143, t = _ + 1 < g.length ? g[_ + 1] : 143, r = (e) => e >= 33 && e <= 127 || e >= 160;
			(n !== 32 || r(e) && r(t)) && u.push(n), _++;
			continue;
		}
		if (n === 138) {
			let n = _ + 1 < g.length ? g[_ + 1] : 143;
			n !== 138 && n !== 143 && (d(), e.pushChild(new p(c)), t && h()), _++;
			continue;
		}
		if (n >= 0 && n <= 7 || n >= 10 && n <= 13 || n >= 28 && n <= 29 || n >= 128 && n <= 133) {
			if (d(), n >= 0 && n <= 7 ? i = Wt[n] : n === 28 ? a = w.black : n === 29 ? a = i : n === 128 ? o = !0 : n === 129 ? o = !1 : n === 130 ? s = !0 : n === 131 ? s = !1 : n === 133 && (a = w.transparent), _ > 0 && _ + 1 < g.length) {
				let e = g[_ - 1], t = g[_ + 1], n = (e) => e >= 33 && e <= 127 || e >= 160;
				n(e) && n(t) && u.push(32);
			}
			_++;
			continue;
		}
		_++;
	}
	d();
}
var Wt, Gt = n((() => {
	v(), F(), Bt(), Wt = {
		0: w.black,
		1: w.red,
		2: w.lime,
		3: w.yellow,
		4: w.blue,
		5: w.magenta,
		6: w.cyan,
		7: w.white
	};
}));
//#endregion
//#region src/stl/dataFile.ts
function Kt(e) {
	return {
		cpn: e.slice(0, 3).toString("ascii"),
		dfc: e.slice(3, 11).toString("ascii").trim(),
		dsc: e.slice(11, 12).toString("ascii"),
		cct: e.slice(12, 14).toString("ascii").trim(),
		lc: e.slice(14, 16).toString("hex").toUpperCase(),
		tnb: parseInt(e.slice(238, 243).toString("ascii")) || 0,
		mnr: parseInt(e.slice(253, 255).toString("ascii")) || 0,
		tcp: e.slice(256, 264).toString("ascii")
	};
}
function qt(e, t) {
	let n = t;
	return {
		sgn: e[n + 0],
		sn: e.readUInt16LE(n + 1),
		ebn: e[n + 3],
		cs: e[n + 4],
		tci: [
			e[n + 5],
			e[n + 6],
			e[n + 7],
			e[n + 8]
		],
		tco: [
			e[n + 9],
			e[n + 10],
			e[n + 11],
			e[n + 12]
		],
		vp: e[n + 13],
		jc: e[n + 14],
		cf: e[n + 15],
		tf: e.slice(n + 16, n + 128)
	};
}
function Jt(e, t, n, r, i, a) {
	for (let o of e.iterRegions()) {
		let e = o.getStyle(P.Origin);
		if (!e || e.x.value !== t || e.y.value !== n) continue;
		let s = o.getStyle(P.Extent);
		if (s && !(s.width.value !== r || s.height.value !== i) && o.getStyle(P.DisplayAlign) === a) return o;
	}
	let o = [...e.iterRegions()].length, s = new h(`r${o}`, e);
	return s.setStyle(P.Origin, {
		x: b(t, C.pct),
		y: b(n, C.pct)
	}), s.setStyle(P.Extent, {
		width: b(r, C.pct),
		height: b(i, C.pct)
	}), s.setStyle(P.DisplayAlign, a), e.putRegion(s), s;
}
function Yt(e, t, n, r) {
	let i = Kt(e.slice(0, 1024)), a = an[i.dfc.replace(/\x00/g, "").trim()] ?? new o(25, 1), s = on[i.lc] ?? "";
	t.setLang(s), t.setCellResolution({
		columns: Math.round(4e3 / (100 - 2 * Xt)),
		rows: Math.round(100 * Qt / (100 - 2 * Zt))
	}), t.setActiveArea({
		leftOffset: Xt / 100,
		topOffset: Zt / 100,
		width: 1 - 2 * Xt / 100,
		height: 1 - 2 * Zt / 100
	});
	let c = new l(t);
	n?.disableFillLineGap || c.setStyle(P.FillLineGap, fe.true), n?.disableLinePadding || c.setStyle(P.LinePadding, b(nn, C.c)), c.setStyle(P.FontFamily, n?.fontStack ?? rn), t.setBody(c);
	let m = i.dsc === "1" || i.dsc === "2", h = new o(0), g = n?.programStartTc ?? null;
	if (g !== null) if (g === "TCP") try {
		let e = i.tcp.replace(/\x00/g, "").trim();
		h = new Ce(parseInt(e.slice(0, 2)), parseInt(e.slice(2, 4)), parseInt(e.slice(4, 6)), parseInt(e.slice(6, 8)), a).toTemporalOffset();
	} catch {}
	else {
		let e = Ce.parse(g, a);
		e && (h = e.toTemporalOffset());
	}
	let _;
	_ = n?.maxRowCount == null || m ? Qt : n.maxRowCount === "MNR" ? i.mnr || Qt : n.maxRowCount;
	let v = Math.round(100 - Zt * 2), y = Math.round(100 - Xt * 2), x = /* @__PURE__ */ new Map(), S = null, w = !1, T = Buffer.alloc(0), E = null, k = null, ee = Math.floor((e.length - 1024) / 128);
	for (let n = 0; n < ee; n++) {
		let s = 1024 + n * 128;
		if (s + 128 > e.length) break;
		let l = qt(e, s);
		if (l.ebn > 239 && l.ebn < 255) continue;
		w || (T = Buffer.alloc(0));
		let g = l.tf, A = g.length;
		for (; A > 0 && g[A - 1] === 143;) A--;
		T = Buffer.concat([T, g.slice(0, A)]);
		let j = Vt(T);
		if (l.ebn !== 255) {
			w = !0;
			continue;
		}
		w = !1;
		let [te, ne, re, ie] = l.tci, [ae, oe, se, ce] = l.tco, M, le;
		try {
			M = new Ce(te, ne, re, ie, a).toTemporalOffset().subtract(h), le = new Ce(ae, oe, se, ce, a).toTemporalOffset().subtract(h);
		} catch {
			continue;
		}
		if (M.lessThan(new o(0)) || (k !== null && l.cs === 0 && M.lessThan(k) && (M = k), le.lessOrEqual(M))) continue;
		if (k = le, l.sn !== S && (l.cs === 0 || l.cs === 1)) {
			S = l.sn;
			let e = x.get(l.sgn);
			e || (e = new u(t), c.pushChild(e), x.set(l.sgn, e)), E = new d(t), l.jc === 1 ? E.setStyle(P.TextAlign, D.start) : l.jc === 3 ? E.setStyle(P.TextAlign, D.end) : E.setStyle(P.TextAlign, D.center), E.setStyle(P.LineHeight, b($t, C.pct));
			let n = m && !j ? en : tn;
			E.setStyle(P.FontSize, b(n, C.pct));
			let r;
			if (l.vp < Math.floor(_ / 2)) {
				let e = Zt + (l.vp - 1) / _ * v;
				r = Jt(t, Xt, e, y, 100 - Zt - e, O.before);
			} else {
				let e = Ht(T, j), n = j ? 2 : 1;
				r = Jt(t, Xt, Zt, y, (l.vp + e * n - 1) / _ * v, O.after);
			}
			E.setRegion(r), e.pushChild(E);
		}
		if (!E) continue;
		let ue;
		if (l.cs === 1 || l.cs === 2 || l.cs === 3) {
			let e = new f(t);
			E.pushChild(e), ue = e;
		} else ue = E;
		ue.setBegin(M), ue.setEnd(le), Ut(ue, m, i.cct, T), (l.cs === 1 || l.cs === 2) && ue.pushChild(new p(t)), r && r(n / ee);
	}
	r && r(1);
}
var Xt, Zt, Qt, $t, en, tn, nn, rn, an, on, sn = n((() => {
	v(), F(), Gt(), we(), Xt = 5, Zt = 10, Qt = 23, $t = 125, en = 80, tn = 160, nn = .5, rn = [
		"Verdana",
		"Arial",
		"Tiresias",
		"sansSerif"
	], an = {
		"STL23.01": new o(24e3, 1001),
		"STL24.01": new o(24, 1),
		"STL25.01": new o(25, 1),
		"STL30.01": new o(3e4, 1001),
		"STL50.01": new o(50, 1)
	}, on = {
		"00": "",
		"01": "sq",
		"02": "br",
		"03": "ca",
		"04": "hr",
		"05": "cy",
		"06": "cs",
		"07": "da",
		"08": "de",
		"09": "en",
		"0A": "es",
		"0B": "eo",
		"0C": "et",
		"0D": "eu",
		"0E": "fo",
		"0F": "fr",
		10: "fy",
		11: "ga",
		12: "gd",
		13: "gl",
		14: "is",
		15: "it",
		16: "se",
		17: "la",
		18: "lv",
		19: "lb",
		"1A": "lt",
		"1B": "hu",
		"1C": "mt",
		"1D": "nl",
		"1E": "no",
		"1F": "oc",
		20: "pl",
		21: "pt",
		22: "ro",
		23: "rm",
		24: "sr",
		25: "sk",
		26: "sl",
		27: "fi",
		28: "sv",
		29: "tr",
		"2A": "nl",
		"2B": "wa",
		"7F": "am",
		"7E": "ar",
		"7D": "hy",
		"7C": "as",
		"7B": "az",
		"7A": "bm",
		79: "be",
		78: "bn",
		77: "bg",
		76: "my",
		75: "zh",
		74: "cv",
		73: "prs",
		72: "ff",
		71: "ka",
		70: "el",
		"6F": "gu",
		"6E": "gn",
		"6D": "ha",
		"6C": "he",
		"6B": "hi",
		"6A": "id",
		69: "ja",
		68: "kn",
		67: "kk",
		66: "km",
		65: "ko",
		64: "lo",
		63: "mk",
		62: "mg",
		61: "ms",
		60: "mo",
		"5F": "mr",
		"5E": "nd",
		"5D": "ne",
		"5C": "or",
		"5B": "pap",
		"5A": "fa",
		59: "pa",
		58: "ps",
		57: "qu",
		56: "ru",
		54: "sh",
		53: "sn",
		52: "si",
		51: "so",
		50: "srn",
		"4F": "sw",
		"4E": "tg",
		"4D": "ta",
		"4C": "tt",
		"4B": "te",
		"4A": "th",
		49: "uk",
		48: "ur",
		47: "uz",
		46: "vi",
		45: "zu"
	};
})), cn = /* @__PURE__ */ r({ stlToModel: () => ln });
function ln(e, t, n) {
	let r = new _();
	return Yt(e, r, t, n), r;
}
var un = n((() => {
	v(), sn();
}));
It(), un(), v(), F();
function dn(e) {
	let t = e.trim().match(/^(\d+):(\d{2}):(\d{2})[,.](\d{3})$/);
	return t ? new o(parseInt(t[1]) * 36e5 + parseInt(t[2]) * 6e4 + parseInt(t[3]) * 1e3 + parseInt(t[4]), 1e3) : null;
}
var fn = {
	1: [O.after, D.start],
	2: [O.after, D.center],
	3: [O.after, D.end],
	4: [O.center, D.start],
	5: [O.center, D.center],
	6: [O.center, D.end],
	7: [O.before, D.start],
	8: [O.before, D.center],
	9: [O.before, D.end]
}, pn = /\{\\an([1-9])\}/g;
function mn(e, t, n) {
	if (n.has(t)) return n.get(t);
	let [r, i] = fn[t], a = new h(`r_an${t}`, e);
	return a.setStyle(P.Origin, {
		x: b(10, C.pct),
		y: b(10, C.pct)
	}), a.setStyle(P.Extent, {
		width: b(80, C.pct),
		height: b(80, C.pct)
	}), a.setStyle(P.DisplayAlign, r), a.setStyle(P.TextAlign, i), a.setStyle(P.Color, w.white), a.setStyle(P.LineHeight, b(125, C.pct)), a.setStyle(P.FontSize, b(80, C.pct)), a.setStyle(P.FontFamily, [
		"Verdana",
		"Arial",
		"Tiresias",
		"sansSerif"
	]), a.setStyle(P.TextOutline, {
		color: w.black,
		thickness: b(5, C.pct)
	}), e.putRegion(a), n.set(t, a), a;
}
function hn(e) {
	return e.replace(/\{b\}/g, "<b>").replace(/\{\/b\}/g, "</b>").replace(/\{bold\}/g, "<b>").replace(/\{\/bold\}/g, "</b>").replace(/<bold>/g, "<b>").replace(/<\/bold>/g, "</b>").replace(/\{i\}/g, "<i>").replace(/\{\/i\}/g, "</i>").replace(/\{italic\}/g, "<i>").replace(/\{\/italic\}/g, "</i>").replace(/<italic>/g, "<i>").replace(/<\/italic>/g, "</i>").replace(/\{u\}/g, "<u>").replace(/\{\/u\}/g, "</u>").replace(/\{underline\}/g, "<u>").replace(/\{\/underline\}/g, "</u>").replace(/<underline>/g, "<u>").replace(/<\/underline>/g, "</u>");
}
function gn(e, t, n) {
	let r = new d(t);
	r.setRegion(n);
	let i = e.split(/\r?\n/);
	for (let e = 0; e < i.length; e++) e > 0 && r.pushChild(new p(t)), _n(i[e], t, r);
	return r;
}
function _n(e, t, n) {
	let r = [{
		bold: !1,
		italic: !1,
		underline: !1,
		color: null
	}], i = 0, a = "", o = () => {
		if (a) {
			let e = r[r.length - 1], i = new f(t);
			if (e.italic && i.setStyle(P.FontStyle, E.italic), e.bold && i.setStyle(P.FontWeight, T.bold), e.underline && i.setStyle(P.TextDecoration, S(!0)), e.color) {
				let t = vn(e.color);
				t && i.setStyle(P.Color, t);
			}
			i.pushChild(new m(t, a)), n.pushChild(i), a = "";
		}
	};
	for (; i < e.length;) {
		if (e[i] !== "<") {
			a += e[i++];
			continue;
		}
		let t = e.indexOf(">", i);
		if (t === -1) {
			a += e[i++];
			continue;
		}
		let n = e.slice(i + 1, t).trim();
		i = t + 1, o();
		let s = { ...r[r.length - 1] };
		if (/^b$/i.test(n)) r.push({
			...s,
			bold: !0
		});
		else if (/^i$/i.test(n)) r.push({
			...s,
			italic: !0
		});
		else if (/^u$/i.test(n)) r.push({
			...s,
			underline: !0
		});
		else if (/^font\b/i.test(n)) {
			let e = n.match(/color=["']?([^"' >]+)/i);
			r.push({
				...s,
				color: e ? e[1] : s.color
			});
		} else (/^\/[biuBIU]$/.test(n) || /^\/font$/i.test(n)) && r.length > 1 && r.pop();
	}
	o();
}
function vn(e) {
	e = e.trim().toLowerCase();
	let t = {
		white: [
			255,
			255,
			255
		],
		black: [
			0,
			0,
			0
		],
		red: [
			255,
			0,
			0
		],
		green: [
			0,
			128,
			0
		],
		lime: [
			0,
			255,
			0
		],
		blue: [
			0,
			0,
			255
		],
		yellow: [
			255,
			255,
			0
		],
		cyan: [
			0,
			255,
			255
		],
		magenta: [
			255,
			0,
			255
		]
	};
	if (t[e]) return x(...t[e]);
	let n = e.startsWith("#") ? e.slice(1) : null;
	return n && n.length === 6 ? x(parseInt(n.slice(0, 2), 16), parseInt(n.slice(2, 4), 16), parseInt(n.slice(4, 6), 16)) : n && n.length === 8 ? x(parseInt(n.slice(0, 2), 16), parseInt(n.slice(2, 4), 16), parseInt(n.slice(4, 6), 16), parseInt(n.slice(6, 8), 16)) : null;
}
function yn(e, t) {
	let n = t?.alignmentTags ?? !1, r = t?.extendedTags ?? !1, i = new _();
	i.setLang("");
	let a = new l(i);
	i.setBody(a);
	let o = new u(i);
	a.pushChild(o);
	let s = /* @__PURE__ */ new Map(), c = mn(i, 2, s), d = e.replace(/\r\n/g, "\n").split(/\n\s*\n/);
	for (let e of d) {
		let t = e.trim().split("\n");
		if (t.length < 2) continue;
		/^\d+$/.test(t[0].trim()) && t.length >= 3 && t.shift();
		let a = t[0].match(/^([\d:,. ]+)\s*-->\s*([\d:,. ]+)/);
		if (!a) continue;
		let l = dn(a[1]), u = dn(a[2]);
		if (!l || !u) continue;
		let d = t.slice(1).join("\n").replace(/\r?\n$/, "");
		r && (d = hn(d));
		let f = c;
		if (n) {
			let e = pn.exec(d);
			pn.lastIndex = 0, e && (f = mn(i, parseInt(e[1]), s), d = d.replace(pn, ""), pn.lastIndex = 0);
		}
		let p = gn(d, i, f);
		p.setBegin(l), p.setEnd(u), o.pushChild(p);
	}
	return i;
}
v(), F();
var bn = x(0, 0, 0, 204), xn = {
	"&amp": "&",
	"&lt": "<",
	"&gt": ">",
	"&nbsp": "\xA0",
	"&apos": "'",
	"&quot": "\""
};
function Sn(e) {
	e = e.trim();
	let t = e.match(/^(\d{2,}):(\d{2}):(\d{2})\.(\d{3})$/);
	return t ? new o(parseInt(t[1]) * 36e5 + parseInt(t[2]) * 6e4 + parseInt(t[3]) * 1e3 + parseInt(t[4]), 1e3) : (t = e.match(/^(\d{2}):(\d{2})\.(\d{3})$/), t ? new o(parseInt(t[1]) * 6e4 + parseInt(t[2]) * 1e3 + parseInt(t[3]), 1e3) : null);
}
var Cn = {
	white: w.white,
	black: w.black,
	red: w.red,
	lime: w.lime,
	blue: w.blue,
	yellow: w.yellow,
	cyan: w.cyan,
	aqua: w.cyan,
	magenta: w.magenta,
	fuchsia: w.fuchsia,
	green: w.green,
	transparent: w.transparent
};
function wn(e) {
	let t = e.startsWith("#") ? e.slice(1) : e, n = parseInt(t.slice(0, 2), 16), r = parseInt(t.slice(2, 4), 16), i = parseInt(t.slice(4, 6), 16), a = t.length >= 8 ? parseInt(t.slice(6, 8), 16) : 255;
	return isNaN(n) || isNaN(r) || isNaN(i) ? null : x(n, r, i, a);
}
function Tn(e) {
	if (e.startsWith("bg_")) {
		let t = e.slice(3), n = Cn[t];
		if (n) return { bgColor: n };
		if (t.startsWith("color_")) {
			let e = wn(t.slice(6));
			if (e) return { bgColor: e };
		}
		return null;
	}
	if (e.startsWith("fg_color_")) {
		let t = wn(e.slice(9));
		return t ? { color: t } : null;
	}
	let t = Cn[e];
	return t ? { color: t } : null;
}
function En(e, t, n) {
	let r = 0, i = "", a = 0, o = null, s = !0, c = [{
		italic: !1,
		bold: !1,
		underline: !1,
		color: null,
		bgColor: null
	}], l = () => c[c.length - 1], u = null, d = () => {
		if (!i) return;
		let e = l(), r = new f(t);
		e.italic && r.setStyle(P.FontStyle, E.italic), e.bold && r.setStyle(P.FontWeight, T.bold), e.underline && r.setStyle(P.TextDecoration, S(!0)), e.color && r.setStyle(P.Color, e.color), u === null && r.setStyle(P.BackgroundColor, bn), e.bgColor && r.setStyle(P.BackgroundColor, e.bgColor), o !== null && r.setBegin(o);
		let a = i.split("\n");
		for (let e = 0; e < a.length; e++) e > 0 && r.pushChild(new p(t)), r.pushChild(new m(t, a[e]));
		if (u !== null) if (u.inAnnotation) {
			u.textContainerSpan === null && (u.textContainerSpan = new f(t), u.textContainerSpan.setStyle(P.Ruby, M.textContainer), u.containerSpan.pushChild(u.textContainerSpan));
			let e = new f(t);
			e.setStyle(P.Ruby, M.text), e.pushChild(r), u.textContainerSpan.pushChild(e);
		} else {
			let e = new f(t);
			e.setStyle(P.Ruby, M.base), e.pushChild(r), u.baseContainerSpan.pushChild(e);
		}
		else n.pushChild(r);
		s = !0, i = "";
	};
	for (; r < e.length;) {
		if (e[r] !== "<") {
			if (a === 0) {
				if (e[r] === "&") {
					let t = r;
					for (r++; r < e.length && e[r] !== ";" && e[r] !== "<";) r++;
					let n = e.slice(t, r);
					r < e.length && e[r] === ";" ? (r++, i += xn[n] ?? n) : i += n;
					continue;
				}
				i += e[r];
			}
			r++;
			continue;
		}
		let p = e.indexOf(">", r);
		if (p === -1) {
			a === 0 && (i += e[r]), r++;
			continue;
		}
		let m = e.slice(r + 1, p).trim();
		if (r = p + 1, /^rp$/i.test(m)) {
			d(), a++;
			continue;
		}
		if (/^\/rp$/i.test(m)) {
			a > 0 && a--;
			continue;
		}
		if (a > 0) continue;
		if (/^ruby$/i.test(m)) {
			d();
			let e = new f(t);
			e.setStyle(P.Ruby, M.container);
			let n = new f(t);
			n.setStyle(P.Ruby, M.baseContainer), e.pushChild(n), u = {
				containerSpan: e,
				baseContainerSpan: n,
				textContainerSpan: null,
				inAnnotation: !1
			};
			continue;
		}
		if (/^\/ruby$/i.test(m)) {
			d(), u !== null && (n.pushChild(u.containerSpan), u = null);
			continue;
		}
		if (/^rt$/i.test(m)) {
			d(), u !== null && (u.inAnnotation = !0);
			continue;
		}
		if (/^\/rt$/i.test(m)) {
			d(), u !== null && (u.inAnnotation = !1);
			continue;
		}
		d();
		let h = Sn(m);
		if (h !== null) {
			o = h, s = !1;
			continue;
		}
		if (/^b$/i.test(m)) c.push({
			...l(),
			bold: !0
		});
		else if (/^i$/i.test(m)) c.push({
			...l(),
			italic: !0
		});
		else if (/^u$/i.test(m)) c.push({
			...l(),
			underline: !0
		});
		else if (/^c\.([\w-]+)$/i.test(m)) {
			let e = Tn(m.slice(2)), t = { ...l() };
			e?.color && (t.color = e.color), e?.bgColor && (t.bgColor = e.bgColor), c.push(t);
		} else (/^\/[biuBIU]$/.test(m) || /^\/c$/i.test(m)) && c.length > 1 && c.pop();
	}
	if (d(), o !== null && !s && u === null) {
		let e = new f(t);
		e.setStyle(P.BackgroundColor, bn), e.setBegin(o), n.pushChild(e);
	}
}
var Dn = 5, On = 6.25, kn = 23, An = 40;
function jn(e) {
	let t = e.match(/^(\d+\.?\d*)%$/);
	if (!t) return null;
	let n = Math.round(parseFloat(t[1]));
	return n >= 0 && n <= 100 ? n : null;
}
function Mn(e) {
	let t = e.match(/^(-?\d{1,20})$/);
	return t ? parseInt(t[1], 10) : null;
}
function Nn(e) {
	let t = e.vertical, n = t === "lr" ? k.tblr : t === "rl" ? k.tbrl : k.lrtb, r = "center", i = e.align;
	i && [
		"left",
		"right",
		"start",
		"center",
		"end"
	].includes(i) && (r = i);
	let a = 100, o = e.size;
	if (o !== void 0) {
		let e = jn(o);
		e !== null && (a = e);
	}
	let s = "start", c = !0, l = -1, u = e.line;
	if (u !== void 0) {
		let e = u.split(","), t = jn(e[0]);
		if (t !== null) l = t, c = !1;
		else {
			let t = Mn(e[0]);
			t !== null && (l = t);
		}
		e.length === 2 && [
			"start",
			"center",
			"end"
		].includes(e[1]) && (s = e[1]);
	}
	let d = null, f = null, p = e.position;
	if (p !== void 0) {
		let e = p.split(",");
		d = jn(e[0]), d !== null && e.length > 1 && [
			"center",
			"line-left",
			"line-right"
		].includes(e[1]) && (f = e[1]);
	}
	f === null && (f = r === "start" ? n === k.rltb ? "line-right" : "line-left" : r === "end" ? n === k.rltb ? "line-left" : "line-right" : r === "left" ? "line-left" : r === "right" ? "line-right" : "center"), (d === null || !(d >= 0 && d <= 100)) && (d = r === "left" ? 0 : r === "right" ? 100 : 50);
	let m = D.center;
	r === "left" ? m = n === k.rltb ? D.end : D.start : r === "right" ? m = n === k.rltb ? D.start : D.end : r === "start" ? m = D.start : r === "end" && (m = D.end);
	let h;
	h = s === "center" ? O.center : s === "end" ? O.after : O.before;
	let g;
	g = f === "line-left" ? 100 - d : f === "line-right" ? d : d <= 50 ? d * 2 : (100 - d) * 2;
	let _ = Math.max(Dn, Math.min(a, g)), v;
	v = f === "line-left" ? Math.min(d, 100 - _) : f === "line-right" ? Math.max(0, d - _) : Math.max(Math.min(d - _ / 2, 100 - _), 0);
	let y;
	y = c ? l >= 0 ? On * l : 100 + l * On : l;
	let x;
	x = s === "center" ? Math.max(On, Math.min(y * 2, (100 - y) * 2)) : s === "end" ? y : 100 - y, x = Math.max(On, x), y = s === "center" ? Math.max(Math.min(y - x / 2, 100 - x), 0) : s === "end" ? Math.max(0, y - x) : Math.min(y, 100 - x);
	let S = n === k.lrtb || n === k.rltb;
	return {
		origin: {
			x: b(S ? v : y, C.pct),
			y: b(S ? y : v, C.pct)
		},
		extent: {
			width: b(S ? _ : x, C.pct),
			height: b(S ? x : _, C.pct)
		},
		writingMode: n,
		textAlign: m,
		displayAlign: h
	};
}
function Pn(e, t) {
	if (e === t) return !0;
	if (typeof e != typeof t) return !1;
	if (typeof e == "object" && e && t !== null) {
		let n = Object.keys(e), r = Object.keys(t);
		return n.length === r.length ? n.every((n) => Pn(e[n], t[n])) : !1;
	}
	return !1;
}
function Fn(e, t) {
	let n = {};
	for (let e of t) {
		let t = e.split(":");
		t.length === 2 && (n[t[0]] = t[1]);
	}
	let r;
	r = Object.keys(n).length > 0 ? Nn(n) : {
		origin: {
			x: b(100 / An, C.pct),
			y: b(100 / kn, C.pct)
		},
		extent: {
			width: b(100 - 200 / An, C.pct),
			height: b(100 - 200 / kn, C.pct)
		},
		writingMode: k.lrtb,
		textAlign: D.center,
		displayAlign: O.after
	};
	for (let t of e.iterRegions()) if (t.getStyle(P.WritingMode) === r.writingMode && Pn(t.getStyle(P.Extent), r.extent) && Pn(t.getStyle(P.Origin), r.origin) && t.getStyle(P.TextAlign) === r.textAlign && t.getStyle(P.DisplayAlign) === r.displayAlign) return t;
	let i = [...e.iterRegions()].length, a = new h(`r${i}`);
	return a.setStyle(P.Origin, r.origin), a.setStyle(P.Extent, r.extent), a.setStyle(P.DisplayAlign, r.displayAlign), a.setStyle(P.TextAlign, r.textAlign), a.setStyle(P.WritingMode, r.writingMode), a.setStyle(P.LineHeight, b(125, C.pct)), a.setStyle(P.FontFamily, ["sansSerif"]), a.setStyle(P.FontSize, b(75, C.pct)), a.setStyle(P.Color, w.white), a.setStyle(P.LinePadding, b(.5, C.c)), a.setStyle(P.FillLineGap, fe.true), e.putRegion(a), a;
}
function In(e) {
	let t = new _();
	t.setLang("");
	let n = new l(t);
	t.setBody(n);
	let r = new u(t);
	n.pushChild(r), e = e.replace(/\r\n/g, "\n").replace(/^\x00+$/gm, "");
	let i = e.split(/\n(?:[ \t]*\n)+/);
	for (let e of i) {
		let n = e.split("\n");
		if (n.length === 0) continue;
		let i = n[0];
		if (!i.trim() || i.startsWith("WEBVTT") || i.startsWith("NOTE") || i.startsWith("STYLE") || i.startsWith("REGION")) continue;
		let a = 0;
		if (!n[a].includes("-->") && (a++, a >= n.length)) continue;
		let o = null;
		for (; a < n.length;) {
			let e = n[a];
			if (!e.includes("-->")) break;
			let t = e.split(/[ \t\r\f\v]+/).filter((e) => e.length > 0);
			if (t.length >= 3) {
				o = t;
				break;
			}
			a++;
		}
		if (!o) continue;
		a++;
		let s = Sn(o[0]), c = Sn(o[2]);
		if (!s || !c) continue;
		let l = o.slice(3), u = n.slice(a).filter((e) => e.trim() !== "");
		if (u.length === 0) continue;
		let f = new d(t);
		f.setBegin(s), f.setEnd(c), f.setRegion(Fn(t, l)), En(u.join("\n").replace(/\x00/g, "�"), t, f), r.pushChild(f);
	}
	return t;
}
//#endregion
//#region src/imsc/namespaces.ts
var Ln, Rn, B, zn, Bn, Vn, Hn = n((() => {
	Ln = "http://www.w3.org/ns/ttml", Rn = "http://www.w3.org/ns/ttml#parameter", B = "http://www.w3.org/ns/ttml#styling", zn = "http://www.w3.org/ns/ttml/profile/imsc1#parameter", Bn = "http://www.w3.org/ns/ttml/profile/imsc1#styling", Vn = "urn:ebu:tt:style";
}));
//#endregion
//#region src/imsc/styleProperties.ts
function Un(e) {
	let { r: t, g: n, b: r, a: i } = e;
	return i === 255 ? `#${t.toString(16).padStart(2, "0")}${n.toString(16).padStart(2, "0")}${r.toString(16).padStart(2, "0")}` : `#${t.toString(16).padStart(2, "0")}${n.toString(16).padStart(2, "0")}${r.toString(16).padStart(2, "0")}${i.toString(16).padStart(2, "0")}`;
}
function Wn(e) {
	e = e.trim();
	let t = e.startsWith("#") ? e.slice(1) : null;
	if (t) {
		if (t.length === 6) return {
			r: parseInt(t.slice(0, 2), 16),
			g: parseInt(t.slice(2, 4), 16),
			b: parseInt(t.slice(4, 6), 16),
			a: 255
		};
		if (t.length === 8) return {
			r: parseInt(t.slice(0, 2), 16),
			g: parseInt(t.slice(2, 4), 16),
			b: parseInt(t.slice(4, 6), 16),
			a: parseInt(t.slice(6, 8), 16)
		};
	}
	let n = e.match(/^rgb\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*\)$/);
	return n ? {
		r: parseInt(n[1]),
		g: parseInt(n[2]),
		b: parseInt(n[3]),
		a: 255
	} : (n = e.match(/^rgba\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*\)$/), n ? {
		r: parseInt(n[1]),
		g: parseInt(n[2]),
		b: parseInt(n[3]),
		a: parseInt(n[4])
	} : {
		white: {
			r: 255,
			g: 255,
			b: 255,
			a: 255
		},
		black: {
			r: 0,
			g: 0,
			b: 0,
			a: 255
		},
		red: {
			r: 255,
			g: 0,
			b: 0,
			a: 255
		},
		lime: {
			r: 0,
			g: 255,
			b: 0,
			a: 255
		},
		blue: {
			r: 0,
			g: 0,
			b: 255,
			a: 255
		},
		yellow: {
			r: 255,
			g: 255,
			b: 0,
			a: 255
		},
		cyan: {
			r: 0,
			g: 255,
			b: 255,
			a: 255
		},
		magenta: {
			r: 255,
			g: 0,
			b: 255,
			a: 255
		},
		transparent: {
			r: 0,
			g: 0,
			b: 0,
			a: 0
		},
		green: {
			r: 0,
			g: 128,
			b: 0,
			a: 255
		},
		silver: {
			r: 192,
			g: 192,
			b: 192,
			a: 255
		},
		gray: {
			r: 128,
			g: 128,
			b: 128,
			a: 255
		},
		maroon: {
			r: 128,
			g: 0,
			b: 0,
			a: 255
		},
		purple: {
			r: 128,
			g: 0,
			b: 128,
			a: 255
		},
		fuchsia: {
			r: 255,
			g: 0,
			b: 255,
			a: 255
		},
		olive: {
			r: 128,
			g: 128,
			b: 0,
			a: 255
		},
		navy: {
			r: 0,
			g: 0,
			b: 128,
			a: 255
		},
		teal: {
			r: 0,
			g: 128,
			b: 128,
			a: 255
		},
		aqua: {
			r: 0,
			g: 255,
			b: 255,
			a: 255
		},
		orange: {
			r: 255,
			g: 165,
			b: 0,
			a: 255
		}
	}[e.toLowerCase()] ?? null);
}
function V(e) {
	let t = e.units === C.pct ? "%" : e.units;
	return `${Math.round(e.value * 1e4) / 1e4}${t}`;
}
function H(e) {
	e = e.trim();
	let t = [
		["%", C.pct],
		["em", C.em],
		["px", C.px],
		["rh", C.rh],
		["rw", C.rw],
		["c", C.c]
	];
	for (let [n, r] of t) if (e.endsWith(n)) {
		let t = parseFloat(e.slice(0, -n.length));
		if (!isNaN(t)) return {
			value: t,
			units: r
		};
	}
	return null;
}
var Gn, Kn, qn, Jn, Yn = n((() => {
	Hn(), F(), Gn = new Set([
		"default",
		"monospace",
		"monospaceSansSerif",
		"monospaceSerif",
		"proportionalSansSerif",
		"proportionalSerif",
		"sansSerif",
		"serif"
	]), Kn = [
		{
			ns: B,
			localName: "backgroundColor",
			modelProp: P.BackgroundColor,
			toTtml: (e) => Un(e),
			fromTtml: (e) => Wn(e)
		},
		{
			ns: B,
			localName: "color",
			modelProp: P.Color,
			toTtml: (e) => Un(e),
			fromTtml: (e) => Wn(e)
		},
		{
			ns: B,
			localName: "direction",
			modelProp: P.Direction,
			toTtml: (e) => e,
			fromTtml: (e) => e
		},
		{
			ns: B,
			localName: "display",
			modelProp: P.Display,
			toTtml: (e) => e,
			fromTtml: (e) => e
		},
		{
			ns: B,
			localName: "displayAlign",
			modelProp: P.DisplayAlign,
			toTtml: (e) => e,
			fromTtml: (e) => e
		},
		{
			ns: B,
			localName: "extent",
			modelProp: P.Extent,
			toTtml: (e) => {
				let t = e;
				return `${V(t.width)} ${V(t.height)}`;
			},
			fromTtml: (e) => {
				let t = e.trim().split(/\s+/);
				return t.length === 2 ? {
					width: H(t[0]),
					height: H(t[1])
				} : null;
			}
		},
		{
			ns: B,
			localName: "fontFamily",
			modelProp: P.FontFamily,
			toTtml: (e) => e.map((e) => Gn.has(e) ? e : `"${e.replace(/"/g, "\\\"")}"`).join(", "),
			fromTtml: (e) => e.split(",").map((e) => e.trim().replace(/^["']|["']$/g, ""))
		},
		{
			ns: B,
			localName: "fontSize",
			modelProp: P.FontSize,
			toTtml: (e) => V(e),
			fromTtml: (e) => H(e)
		},
		{
			ns: B,
			localName: "fontStyle",
			modelProp: P.FontStyle,
			toTtml: (e) => e,
			fromTtml: (e) => e
		},
		{
			ns: B,
			localName: "fontWeight",
			modelProp: P.FontWeight,
			toTtml: (e) => e,
			fromTtml: (e) => e
		},
		{
			ns: B,
			localName: "lineHeight",
			modelProp: P.LineHeight,
			toTtml: (e) => V(e),
			fromTtml: (e) => H(e)
		},
		{
			ns: Vn,
			localName: "linePadding",
			modelProp: P.LinePadding,
			toTtml: (e) => V(e),
			fromTtml: (e) => H(e)
		},
		{
			ns: B,
			localName: "opacity",
			modelProp: P.Opacity,
			toTtml: (e) => String(e),
			fromTtml: (e) => parseFloat(e)
		},
		{
			ns: B,
			localName: "origin",
			modelProp: P.Origin,
			toTtml: (e) => {
				let t = e;
				return `${V(t.x)} ${V(t.y)}`;
			},
			fromTtml: (e) => {
				let t = e.trim().split(/\s+/);
				return t.length === 2 ? {
					x: H(t[0]),
					y: H(t[1])
				} : null;
			}
		},
		{
			ns: B,
			localName: "overflow",
			modelProp: P.Overflow,
			toTtml: (e) => e,
			fromTtml: (e) => e
		},
		{
			ns: B,
			localName: "padding",
			modelProp: P.Padding,
			toTtml: (e) => {
				let t = e;
				return `${V(t.before)} ${V(t.end)} ${V(t.after)} ${V(t.start)}`;
			},
			fromTtml: (e) => {
				let t = e.trim().split(/\s+/);
				return t.length === 4 ? {
					before: H(t[0]),
					end: H(t[1]),
					after: H(t[2]),
					start: H(t[3])
				} : null;
			}
		},
		{
			ns: B,
			localName: "showBackground",
			modelProp: P.ShowBackground,
			toTtml: (e) => e,
			fromTtml: (e) => e
		},
		{
			ns: B,
			localName: "textAlign",
			modelProp: P.TextAlign,
			toTtml: (e) => e,
			fromTtml: (e) => e
		},
		{
			ns: B,
			localName: "textDecoration",
			modelProp: P.TextDecoration,
			toTtml: (e) => {
				let t = e, n = [];
				return t.underline && n.push("underline"), t.overline && n.push("overline"), t.lineThrough && n.push("lineThrough"), n.length > 0 ? n.join(" ") : null;
			},
			fromTtml: (e) => ({
				underline: e.includes("underline"),
				overline: e.includes("overline"),
				lineThrough: e.includes("lineThrough") || e.includes("line-through")
			})
		},
		{
			ns: B,
			localName: "unicodeBidi",
			modelProp: P.UnicodeBidi,
			toTtml: (e) => e,
			fromTtml: (e) => e
		},
		{
			ns: B,
			localName: "visibility",
			modelProp: P.Visibility,
			toTtml: (e) => e,
			fromTtml: (e) => e
		},
		{
			ns: B,
			localName: "wrapOption",
			modelProp: P.WrapOption,
			toTtml: (e) => e,
			fromTtml: (e) => e
		},
		{
			ns: B,
			localName: "writingMode",
			modelProp: P.WritingMode,
			toTtml: (e) => e,
			fromTtml: (e) => e
		},
		{
			ns: Bn,
			localName: "fillLineGap",
			modelProp: P.FillLineGap,
			toTtml: (e) => e,
			fromTtml: (e) => e
		},
		{
			ns: B,
			localName: "ruby",
			modelProp: P.Ruby,
			toTtml: (e) => e,
			fromTtml: (e) => e
		},
		{
			ns: B,
			localName: "fontVariant",
			modelProp: P.FontVariant,
			toTtml: (e) => e,
			fromTtml: (e) => e
		},
		{
			ns: B,
			localName: "shear",
			modelProp: P.Shear,
			toTtml: (e) => `${e}%`,
			fromTtml: (e) => {
				if (!e.endsWith("%")) return null;
				let t = parseFloat(e.slice(0, -1));
				return isNaN(t) ? null : Math.max(-100, Math.min(100, t));
			}
		},
		{
			ns: Vn,
			localName: "multiRowAlign",
			modelProp: P.MultiRowAlign,
			toTtml: (e) => e,
			fromTtml: (e) => e
		},
		{
			ns: B,
			localName: "luminanceGain",
			modelProp: P.LuminanceGain,
			toTtml: (e) => String(e),
			fromTtml: (e) => {
				let t = parseFloat(e);
				return isNaN(t) || t < 0 ? null : t;
			}
		},
		{
			ns: B,
			localName: "rubyAlign",
			modelProp: P.RubyAlign,
			toTtml: (e) => e,
			fromTtml: (e) => e
		},
		{
			ns: B,
			localName: "rubyPosition",
			modelProp: P.RubyPosition,
			toTtml: (e) => e,
			fromTtml: (e) => e
		},
		{
			ns: B,
			localName: "textCombine",
			modelProp: P.TextCombine,
			toTtml: (e) => e,
			fromTtml: (e) => e
		},
		{
			ns: B,
			localName: "textOutline",
			modelProp: P.TextOutline,
			toTtml: (e) => {
				if (typeof e == "string") return null;
				let t = e, n = [];
				return t.color && n.push(Un(t.color)), n.push(V(t.thickness)), n.join(" ");
			},
			fromTtml: (e) => {
				if (e = e.trim(), e === "none") return null;
				let t = e.split(/\s+/);
				if (t.length === 1) {
					let e = H(t[0]);
					return e ? { thickness: e } : null;
				}
				if (t.length >= 2) {
					let e = Wn(t[0]), n = H(e ? t[1] : t[0]);
					return n ? e ? {
						color: e,
						thickness: n
					} : { thickness: n } : null;
				}
				return null;
			}
		},
		{
			ns: B,
			localName: "textShadow",
			modelProp: P.TextShadow,
			toTtml: (e) => typeof e == "string" ? null : e.shadows.map((e) => {
				let t = [V(e.xOffset), V(e.yOffset)];
				return e.blurRadius && t.push(V(e.blurRadius)), e.color && t.push(Un(e.color)), t.join(" ");
			}).join(", ") || null,
			fromTtml: (e) => {
				if (e = e.trim(), e === "none") return null;
				let t = e.split(",").map((e) => {
					let t = e.trim().split(/\s+/), n = [], r;
					for (let e of t) {
						let t = H(e);
						if (t) {
							n.push(t);
							continue;
						}
						let i = Wn(e);
						i && (r = i);
					}
					return n.length < 2 ? null : {
						xOffset: n[0],
						yOffset: n[1],
						blurRadius: n[2],
						color: r
					};
				}).filter(Boolean);
				return t.length > 0 ? { shadows: t } : null;
			}
		},
		{
			ns: B,
			localName: "textEmphasis",
			modelProp: P.TextEmphasis,
			toTtml: (e) => {
				if (typeof e == "string") return null;
				let t = e, n = [];
				return t.filled !== void 0 && n.push(t.filled ? "filled" : "open"), n.push(t.style ?? oe.auto), t.color && n.push(Un(t.color)), t.position && n.push(t.position), n.join(" ") || null;
			},
			fromTtml: (e) => {
				if (e = e.trim(), e === "none") return null;
				if (e === "auto") return { style: oe.auto };
				let t = e.split(/\s+/), n = oe.auto, r, i, a;
				for (let e of t) {
					if (e === "filled") {
						r = !0;
						continue;
					}
					if (e === "open") {
						r = !1;
						continue;
					}
					if (e === "before" || e === "after") {
						a = e;
						continue;
					}
					let t = Wn(e);
					if (t) {
						i = t;
						continue;
					}
					Object.values(oe).includes(e) && (n = e);
				}
				return {
					style: n,
					color: i,
					position: a,
					filled: r
				};
			}
		}
	], qn = {}, Jn = {};
	for (let e of Kn) qn[e.modelProp] = e, Jn[`{${e.ns}}${e.localName}`] = e;
}));
v(), F(), Yn(), Hn(), we();
var Xn = {
	fpsN: 30,
	fpsD: 1,
	tickRate: 1,
	timeBase: "media",
	dropMode: "nonDrop"
}, Zn = new Set([P.Ruby]);
function Qn(e) {
	let t = e.getAttributeNS("http://www.w3.org/ns/ttml#parameter", "frameRate") ?? e.getAttribute("ttp:frameRate"), n = t && parseInt(t) || 30, r = e.getAttributeNS("http://www.w3.org/ns/ttml#parameter", "frameRateMultiplier") ?? e.getAttribute("ttp:frameRateMultiplier"), i = 1, a = 1;
	if (r) {
		let e = r.match(/^(\d+)\s+(\d+)$/);
		e && (i = parseInt(e[1]), a = parseInt(e[2]));
	}
	let o = e.getAttributeNS("http://www.w3.org/ns/ttml#parameter", "tickRate") ?? e.getAttribute("ttp:tickRate"), s = o && parseInt(o) || 1, c = e.getAttributeNS("http://www.w3.org/ns/ttml#parameter", "timeBase") ?? e.getAttribute("ttp:timeBase"), l = c === "smpte" ? "smpte" : c === "clock" ? "clock" : "media", u = e.getAttributeNS("http://www.w3.org/ns/ttml#parameter", "dropMode") ?? e.getAttribute("ttp:dropMode"), d = u === "dropNtsc" ? "dropNtsc" : u === "dropPal" ? "dropPal" : "nonDrop";
	return {
		fpsN: n * i,
		fpsD: a,
		tickRate: s,
		timeBase: l,
		dropMode: d
	};
}
function $n(e, t = Xn) {
	if (!e) return null;
	e = e.trim();
	let n = e.match(/^(\d+):(\d{2}):(\d{2})\.(\d+)$/);
	if (n) return new o(parseInt(n[1]) * 36e5 + parseInt(n[2]) * 6e4 + parseInt(n[3]) * 1e3 + Math.round(parseFloat("0." + n[4]) * 1e3), 1e3);
	if (n = e.match(/^(\d+):(\d{2}):(\d{2})$/), n) return new o(parseInt(n[1]) * 3600 + parseInt(n[2]) * 60 + parseInt(n[3]), 1);
	if (n = e.match(/^(\d+(?:\.\d+)?)f$/), n) return new o(Math.round(parseFloat(n[1]) * t.fpsD), t.fpsN);
	if (n = e.match(/^(\d+)t$/), n) return new o(parseInt(n[1]), t.tickRate);
	if (n = e.match(/^(\d+(?:\.\d+)?)ms$/), n) return o.fromNumber(parseFloat(n[1]) / 1e3);
	if (n = e.match(/^(\d+(?:\.\d+)?)s$/), n) return o.fromNumber(parseFloat(n[1]));
	if (n = e.match(/^(\d+(?:\.\d+)?)m$/), n) return o.fromNumber(parseFloat(n[1]) * 60);
	if (n = e.match(/^(\d+(?:\.\d+)?)h$/), n) return o.fromNumber(parseFloat(n[1]) * 3600);
	if (n = e.match(/^(\d+):(\d{2}):(\d{2})[;:](\d{2})$/), n) {
		let e = parseInt(n[1]), r = parseInt(n[2]), i = parseInt(n[3]), a = parseInt(n[4]);
		if (t.timeBase === "smpte") {
			let n = t.dropMode !== "nonDrop";
			return new o(new Ce(e, r, i, a, new o(t.fpsN, t.fpsD), n).toFrames() * t.fpsD, t.fpsN);
		}
		return new o((e * 3600 + r * 60 + i) * t.fpsN + a * t.fpsD, t.fpsN);
	}
	return null;
}
function er(e) {
	if (typeof DOMParser < "u") return new DOMParser().parseFromString(e, "text/xml");
	try {
		let { DOMParser: t } = i("@xmldom/xmldom");
		return new t().parseFromString(e, "text/xml");
	} catch {
		throw Error("No XML parser found. Install @xmldom/xmldom or patch globalThis.DOMParser before calling ttmlToModel.");
	}
}
function tr(e) {
	let t = /* @__PURE__ */ new Map();
	for (let n of Array.from(e.getElementsByTagNameNS("*", "style"))) {
		let e = n.getAttribute("xml:id") ?? n.getAttribute("id");
		e && t.set(e, n);
	}
	return t;
}
function nr(e, t, n, r, i) {
	if (r.has(e)) return;
	r.add(e);
	let a = n.get(e);
	if (!a) return;
	let o = a.getAttribute("style");
	if (o) for (let e of o.trim().split(/\s+/)) nr(e, t, n, r, i);
	fr(a, t, i);
}
function rr(e, t, n, r) {
	let i = e.getAttribute("style");
	if (i) {
		let e = /* @__PURE__ */ new Set();
		for (let a of i.trim().split(/\s+/)) nr(a, t, n, e, r);
	}
	fr(e, t);
}
var ir = b(0, C.pct), ar = b(50, C.pct);
function or(e) {
	let t = new Set(["left", "right"]), n = new Set(["top", "bottom"]), r = e.trim().split(/\s+/);
	if (r.length === 0 || r.length > 4) return null;
	let i = null, a = null, o = null, s = null, c = [...r];
	if (r.length <= 2) for (; c.length > 0;) {
		let e = c.shift().toLowerCase();
		if (t.has(e)) i = e, a = ir;
		else if (n.has(e)) o = e, s = ir;
		else if (e === "center") i === null ? (i = "left", a = ar) : o === null && (o = "top", s = ar);
		else {
			let t = H(e);
			if (!t) return null;
			i === null ? (i = "left", a = t) : o === null && (o = "top", s = t);
		}
	}
	else for (; c.length > 0;) {
		let e = c.shift().toLowerCase();
		if (t.has(e)) i = e, o !== null && s === null && (s = ir);
		else if (n.has(e)) o = e, i !== null && a === null && (a = ir);
		else if (e !== "center") {
			let t = H(e);
			if (!t) return null;
			i !== null && a === null && (a = t), o !== null && s === null && (s = t);
		}
	}
	return a === null && (i === null ? (i = "left", a = ar) : a = ir), s === null && (o === null ? (o = "top", s = ar) : s = ir), {
		hEdge: i ?? "left",
		hOffset: a,
		vEdge: o ?? "top",
		vOffset: s
	};
}
function sr(e, t, n) {
	return e ? e.units === C.pct ? e.value * t / 100 : e.units === C.rh ? e.value : e.units === C.px ? n > 0 ? e.value * 100 / n : 0 : e.value : 0;
}
function cr(e, t, n) {
	return e ? e.units === C.pct ? e.value * t / 100 : e.units === C.rw ? e.value : e.units === C.px ? n > 0 ? e.value * 100 / n : 0 : e.value : 0;
}
function lr(e, t) {
	let n = e.getAttributeNS("http://www.w3.org/ns/ttml#styling", "position") ?? e.getAttribute("tts:position");
	if (n) return n;
	let r = e.getAttribute("style");
	if (r) {
		let e = null;
		for (let n of r.trim().split(/\s+/)) {
			let r = t.get(n);
			if (r) {
				let t = r.getAttributeNS("http://www.w3.org/ns/ttml#styling", "position") ?? r.getAttribute("tts:position");
				t && (e = t);
			}
		}
		if (e) return e;
	}
	return null;
}
function ur(e, t, n, r, i) {
	let a = lr(e, n);
	if (!a) return;
	let o = or(a);
	if (!o) return;
	let s = t.getStyle(P.Extent);
	if (!s) return;
	let c = sr(s.height, 100, i), l = cr(s.width, 100, r), u = sr(o.vOffset, 100 - c, i);
	o.vEdge === "bottom" && (u = 100 - u);
	let d = cr(o.hOffset, 100 - l, r);
	o.hEdge === "right" && (d = 100 - d), t.setStyle(P.Origin, {
		x: b(d, C.rw),
		y: b(u, C.rh)
	});
}
var dr = {
	[B]: "tts",
	[Vn]: "ebutts",
	[Bn]: "itts"
};
function fr(e, t, n) {
	for (let [r, i] of Object.entries(Jn)) {
		if (n?.has(i.modelProp)) continue;
		let a = r.match(/^\{([^}]+)\}(.+)$/);
		if (!a) continue;
		let [, o, s] = a, c = e.getAttributeNS(o, s);
		if (c == null) {
			let t = dr[o];
			t && (c = e.getAttribute(`${t}:${s}`));
		}
		if (c == null) continue;
		let l = i.fromTtml(c);
		l != null && t.setStyle(i.modelProp, l);
	}
}
function pr(e, t, n, r, i = Xn, a = new o(0), c = null) {
	for (let l of Array.from(e.childNodes)) if (l.nodeType === 3) {
		let e = l.data;
		if (e.length > 0) if (n instanceof d) {
			let r = new f(t);
			r.pushChild(new m(t, e)), n.pushChild(r);
		} else n.pushChild(new m(t, e));
	} else if (l.nodeType === 1) {
		let e = l, u = e.localName;
		if (u === "span") {
			let l = new f(t);
			rr(e, l, r, Zn), e.getAttribute("xml:space") === "preserve" && l.setSpace(s.PRESERVE);
			let u = $n(e.getAttribute("begin") ?? "", i), d = $n(e.getAttribute("end") ?? "", i), p = $n(e.getAttribute("dur") ?? "", i), m = d;
			if (p !== null) {
				let e = (u ?? new o(0)).add(p);
				m = d !== null && d.lessThan(e) ? d : e;
			}
			u && l.setBegin(u), m && l.setEnd(m), pr(e, t, l, r, i, u === null ? a : a.add(u), m === null ? c : a.add(m)), n.pushChild(l);
		} else if (u === "br") n.pushChild(new p(t));
		else if (u === "set") {
			let t = $n(e.getAttribute("begin") ?? "", i), r = $n(e.getAttribute("end") ?? "", i), s = $n(e.getAttribute("dur") ?? "", i), l = t === null ? a : a.add(t), u;
			if (s !== null) {
				let e = l.add(s), t = r === null ? null : a.add(r);
				u = t !== null && t.lessThan(e) ? t : e;
			} else u = r === null ? c ?? new o(1e9, 1) : a.add(r);
			c !== null && c.lessThan(u) && (u = c);
			for (let [t, r] of Object.entries(Jn)) {
				let i = t.match(/^\{([^}]+)\}(.+)$/);
				if (!i) continue;
				let [, a, o] = i, s = e.getAttributeNS(a, o);
				if (s == null) {
					let t = dr[a];
					t && (s = e.getAttribute(`${t}:${o}`));
				}
				if (s == null) continue;
				let c = r.fromTtml(s);
				c != null && n.addAnimationStep({
					styleProperty: r.modelProp,
					begin: l,
					end: u,
					value: c
				});
			}
		}
	}
}
function mr(e) {
	let t = e.parentElement;
	for (; t;) {
		let e = t.getAttribute("region");
		if (e) return e;
		t = t.parentElement;
	}
	return null;
}
function hr(e) {
	let t = er(e), n = new _(), r = t.documentElement, i = r.getAttribute("xml:lang") ?? "";
	n.setLang(i);
	let a = Qn(r), s = r.getAttributeNS("http://www.w3.org/ns/ttml#parameter", "cellResolution") ?? r.getAttribute("ttp:cellResolution");
	if (s) {
		let e = s.match(/^(\d+)\s+(\d+)$/);
		e && n.setCellResolution({
			columns: parseInt(e[1]),
			rows: parseInt(e[2])
		});
	}
	let c = r.getAttributeNS("http://www.w3.org/ns/ttml/profile/imsc1#parameter", "activeArea") ?? r.getAttribute("ittp:activeArea");
	if (c) {
		let e = c.trim().split(/\s+/);
		if (e.length === 4) {
			let t = e.map((e) => parseFloat(e) / 100);
			t.every((e) => !isNaN(e)) && n.setActiveArea({
				leftOffset: t[0],
				topOffset: t[1],
				width: t[2],
				height: t[3]
			});
		}
	}
	let f = 0, p = 0, m = r.getAttributeNS("http://www.w3.org/ns/ttml#styling", "extent") ?? r.getAttribute("tts:extent");
	if (m) {
		let e = m.trim().split(/\s+/);
		if (e.length === 2) {
			let t = H(e[0]), r = H(e[1]);
			t && r && t.units === C.px && r.units === C.px && (f = t.value, p = r.value, n.setPxResolution({
				width: f,
				height: p
			}));
		}
	}
	let g = tr(t), v = t.getElementsByTagNameNS("*", "region"), y = v.length > 0;
	for (let e of Array.from(v)) {
		let t = e.getAttribute("xml:id") ?? e.getAttribute("id") ?? "";
		if (!t) continue;
		let r = new h(t);
		rr(e, r, g);
		for (let t of Array.from(e.childNodes)) if (t.nodeType === 1) {
			let e = t;
			e.localName === "style" && fr(e, r);
		}
		r.getStyle(P.Extent) || r.setStyle(P.Extent, {
			width: b(100, C.pct),
			height: b(100, C.pct)
		}), ur(e, r, g, f, p), r.getStyle(P.Origin) || r.setStyle(P.Origin, {
			x: b(0, C.pct),
			y: b(0, C.pct)
		}), n.putRegion(r);
	}
	if (Array.from(n.iterRegions()).length === 0) {
		let e = new h("r0");
		e.setStyle(P.Origin, {
			x: b(0, C.pct),
			y: b(0, C.pct)
		}), e.setStyle(P.Extent, {
			width: b(100, C.pct),
			height: b(100, C.pct)
		}), n.putRegion(e);
	}
	let x = new l(n);
	n.setBody(x);
	let S = t.getElementsByTagNameNS("*", "body");
	S.length > 0 && rr(S[0], x, g);
	let w = t.getElementsByTagNameNS("*", "initial");
	for (let e of Array.from(w)) fr(e, x);
	function T(e, t, r, i) {
		let s = $n(e.getAttribute("begin") ?? "", a), c = $n(e.getAttribute("end") ?? "", a), l = $n(e.getAttribute("dur") ?? "", a), u, f;
		if (r === "seq") if (u = i.add(s ?? new o(0)), l !== null) {
			let e = u.add(l), t = c === null ? null : i.add(c);
			f = t !== null && t.lessThan(e) ? t : e;
		} else f = c === null ? null : i.add(c);
		else if (u = s ?? new o(0), l !== null) {
			let e = u.add(l);
			f = c !== null && c.lessThan(e) ? c : e;
		} else f = c;
		let p = e.getAttribute("region") ?? mr(e), m = null;
		if (p) {
			for (let e of n.iterRegions()) if (e.getId() === p) {
				m = e;
				break;
			}
		}
		if (!m && !y) for (let e of n.iterRegions()) {
			m = e;
			break;
		}
		if (!m) return f ?? i;
		let h = new d(n);
		return (s !== null || r === "seq") && (u.numerator !== 0 || u.denominator !== 1 || r === "seq") && h.setBegin(u), f && h.setEnd(f), h.setRegion(m), rr(e, h, g), pr(e, n, h, g, a, u, f), t.pushChild(h), f ?? i;
	}
	function E(e, t) {
		let r = new u(n);
		rr(e, r, g);
		let i = $n(e.getAttribute("begin") ?? "", a), s = $n(e.getAttribute("end") ?? "", a);
		i && r.setBegin(i), s && r.setEnd(s), t.pushChild(r);
		let c = e.getAttribute("timeContainer") ?? "par", l = i ?? new o(0);
		for (let t of Array.from(e.childNodes)) {
			if (t.nodeType !== 1) continue;
			let e = t;
			e.localName === "p" ? l = T(e, r, c, l) : e.localName === "div" && E(e, r);
		}
	}
	let D = t.getElementsByTagNameNS("*", "body")[0];
	if (D) for (let e of Array.from(D.childNodes)) e.nodeType === 1 && e.localName === "div" && E(e, x);
	else {
		let e = new u(n);
		x.pushChild(e);
		for (let n of Array.from(t.getElementsByTagNameNS("*", "p"))) T(n, e, "par", new o(0));
	}
	return n;
}
//#endregion
//#region src/isd.ts
function gr(e, t, n = new o(0)) {
	let r = e.getBegin(), i = e.getEnd(), a = r === null ? null : n.add(r), s = i === null ? null : n.add(i);
	return !(a !== null && t.lessThan(a) || s !== null && !t.lessThan(s));
}
function _r(e, t, n) {
	for (let r of e.iterAnimationSteps()) if (r.styleProperty === t && !n.lessThan(r.begin) && n.lessThan(r.end)) return r.value;
	return e.getStyle(t);
}
function vr(e, t, n, r, i) {
	let a = Object.values(P).filter((e) => typeof e == "string");
	for (let t of a) {
		let a = _r(e, t, n);
		a === void 0 && (P.INHERITED.has(t) && i !== null && (a = i.get(t)), a === void 0 && (a = P.INITIAL_VALUES[t])), a !== void 0 && r.setStyle(t, a);
	}
}
function yr(e, t, n = !1) {
	for (let r of e.getChildren()) r.kind === "text" || r.kind === "br" ? t.push([r, n]) : yr(r, t, n || r.getSpace() === s.PRESERVE);
}
function br(e) {
	if (e.kind === "br") return !0;
	let t = e.getText() ?? "";
	return t.length === 0 || t[t.length - 1] === " ";
}
function xr(e) {
	if (e.kind === "br") return !0;
	let t = e.getText() ?? "";
	return t.length > 0 && (t[0] === "\r" || t[0] === "\n");
}
function Sr(e) {
	let t = [];
	if (yr(e, t), t.length === 0) return;
	let n = 0;
	for (; n < t.length;) {
		let [e, r] = t[n];
		if (e.kind === "br" || r) {
			n++;
			continue;
		}
		let i = (e.getText() ?? "").replace(/[\t\r\n ]+/g, " ");
		i[0] === " " && (n === 0 || br(t[n - 1][0])) && (i = i.slice(1)), e.setText(i), i === "" ? t.splice(n, 1) : n++;
	}
	for (let e = 0; e < t.length; e++) {
		let [n, r] = t[e];
		if (n.kind === "br" || r) continue;
		let i = n.getText() ?? "";
		if (i.endsWith(" ")) {
			let r = e + 1 < t.length ? t[e + 1][0] : null;
			(r === null || xr(r)) && n.setText(i.slice(0, -1));
		}
	}
}
function Cr(e, t, n, r, i, a = new o(0)) {
	if (!gr(e, n, a)) return null;
	let s = e.getBegin(), c = s === null ? a : a.add(s), l = new Tr(r);
	if (e instanceof m) return l.setText(e.getText()), l;
	let h = e.getSpace();
	h !== null && l.setSpace(h);
	for (let t of e.iterStyles()) {
		let r = _r(e, t, n);
		r !== void 0 && l.setStyle(t, r);
	}
	for (let t of e.iterAnimationSteps()) l.getStyle(t.styleProperty) === void 0 && !n.lessThan(t.begin) && n.lessThan(t.end) && l.setStyle(t.styleProperty, t.value);
	if (l.getStyle(P.Display) === ee.none) return null;
	if (i) for (let [e, t] of i) P.INHERITED.has(e) && l.getStyle(e) === void 0 && l.setStyle(e, t);
	let g = /* @__PURE__ */ new Map();
	for (let [e, t] of l.iterStyles()) g.set(e, t);
	for (let r of e.iterChildren()) {
		let e = "span";
		if (r instanceof u) e = "div";
		else if (r instanceof d) {
			e = "p";
			let n = r.getRegion();
			if (n !== null && n.getId() !== t.getId()) continue;
		} else r instanceof f ? e = "span" : r instanceof p ? e = "br" : r instanceof m && (e = "text");
		let i = Cr(r, t, n, e, g, c);
		i !== null && l.pushChild(i);
	}
	return r === "p" && Sr(l), l;
}
var wr, Tr, Er, Dr = n((() => {
	v(), F(), wr = class {
		constructor(e) {
			this._styles = /* @__PURE__ */ new Map(), this._children = [], this.id = e;
		}
		setStyle(e, t) {
			this._styles.set(e, t);
		}
		getStyle(e) {
			return this._styles.get(e);
		}
		iterStyles() {
			return this._styles.keys();
		}
		pushChild(e) {
			this._children.push(e);
		}
		getChildren() {
			return this._children;
		}
		isEmpty() {
			return this._children.length === 0;
		}
	}, Tr = class {
		constructor(e) {
			this._styles = /* @__PURE__ */ new Map(), this._children = [], this._text = null, this._space = null, this._lang = null, this.kind = e;
		}
		setStyle(e, t) {
			this._styles.set(e, t);
		}
		getStyle(e) {
			return this._styles.get(e);
		}
		iterStyles() {
			return this._styles.entries();
		}
		pushChild(e) {
			this._children.push(e);
		}
		getChildren() {
			return this._children;
		}
		getText() {
			return this._text;
		}
		setText(e) {
			this._text = e;
		}
		setSpace(e) {
			this._space = e;
		}
		getSpace() {
			return this._space;
		}
		setLang(e) {
			this._lang = e;
		}
		getLang() {
			return this._lang;
		}
	}, Er = class e extends _ {
		constructor(...e) {
			super(...e), this._isdRegions = /* @__PURE__ */ new Map();
		}
		putISDRegion(e) {
			this._isdRegions.set(e.id, e);
		}
		getISDRegion(e) {
			return this._isdRegions.get(e);
		}
		*iterISDRegions() {
			yield* this._isdRegions.values();
		}
		static significantTimes(e) {
			let t = /* @__PURE__ */ new Set(), n = /* @__PURE__ */ new Map();
			function r(e) {
				if (e !== null) {
					let r = `${e.numerator}/${e.denominator}`;
					n.set(r, e), t.add(r);
				}
			}
			for (let t of e.iterRegions()) {
				r(t.getBegin()), r(t.getEnd());
				for (let e of t.iterAnimationSteps()) r(e.begin), r(e.end);
			}
			let i = e.getBody();
			if (i !== null) {
				function e(t, n) {
					let i = t.getBegin(), a = t.getEnd(), o = i === null ? n : n.add(i), s = a === null ? null : n.add(a);
					if (!(s !== null && !o.lessThan(s))) {
						i !== null && r(o), a !== null && r(s);
						for (let e of t.iterAnimationSteps()) r(e.begin), r(e.end);
						for (let n of t.iterChildren()) e(n, o);
					}
				}
				e(i, new o(0));
			}
			(e.getBody() !== null || Array.from(e.iterRegions()).length > 0) && r(new o(0));
			let a = Array.from(n.values());
			return a.sort((e, t) => e.toNumber() - t.toNumber()), a;
		}
		static fromModel(t, n) {
			let r = new e();
			r.setLang(t.getLang()), r.setCellResolution(t.getCellResolution()), t.getPxResolution() && r.setPxResolution(t.getPxResolution()), t.getActiveArea() && r.setActiveArea(t.getActiveArea());
			let i = t.getBody();
			if (i === null) return r;
			for (let e of t.iterRegions()) {
				if (!gr(e, n)) continue;
				let t = new wr(e.getId() ?? "");
				vr(e, null, n, t, null);
				let a = /* @__PURE__ */ new Map();
				for (let e of t.iterStyles()) {
					let n = t.getStyle(e);
					n !== void 0 && a.set(e, n);
				}
				let o = Cr(i, e, n, "body", a);
				o !== null && o.getChildren().length > 0 && (t.pushChild(o), r.putISDRegion(t));
			}
			return r;
		}
		static generateISDSequence(t) {
			return e.significantTimes(t).map((n) => [n, e.fromModel(t, n)]);
		}
	};
})), Or, kr = n((() => {
	Dr(), Or = class {
		process(e) {
			let t = Array.from(e.iterISDRegions()), n = t.reduce((e, t) => e + t.getChildren().length, 0);
			if (t.length <= 1 || n <= 1) return e;
			let r = new Tr("body"), i = [];
			for (let e of t) {
				for (let t of e.getChildren()) for (let e of t.getChildren()) r.pushChild(e);
				i.push(e.id);
			}
			let a = e._isdRegions;
			for (let e of i) a.delete(e);
			let o = new wr(i.join("_"));
			return o.pushChild(r), e.putISDRegion(o), e;
		}
	};
})), Ar, jr = n((() => {
	Dr(), Ar = class {
		process(e) {
			for (let t of e.iterISDRegions()) this._processRegion(t);
			return e;
		}
		_getParagraphs(e) {
			let t = [];
			for (let n of e.getChildren()) n.kind === "div" ? t.push(...this._getParagraphs(n)) : n.kind === "p" && t.push(n);
			return t;
		}
		_processRegion(e) {
			for (let t of e.getChildren()) t.kind === "body" && this._processBody(t);
		}
		_processBody(e) {
			let t = e.getChildren().filter((e) => e.kind === "div"), n = [];
			for (let e of t) n.push(...this._getParagraphs(e));
			if (n.length <= 1) return;
			let r = new Tr("div"), i = new Tr("p");
			r.pushChild(i);
			for (let e = 0; e < n.length; e++) {
				e > 0 && i.pushChild(new Tr("br"));
				for (let t of n[e].getChildren()) i.pushChild(t);
			}
			e._children = [...e.getChildren().filter((e) => e.kind !== "div"), r];
		}
	};
})), Mr, Nr, Pr, Fr, Ir = n((() => {
	Mr = class {
		constructor(e) {
			this._supportedProps = new Set(e);
		}
		process(e) {
			for (let t of e.iterISDRegions()) this._filterRegion(t);
			return e;
		}
		_filterRegion(e) {
			let t = [];
			for (let n of e.iterStyles()) this._supportedProps.has(n) || t.push(n);
			let n = e._styles;
			for (let e of t) n.delete(e);
			for (let t of e.getChildren()) this._filterElement(t);
		}
		_filterElement(e) {
			let t = [];
			for (let [n] of e.iterStyles()) this._supportedProps.has(n) || t.push(n);
			let n = e._styles;
			for (let e of t) n.delete(e);
			for (let t of e.getChildren()) this._filterElement(t);
		}
	}, Nr = [
		"FontWeight",
		"FontStyle",
		"TextDecoration",
		"Color"
	], Pr = [
		"FontWeight",
		"FontStyle",
		"TextDecoration",
		"Color",
		"BackgroundColor"
	], Fr = [
		"FontWeight",
		"FontStyle",
		"TextDecoration",
		"Color",
		"BackgroundColor",
		"Origin",
		"Extent",
		"DisplayAlign",
		"TextAlign",
		"Direction"
	];
}));
//#endregion
//#region src/filters/isd/defaultStyleProperties.ts
function Lr(e, t) {
	if (e === t) return !0;
	if (typeof e != typeof t) return !1;
	if (typeof e == "object" && e && t !== null) {
		let n = Object.keys(e), r = Object.keys(t);
		return n.length === r.length ? n.every((n) => Lr(e[n], t[n])) : !1;
	}
	return !1;
}
var Rr, zr = n((() => {
	F(), Rr = class {
		constructor(e = /* @__PURE__ */ new Set(), t = /* @__PURE__ */ new Map()) {
			this._excludeProps = e, this._overrideInitialValues = t;
		}
		process(e) {
			for (let t of e.iterISDRegions()) this._filterRegion(t);
			return e;
		}
		_getDefaultVal(e) {
			return this._overrideInitialValues.has(e) ? this._overrideInitialValues.get(e) : P.INITIAL_VALUES[e];
		}
		_filterRegion(e) {
			let t = [];
			for (let n of e.iterStyles()) {
				if (this._excludeProps.has(n)) continue;
				let r = e.getStyle(n), i = this._getDefaultVal(n);
				i !== void 0 && Lr(r, i) && t.push(n);
			}
			let n = e._styles;
			for (let e of t) n.delete(e);
			for (let t of e.getChildren()) this._filterElement(t);
		}
		_filterElement(e) {
			let t = [];
			for (let [n, r] of e.iterStyles()) {
				if (this._excludeProps.has(n)) continue;
				let e = this._getDefaultVal(n);
				e !== void 0 && Lr(r, e) && t.push(n);
			}
			let n = e._styles;
			for (let e of t) n.delete(e);
			for (let t of e.getChildren()) this._filterElement(t);
		}
	};
})), Br, Vr = n((() => {
	F(), Br = class {
		process(e) {
			for (let t of e.iterISDRegions()) this._filterChildren(t.getChildren());
			return e;
		}
		_filterChildren(e) {
			for (let t = e.length - 1; t >= 0; t--) {
				let n = e[t];
				n.getStyle(P.Ruby) === void 0 ? this._filterChildren(n.getChildren()) : e.splice(t, 1);
			}
		}
	};
})), Hr, Ur = n((() => {
	we(), Hr = class e {
		static {
			this.EOL_SEQ_RE = /\n{2,}/g;
		}
		constructor(e) {
			this._begin = null, this._end = null, this._text = "", this._id = e;
		}
		setBegin(e) {
			this._begin = Se.fromSeconds(e), this._begin.setSeparator(",");
		}
		getBegin() {
			return this._begin;
		}
		setEnd(e) {
			e === null ? this._end = null : (this._end = Se.fromSeconds(e), this._end.setSeparator(","));
		}
		getEnd() {
			return this._end;
		}
		isOnlyWhitespace() {
			return this._text.length === 0 || this._text.trim().length === 0;
		}
		normalizeEol() {
			this._text = this._text.replace(e.EOL_SEQ_RE, "\n").replace(/^[\n\r]+|[\n\r]+$/g, "");
		}
		appendText(e) {
			this._text += e;
		}
		toString(e) {
			if (this._begin === null) throw Error("SRT paragraph begin time code must be set.");
			if (this._end === null) throw Error("SRT paragraph end time code must be set.");
			let t = this._begin.toSeconds();
			if (this._end.toSeconds() <= t) throw Error("SRT paragraph end time code must be greater than the begin time code.");
			return `${e === void 0 ? this._id : e}\n${this._begin} --> ${this._end}\n${this._text}` + (this._text ? "\n" : "");
		}
	};
})), Wr, Gr, Kr, qr, Jr = n((() => {
	F(), Wr = "</b>", Gr = "</i>", Kr = "</u>", qr = "</font>";
})), Yr = /* @__PURE__ */ r({ srtFromModel: () => Qr });
function Xr(e, t) {
	if (e.kind === "text") return e.getText() ?? "";
	if (e.kind === "br") return "\n";
	let n = e.getChildren().map((e) => Xr(e, t)).join("");
	if (!t) return n;
	let r = "", i = "", a = e.getStyle(P.Color);
	return a && t && (r = `<font color="${`#${a.r.toString(16).padStart(2, "0")}${a.g.toString(16).padStart(2, "0")}${a.b.toString(16).padStart(2, "0")}${a.a.toString(16).padStart(2, "0")}`}">` + r, i += qr), e.getStyle(P.TextDecoration)?.underline && (r = "<u>" + r, i += Kr), e.getStyle(P.FontStyle) === "italic" && (r = "<i>" + r, i += Gr), e.getStyle(P.FontWeight) === "bold" && (r = "<b>" + r, i += Wr), r + n + i;
}
function Zr(e, t) {
	return e.getChildren().map((e) => Xr(e, t)).join("");
}
function Qr(e, t, n) {
	let r = t?.textFormatting !== !1, i = new Br(), a = new Or(), s = new Ar(), c = new Mr(Nr), l = new Rr(), u = [], d = 1, f = Er.significantTimes(e);
	for (let t = 0; t < f.length; t++) {
		let p = f[t], m = Er.fromModel(e, p);
		m = i.process(m), m = a.process(m), m = s.process(m), m = c.process(m), m = l.process(m);
		let h = t + 1 < f.length ? f[t + 1] : p.add(new o(10));
		for (let e of m.iterISDRegions()) {
			if (e.isEmpty()) continue;
			let t = new Hr(d);
			t.setBegin(p), t.setEnd(h);
			let n = "";
			for (let t of e.getChildren()) for (let e of t.getChildren()) for (let t of e.getChildren()) t.kind === "p" && (n += Zr(t, r));
			t.appendText(n), t.normalizeEol(), t.isOnlyWhitespace() || (u.push(t), d++);
		}
		n && n(t / f.length);
	}
	return n && n(1), u.length === 0 ? "" : u.map((e, t) => e.toString(t + 1)).join("\n");
}
var $r = n((() => {
	v(), Dr(), F(), kr(), jr(), Ir(), zr(), Vr(), Ur(), Jr();
})), ei, ti = n((() => {
	we(), ei = class e {
		static {
			this.EOL_SEQ_RE = /\n{2,}/g;
		}
		constructor(e) {
			this._begin = null, this._end = null, this._text = "", this._line = null, this._lineAlign = null, this._textAlign = null, this._id = e ?? null;
		}
		setBegin(e) {
			this._begin = Se.fromSeconds(e), this._begin.setSeparator(".");
		}
		getBegin() {
			return this._begin;
		}
		setEnd(e) {
			e === null ? this._end = null : (this._end = Se.fromSeconds(e), this._end.setSeparator("."));
		}
		getEnd() {
			return this._end;
		}
		setLine(e) {
			this._line = e;
		}
		getLine() {
			return this._line;
		}
		setAlign(e) {
			this._lineAlign = e;
		}
		getAlign() {
			return this._lineAlign;
		}
		setTextAlign(e) {
			this._textAlign = e;
		}
		getTextAlign() {
			return this._textAlign;
		}
		isOnlyWhitespaceOrEmpty() {
			return this._text.length === 0 || this._text.trim().length === 0;
		}
		normalizeEol() {
			this._text = this._text.replace(e.EOL_SEQ_RE, "\n").replace(/^[\n\r]+|[\n\r]+$/g, "");
		}
		appendText(e) {
			this._text += e;
		}
		toString() {
			if (this._begin === null) throw Error("VTT paragraph begin time code must be set.");
			if (this._end === null) throw Error("VTT paragraph end time code must be set.");
			let e = this._begin.toSeconds();
			if (this._end.toSeconds() <= e) throw Error("VTT paragraph end time code must be greater than the begin time code.");
			let t = this._id === null ? "" : `${this._id}\n`;
			return t += `${this._begin} --> ${this._end}`, this._textAlign !== null && (t += ` align:${this._textAlign}`), this._line !== null && (t += ` line:${this._line}%`, this._lineAlign !== null && (t += `,${this._lineAlign}`)), t += "\n", this._text && (t += this._text + "\n"), t;
		}
	};
})), ni, ri = n((() => {
	ni = class {
		constructor(e, t, n) {
			this._propertyName = e, this._value = t, this._classname = n;
		}
		toString() {
			return `::cue(.${this._classname}) {\n  ${this._propertyName}: ${this._value};\n}`;
		}
	};
}));
//#endregion
//#region src/vtt/style.ts
function ii(e) {
	return oi[e] ?? `fg_color_${e.slice(1)}`;
}
function ai(e) {
	return si[e] ?? `bg_color_${e.slice(1)}`;
}
var oi, si, ci = n((() => {
	F(), oi = {
		"#ffffffff": "white",
		"#00ff00ff": "lime",
		"#00ffffff": "cyan",
		"#ff0000ff": "red",
		"#ffff00ff": "yellow",
		"#ff00ffff": "magenta",
		"#0000ffff": "blue",
		"#000000ff": "black"
	}, si = {
		"#ffffffff": "bg_white",
		"#00ff00ff": "bg_lime",
		"#00ffffff": "bg_cyan",
		"#ff0000ff": "bg_red",
		"#ffff00ff": "bg_yellow",
		"#ff00ffff": "bg_magenta",
		"#0000ffff": "bg_blue",
		"#000000ff": "bg_black"
	};
})), li = /* @__PURE__ */ r({ vttFromModel: () => pi });
function ui(e, t) {
	if (e.kind === "text") return e.getText() ?? "";
	if (e.kind === "br") return "\n";
	let n = e.getChildren().map((e) => ui(e, t)).join(""), r = "", i = "";
	e.getStyle(P.FontWeight) === "bold" && (r = "<b>" + r, i += "</b>"), e.getStyle(P.FontStyle) === "italic" && (r = "<i>" + r, i += "</i>"), e.getStyle(P.TextDecoration)?.underline && (r = "<u>" + r, i += "</u>");
	let a = e.getStyle(P.Color);
	if (a) {
		let e = `#${a.r.toString(16).padStart(2, "0")}${a.g.toString(16).padStart(2, "0")}${a.b.toString(16).padStart(2, "0")}${a.a.toString(16).padStart(2, "0")}`, n = ii(e);
		t.has(n) || t.set(n, new ni("color", e, n)), r = `<c.${n}>` + r, i += "</c>";
	}
	let o = e.getStyle(P.BackgroundColor);
	if (o) {
		let e = `#${o.r.toString(16).padStart(2, "0")}${o.g.toString(16).padStart(2, "0")}${o.b.toString(16).padStart(2, "0")}${o.a.toString(16).padStart(2, "0")}`, n = ai(e);
		t.has(n) || t.set(n, new ni("background-color", e, n)), r = `<c.${n}>` + r, i += "</c>";
	}
	return n ? r + n + i : "";
}
function di(e, t) {
	return e.units === C.rh || e.units === C.pct ? e.value : e.units === C.px ? t > 0 ? e.value * 100 / t : 0 : e.value;
}
function fi(e, t, n, r, i, a, o, s) {
	let c = new ei(i ? r : void 0), l = t.getStyle(P.Origin), u = t.getStyle(P.Extent), d = t.getStyle(P.DisplayAlign);
	if (l && u) {
		let e = di(l.y, s), t = di(u.height, s);
		d === O.after || d === "after" ? (c.setLine(Math.round(e + t)), c.setAlign("end")) : d === O.center || d === "center" ? (c.setLine(Math.round(e + t / 2)), c.setAlign("center")) : (c.setLine(Math.round(e)), c.setAlign("start"));
	}
	if (a) {
		let t = e.getStyle(P.TextAlign), n = e.getStyle(P.Direction), r = n === ie.rtl || n === "rtl";
		t === D.center ? c.setTextAlign("center") : t === D.left || t === "left" ? c.setTextAlign("left") : t === D.right || t === "right" ? c.setTextAlign("right") : t === D.start || t === "start" ? c.setTextAlign(r ? "right" : "left") : (t === D.end || t === "end") && c.setTextAlign(r ? "left" : "right");
	}
	let f = e.getChildren().map((e) => ui(e, n)).join("");
	return c.appendText(f), c.normalizeEol(), c.isOnlyWhitespaceOrEmpty() ? null : c;
}
function pi(e, t, n) {
	let r = t?.styleRegion ?? !1, i = t?.textAlign ?? r, a = t?.cueId ?? !0, s = r ? null : new Or(), c = new Ar(), l = new Mr(r ? Fr : Pr), u = new Rr(new Set([P.TextAlign]), new Map([[P.BackgroundColor, x(0, 0, 0, 204)]])), d = new Br(), f = [], p = /* @__PURE__ */ new Map(), m = 1, h = e.getPxResolution(), g = h?.width ?? 0, _ = h?.height ?? 0, v = Er.significantTimes(e);
	for (let t = 0; t < v.length; t++) {
		let r = v[t], h = Er.fromModel(e, r);
		h = d.process(h), s && (h = s.process(h)), h = c.process(h), h = l.process(h), h = u.process(h);
		let y = t + 1 < v.length ? v[t + 1] : null;
		for (let e of h.iterISDRegions()) if (!e.isEmpty()) {
			for (let t of e.getChildren()) for (let n of t.getChildren()) for (let t of n.getChildren()) if (t.kind === "p") {
				let n = fi(t, e, p, m, a, i, g, _);
				n !== null && (n.setBegin(r), n.setEnd(y ?? r.add(new o(10))), f.push(n), m++);
			}
		}
		n && n(t / v.length);
	}
	let y = "WEBVTT\n\n";
	if (p.size > 0) {
		y += "STYLE\n", y += "::cue {\n  background-color: transparent;\n}\n";
		for (let e of p.values()) y += e.toString() + "\n";
		y += "\n";
	}
	return y += f.map((e) => e.toString()).join("\n"), n && n(1), y;
}
var mi = n((() => {
	v(), Dr(), F(), kr(), jr(), Ir(), zr(), Vr(), ti(), ri(), ci();
})), hi = /* @__PURE__ */ r({ imscFromModel: () => xi });
function gi(e) {
	let t = Math.floor(e);
	return Math.abs(e - t - .5) < 1e-9 ? t % 2 == 0 ? t : t + 1 : Math.round(e);
}
function _i(e) {
	return parseFloat(e.toPrecision(6)).toString();
}
function vi(e) {
	let t = gi(e.toNumber() * 1e3), n = t % 1e3, r = Math.floor(t / 1e3), i = r % 60, a = Math.floor(r / 60), o = a % 60, s = Math.floor(a / 60);
	return `${String(s).padStart(2, "0")}:${String(o).padStart(2, "0")}:${String(i).padStart(2, "0")}.${String(n).padStart(3, "0")}`;
}
function yi(e, t, n, r) {
	let i = Ci[t];
	i ? e.att(`${i}:${n}`, r) : e.att(n, r);
}
function bi(e, t) {
	for (let n of t.iterStyles()) {
		let r = t.getStyle(n), i = qn[n];
		if (i && r !== void 0) {
			let t = i.toTtml(r);
			t !== null && yi(e, i.ns, i.localName, t);
		}
	}
}
function xi(t, n, r) {
	let i = e(), a = i.ele("tt");
	a.att("xmlns", Ln), a.att("xmlns:ebutts", Vn), a.att("xmlns:ittp", zn), a.att("xmlns:itts", Bn), a.att("xmlns:ttp", Rn), a.att("xmlns:tts", B), a.att("xml:lang", t.getLang() || "");
	let s = t.getCellResolution();
	(s.rows !== 15 || s.columns !== 32) && a.att("ttp:cellResolution", `${s.columns} ${s.rows}`);
	let c = t.getPxResolution();
	c && a.att("tts:extent", `${c.width}px ${c.height}px`);
	let l = t.getActiveArea();
	l && a.att("ittp:activeArea", `${_i(l.leftOffset)}% ${_i(l.topOffset)}% ${_i(l.width)}% ${_i(l.height)}%`);
	let f = n?.frameRate;
	if (f) {
		let e = Math.round(f.toNumber());
		a.att("ttp:frameRate", String(e));
		let t = f.divide(new o(e));
		t.numerator !== t.denominator && a.att("ttp:frameRateMultiplier", `${t.numerator} ${t.denominator}`);
	}
	let p = Array.from(t.iterRegions()), m = Array.from(t.iterInitialValues());
	if (m.length > 0 || p.length > 0) {
		let e = a.ele("head");
		if (m.length > 0) {
			let t = e.ele("styling");
			for (let [e, n] of m) {
				let r = qn[e];
				if (!r || n === void 0) continue;
				let i = r.toTtml(n);
				i !== null && yi(t.ele("initial"), r.ns, r.localName, i);
			}
		}
		if (p.length > 0) {
			let t = e.ele("layout");
			for (let e of p) {
				let n = t.ele("region");
				n.att("xml:id", e.getId() ?? ""), bi(n, e);
			}
		}
	}
	r && r(.5);
	let h = t.getBody();
	if (h !== null) {
		let e = a.ele("body");
		bi(e, h);
		for (let t of h.iterChildren()) {
			if (!(t instanceof u)) continue;
			let n = e.ele("div");
			bi(n, t);
			for (let e of t.iterChildren()) {
				if (!(e instanceof d)) continue;
				let t = n.ele("p"), r = e.getId();
				r && t.att("xml:id", r);
				let i = e.getBegin(), a = e.getEnd();
				i !== null && t.att("begin", vi(i)), a !== null && t.att("end", vi(a));
				let o = e.getRegion();
				o !== null && t.att("region", o.getId() ?? ""), bi(t, e);
				for (let n of e.iterChildren()) Si(n, t);
			}
		}
	}
	return r && r(1), i.end({
		prettyPrint: !0,
		headless: !0
	});
}
function Si(e, t) {
	if (e instanceof f) {
		let n = t.ele("span"), r = e.getBegin(), i = e.getEnd();
		r !== null && n.att("begin", vi(r)), i !== null && n.att("end", vi(i)), bi(n, e);
		for (let t of e.iterChildren()) Si(t, n);
	} else e instanceof p ? t.ele("br") : e instanceof m && t.txt(e.getText());
}
var Ci, wi = n((() => {
	v(), Hn(), Yn(), Ci = {
		[B]: "tts",
		[Rn]: "ttp",
		[zn]: "ittp",
		[Bn]: "itts",
		[Vn]: "ebutts"
	};
}));
$r(), mi(), wi();
var Ti = 9e15, Ei = 1e9, Di = "0123456789abcdef", Oi = "2.3025850929940456840179914546843642076011014886287729760333279009675726096773524802359972050895982983419677840422862486334095254650828067566662873690987816894829072083255546808437998948262331985283935053089653777326288461633662222876982198867465436674744042432743651550489343149393914796194044002221051017141748003688084012647080685567743216228355220114804663715659121373450747856947683463616792101806445070648000277502684916746550586856935673420670581136429224554405758925724208241314695689016758940256776311356919292033376587141660230105703089634572075440370847469940168269282808481184289314848524948644871927809676271275775397027668605952496716674183485704422507197965004714951050492214776567636938662976979522110718264549734772662425709429322582798502585509785265383207606726317164309505995087807523710333101197857547331541421808427543863591778117054309827482385045648019095610299291824318237525357709750539565187697510374970888692180205189339507238539205144634197265287286965110862571492198849978748873771345686209167058", ki = "3.1415926535897932384626433832795028841971693993751058209749445923078164062862089986280348253421170679821480865132823066470938446095505822317253594081284811174502841027019385211055596446229489549303819644288109756659334461284756482337867831652712019091456485669234603486104543266482133936072602491412737245870066063155881748815209209628292540917153643678925903600113305305488204665213841469519415116094330572703657595919530921861173819326117931051185480744623799627495673518857527248912279381830119491298336733624406566430860213949463952247371907021798609437027705392171762931767523846748184676694051320005681271452635608277857713427577896091736371787214684409012249534301465495853710507922796892589235420199561121290219608640344181598136297747713099605187072113499999983729780499510597317328160963185950244594553469083026425223082533446850352619311881710100031378387528865875332083814206171776691473035982534904287554687311595628638823537875937519577818577805321712268066130019278766111959092164201989380952572010654858632789", Ai = {
	precision: 20,
	rounding: 4,
	modulo: 1,
	toExpNeg: -7,
	toExpPos: 21,
	minE: -Ti,
	maxE: Ti,
	crypto: !1
}, ji, Mi, U = !0, Ni = "[DecimalError] ", Pi = Ni + "Invalid argument: ", Fi = Ni + "Precision limit exceeded", Ii = Ni + "crypto unavailable", Li = "[object Decimal]", W = Math.floor, G = Math.pow, Ri = /^0b([01]+(\.[01]*)?|\.[01]+)(p[+-]?\d+)?$/i, zi = /^0x([0-9a-f]+(\.[0-9a-f]*)?|\.[0-9a-f]+)(p[+-]?\d+)?$/i, Bi = /^0o([0-7]+(\.[0-7]*)?|\.[0-7]+)(p[+-]?\d+)?$/i, Vi = /^(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i, Hi = 1e7, K = 7, Ui = 9007199254740991, Wi = Oi.length - 1, Gi = ki.length - 1, q = { toStringTag: Li };
q.absoluteValue = q.abs = function() {
	var e = new this.constructor(this);
	return e.s < 0 && (e.s = 1), Z(e);
}, q.ceil = function() {
	return Z(new this.constructor(this), this.e + 1, 2);
}, q.clampedTo = q.clamp = function(e, t) {
	var n, r = this, i = r.constructor;
	if (e = new i(e), t = new i(t), !e.s || !t.s) return new i(NaN);
	if (e.gt(t)) throw Error(Pi + t);
	return n = r.cmp(e), n < 0 ? e : r.cmp(t) > 0 ? t : new i(r);
}, q.comparedTo = q.cmp = function(e) {
	var t, n, r, i, a = this, o = a.d, s = (e = new a.constructor(e)).d, c = a.s, l = e.s;
	if (!o || !s) return !c || !l ? NaN : c === l ? o === s ? 0 : !o ^ c < 0 ? 1 : -1 : c;
	if (!o[0] || !s[0]) return o[0] ? c : s[0] ? -l : 0;
	if (c !== l) return c;
	if (a.e !== e.e) return a.e > e.e ^ c < 0 ? 1 : -1;
	for (r = o.length, i = s.length, t = 0, n = r < i ? r : i; t < n; ++t) if (o[t] !== s[t]) return o[t] > s[t] ^ c < 0 ? 1 : -1;
	return r === i ? 0 : r > i ^ c < 0 ? 1 : -1;
}, q.cosine = q.cos = function() {
	var e, t, n = this, r = n.constructor;
	return n.d ? n.d[0] ? (e = r.precision, t = r.rounding, r.precision = e + Math.max(n.e, n.sd()) + K, r.rounding = 1, n = Ji(r, fa(r, n)), r.precision = e, r.rounding = t, Z(Mi == 2 || Mi == 3 ? n.neg() : n, e, t, !0)) : new r(1) : new r(NaN);
}, q.cubeRoot = q.cbrt = function() {
	var e, t, n, r, i, a, o, s, c, l, u = this, d = u.constructor;
	if (!u.isFinite() || u.isZero()) return new d(u);
	for (U = !1, a = u.s * G(u.s * u, 1 / 3), !a || Math.abs(a) == Infinity ? (n = J(u.d), e = u.e, (a = (e - n.length + 1) % 3) && (n += a == 1 || a == -2 ? "0" : "00"), a = G(n, 1 / 3), e = W((e + 1) / 3) - (e % 3 == (e < 0 ? -1 : 2)), a == Infinity ? n = "5e" + e : (n = a.toExponential(), n = n.slice(0, n.indexOf("e") + 1) + e), r = new d(n), r.s = u.s) : r = new d(a.toString()), o = (e = d.precision) + 3;;) if (s = r, c = s.times(s).times(s), l = c.plus(u), r = X(l.plus(u).times(s), l.plus(c), o + 2, 1), J(s.d).slice(0, o) === (n = J(r.d)).slice(0, o)) if (n = n.slice(o - 3, o + 1), n == "9999" || !i && n == "4999") {
		if (!i && (Z(s, e + 1, 0), s.times(s).times(s).eq(u))) {
			r = s;
			break;
		}
		o += 4, i = 1;
	} else {
		(!+n || !+n.slice(1) && n.charAt(0) == "5") && (Z(r, e + 1, 1), t = !r.times(r).times(r).eq(u));
		break;
	}
	return U = !0, Z(r, e, d.rounding, t);
}, q.decimalPlaces = q.dp = function() {
	var e, t = this.d, n = NaN;
	if (t) {
		if (e = t.length - 1, n = (e - W(this.e / K)) * K, e = t[e], e) for (; e % 10 == 0; e /= 10) n--;
		n < 0 && (n = 0);
	}
	return n;
}, q.dividedBy = q.div = function(e) {
	return X(this, new this.constructor(e));
}, q.dividedToIntegerBy = q.divToInt = function(e) {
	var t = this, n = t.constructor;
	return Z(X(t, new n(e), 0, 1, 1), n.precision, n.rounding);
}, q.equals = q.eq = function(e) {
	return this.cmp(e) === 0;
}, q.floor = function() {
	return Z(new this.constructor(this), this.e + 1, 3);
}, q.greaterThan = q.gt = function(e) {
	return this.cmp(e) > 0;
}, q.greaterThanOrEqualTo = q.gte = function(e) {
	var t = this.cmp(e);
	return t == 1 || t === 0;
}, q.hyperbolicCosine = q.cosh = function() {
	var e, t, n, r, i, a = this, o = a.constructor, s = new o(1);
	if (!a.isFinite()) return new o(a.s ? Infinity : NaN);
	if (a.isZero()) return s;
	n = o.precision, r = o.rounding, o.precision = n + Math.max(a.e, a.sd()) + 4, o.rounding = 1, i = a.d.length, i < 32 ? (e = Math.ceil(i / 3), t = (1 / da(4, e)).toString()) : (e = 16, t = "2.3283064365386962890625e-10"), a = ua(o, 1, a.times(t), new o(1), !0);
	for (var c, l = e, u = new o(8); l--;) c = a.times(a), a = s.minus(c.times(u.minus(c.times(u))));
	return Z(a, o.precision = n, o.rounding = r, !0);
}, q.hyperbolicSine = q.sinh = function() {
	var e, t, n, r, i = this, a = i.constructor;
	if (!i.isFinite() || i.isZero()) return new a(i);
	if (t = a.precision, n = a.rounding, a.precision = t + Math.max(i.e, i.sd()) + 4, a.rounding = 1, r = i.d.length, r < 3) i = ua(a, 2, i, i, !0);
	else {
		e = 1.4 * Math.sqrt(r), e = e > 16 ? 16 : e | 0, i = i.times(1 / da(5, e)), i = ua(a, 2, i, i, !0);
		for (var o, s = new a(5), c = new a(16), l = new a(20); e--;) o = i.times(i), i = i.times(s.plus(o.times(c.times(o).plus(l))));
	}
	return a.precision = t, a.rounding = n, Z(i, t, n, !0);
}, q.hyperbolicTangent = q.tanh = function() {
	var e, t, n = this, r = n.constructor;
	return n.isFinite() ? n.isZero() ? new r(n) : (e = r.precision, t = r.rounding, r.precision = e + 7, r.rounding = 1, X(n.sinh(), n.cosh(), r.precision = e, r.rounding = t)) : new r(n.s);
}, q.inverseCosine = q.acos = function() {
	var e = this, t = e.constructor, n = e.abs().cmp(1), r = t.precision, i = t.rounding;
	return n === -1 ? e.isZero() ? Qi(t, r + 4, i).times(.5) : (t.precision = r + 6, t.rounding = 1, e = new t(1).minus(e).div(e.plus(1)).sqrt().atan(), t.precision = r, t.rounding = i, e.times(2)) : n === 0 ? e.isNeg() ? Qi(t, r, i) : new t(0) : new t(NaN);
}, q.inverseHyperbolicCosine = q.acosh = function() {
	var e, t, n = this, r = n.constructor;
	return n.lte(1) ? new r(n.eq(1) ? 0 : NaN) : n.isFinite() ? (e = r.precision, t = r.rounding, r.precision = e + Math.max(Math.abs(n.e), n.sd()) + 4, r.rounding = 1, U = !1, n = n.times(n).minus(1).sqrt().plus(n), U = !0, r.precision = e, r.rounding = t, n.ln()) : new r(n);
}, q.inverseHyperbolicSine = q.asinh = function() {
	var e, t, n = this, r = n.constructor;
	return !n.isFinite() || n.isZero() ? new r(n) : (e = r.precision, t = r.rounding, r.precision = e + 2 * Math.max(Math.abs(n.e), n.sd()) + 6, r.rounding = 1, U = !1, n = n.times(n).plus(1).sqrt().plus(n), U = !0, r.precision = e, r.rounding = t, n.ln());
}, q.inverseHyperbolicTangent = q.atanh = function() {
	var e, t, n, r, i = this, a = i.constructor;
	return i.isFinite() ? i.e >= 0 ? new a(i.abs().eq(1) ? i.s / 0 : i.isZero() ? i : NaN) : (e = a.precision, t = a.rounding, r = i.sd(), Math.max(r, e) < 2 * -i.e - 1 ? Z(new a(i), e, t, !0) : (a.precision = n = r - i.e, i = X(i.plus(1), new a(1).minus(i), n + e, 1), a.precision = e + 4, a.rounding = 1, i = i.ln(), a.precision = e, a.rounding = t, i.times(.5))) : new a(NaN);
}, q.inverseSine = q.asin = function() {
	var e, t, n, r, i = this, a = i.constructor;
	return i.isZero() ? new a(i) : (t = i.abs().cmp(1), n = a.precision, r = a.rounding, t === -1 ? (a.precision = n + 6, a.rounding = 1, i = i.div(new a(1).minus(i.times(i)).sqrt().plus(1)).atan(), a.precision = n, a.rounding = r, i.times(2)) : t === 0 ? (e = Qi(a, n + 4, r).times(.5), e.s = i.s, e) : new a(NaN));
}, q.inverseTangent = q.atan = function() {
	var e, t, n, r, i, a, o, s, c, l = this, u = l.constructor, d = u.precision, f = u.rounding;
	if (!l.isFinite()) {
		if (!l.s) return new u(NaN);
		if (d + 4 <= Gi) return o = Qi(u, d + 4, f).times(.5), o.s = l.s, o;
	} else if (l.isZero()) return new u(l);
	else if (l.abs().eq(1) && d + 4 <= Gi) return o = Qi(u, d + 4, f).times(.25), o.s = l.s, o;
	for (u.precision = s = d + 10, u.rounding = 1, n = Math.min(28, s / K + 2 | 0), e = n; e; --e) l = l.div(l.times(l).plus(1).sqrt().plus(1));
	for (U = !1, t = Math.ceil(s / K), r = 1, c = l.times(l), o = new u(l), i = l; e !== -1;) if (i = i.times(c), a = o.minus(i.div(r += 2)), i = i.times(c), o = a.plus(i.div(r += 2)), o.d[t] !== void 0) for (e = t; o.d[e] === a.d[e] && e--;);
	return n && (o = o.times(2 << n - 1)), U = !0, Z(o, u.precision = d, u.rounding = f, !0);
}, q.isFinite = function() {
	return !!this.d;
}, q.isInteger = q.isInt = function() {
	return !!this.d && W(this.e / K) > this.d.length - 2;
}, q.isNaN = function() {
	return !this.s;
}, q.isNegative = q.isNeg = function() {
	return this.s < 0;
}, q.isPositive = q.isPos = function() {
	return this.s > 0;
}, q.isZero = function() {
	return !!this.d && this.d[0] === 0;
}, q.lessThan = q.lt = function(e) {
	return this.cmp(e) < 0;
}, q.lessThanOrEqualTo = q.lte = function(e) {
	return this.cmp(e) < 1;
}, q.logarithm = q.log = function(e) {
	var t, n, r, i, a, o, s, c, l = this, u = l.constructor, d = u.precision, f = u.rounding, p = 5;
	if (e == null) e = new u(10), t = !0;
	else {
		if (e = new u(e), n = e.d, e.s < 0 || !n || !n[0] || e.eq(1)) return new u(NaN);
		t = e.eq(10);
	}
	if (n = l.d, l.s < 0 || !n || !n[0] || l.eq(1)) return new u(n && !n[0] ? -Infinity : l.s == 1 ? n ? 0 : Infinity : NaN);
	if (t) if (n.length > 1) a = !0;
	else {
		for (i = n[0]; i % 10 == 0;) i /= 10;
		a = i !== 1;
	}
	if (U = !1, s = d + p, o = aa(l, s), r = t ? Zi(u, s + 10) : aa(e, s), c = X(o, r, s, 1), Ki(c.d, i = d, f)) do
		if (s += 10, o = aa(l, s), r = t ? Zi(u, s + 10) : aa(e, s), c = X(o, r, s, 1), !a) {
			+J(c.d).slice(i + 1, i + 15) + 1 == 0x5af3107a4000 && (c = Z(c, d + 1, 0));
			break;
		}
	while (Ki(c.d, i += 10, f));
	return U = !0, Z(c, d, f);
}, q.minus = q.sub = function(e) {
	var t, n, r, i, a, o, s, c, l, u, d, f, p = this, m = p.constructor;
	if (e = new m(e), !p.d || !e.d) return !p.s || !e.s ? e = new m(NaN) : p.d ? e.s = -e.s : e = new m(e.d || p.s !== e.s ? p : NaN), e;
	if (p.s != e.s) return e.s = -e.s, p.plus(e);
	if (l = p.d, f = e.d, s = m.precision, c = m.rounding, !l[0] || !f[0]) {
		if (f[0]) e.s = -e.s;
		else if (l[0]) e = new m(p);
		else return new m(c === 3 ? -0 : 0);
		return U ? Z(e, s, c) : e;
	}
	if (n = W(e.e / K), u = W(p.e / K), l = l.slice(), a = u - n, a) {
		for (d = a < 0, d ? (t = l, a = -a, o = f.length) : (t = f, n = u, o = l.length), r = Math.max(Math.ceil(s / K), o) + 2, a > r && (a = r, t.length = 1), t.reverse(), r = a; r--;) t.push(0);
		t.reverse();
	} else {
		for (r = l.length, o = f.length, d = r < o, d && (o = r), r = 0; r < o; r++) if (l[r] != f[r]) {
			d = l[r] < f[r];
			break;
		}
		a = 0;
	}
	for (d && (t = l, l = f, f = t, e.s = -e.s), o = l.length, r = f.length - o; r > 0; --r) l[o++] = 0;
	for (r = f.length; r > a;) {
		if (l[--r] < f[r]) {
			for (i = r; i && l[--i] === 0;) l[i] = Hi - 1;
			--l[i], l[r] += Hi;
		}
		l[r] -= f[r];
	}
	for (; l[--o] === 0;) l.pop();
	for (; l[0] === 0; l.shift()) --n;
	return l[0] ? (e.d = l, e.e = Xi(l, n), U ? Z(e, s, c) : e) : new m(c === 3 ? -0 : 0);
}, q.modulo = q.mod = function(e) {
	var t, n = this, r = n.constructor;
	return e = new r(e), !n.d || !e.s || e.d && !e.d[0] ? new r(NaN) : !e.d || n.d && !n.d[0] ? Z(new r(n), r.precision, r.rounding) : (U = !1, r.modulo == 9 ? (t = X(n, e.abs(), 0, 3, 1), t.s *= e.s) : t = X(n, e, 0, r.modulo, 1), t = t.times(e), U = !0, n.minus(t));
}, q.naturalExponential = q.exp = function() {
	return ia(this);
}, q.naturalLogarithm = q.ln = function() {
	return aa(this);
}, q.negated = q.neg = function() {
	var e = new this.constructor(this);
	return e.s = -e.s, Z(e);
}, q.plus = q.add = function(e) {
	var t, n, r, i, a, o, s, c, l, u, d = this, f = d.constructor;
	if (e = new f(e), !d.d || !e.d) return !d.s || !e.s ? e = new f(NaN) : d.d || (e = new f(e.d || d.s === e.s ? d : NaN)), e;
	if (d.s != e.s) return e.s = -e.s, d.minus(e);
	if (l = d.d, u = e.d, s = f.precision, c = f.rounding, !l[0] || !u[0]) return u[0] || (e = new f(d)), U ? Z(e, s, c) : e;
	if (a = W(d.e / K), r = W(e.e / K), l = l.slice(), i = a - r, i) {
		for (i < 0 ? (n = l, i = -i, o = u.length) : (n = u, r = a, o = l.length), a = Math.ceil(s / K), o = a > o ? a + 1 : o + 1, i > o && (i = o, n.length = 1), n.reverse(); i--;) n.push(0);
		n.reverse();
	}
	for (o = l.length, i = u.length, o - i < 0 && (i = o, n = u, u = l, l = n), t = 0; i;) t = (l[--i] = l[i] + u[i] + t) / Hi | 0, l[i] %= Hi;
	for (t && (l.unshift(t), ++r), o = l.length; l[--o] == 0;) l.pop();
	return e.d = l, e.e = Xi(l, r), U ? Z(e, s, c) : e;
}, q.precision = q.sd = function(e) {
	var t, n = this;
	if (e !== void 0 && e !== !!e && e !== 1 && e !== 0) throw Error(Pi + e);
	return n.d ? (t = $i(n.d), e && n.e + 1 > t && (t = n.e + 1)) : t = NaN, t;
}, q.round = function() {
	var e = this, t = e.constructor;
	return Z(new t(e), e.e + 1, t.rounding);
}, q.sine = q.sin = function() {
	var e, t, n = this, r = n.constructor;
	return n.isFinite() ? n.isZero() ? new r(n) : (e = r.precision, t = r.rounding, r.precision = e + Math.max(n.e, n.sd()) + K, r.rounding = 1, n = la(r, fa(r, n)), r.precision = e, r.rounding = t, Z(Mi > 2 ? n.neg() : n, e, t, !0)) : new r(NaN);
}, q.squareRoot = q.sqrt = function() {
	var e, t, n, r, i, a, o = this, s = o.d, c = o.e, l = o.s, u = o.constructor;
	if (l !== 1 || !s || !s[0]) return new u(!l || l < 0 && (!s || s[0]) ? NaN : s ? o : Infinity);
	for (U = !1, l = Math.sqrt(+o), l == 0 || l == Infinity ? (t = J(s), (t.length + c) % 2 == 0 && (t += "0"), l = Math.sqrt(t), c = W((c + 1) / 2) - (c < 0 || c % 2), l == Infinity ? t = "5e" + c : (t = l.toExponential(), t = t.slice(0, t.indexOf("e") + 1) + c), r = new u(t)) : r = new u(l.toString()), n = (c = u.precision) + 3;;) if (a = r, r = a.plus(X(o, a, n + 2, 1)).times(.5), J(a.d).slice(0, n) === (t = J(r.d)).slice(0, n)) if (t = t.slice(n - 3, n + 1), t == "9999" || !i && t == "4999") {
		if (!i && (Z(a, c + 1, 0), a.times(a).eq(o))) {
			r = a;
			break;
		}
		n += 4, i = 1;
	} else {
		(!+t || !+t.slice(1) && t.charAt(0) == "5") && (Z(r, c + 1, 1), e = !r.times(r).eq(o));
		break;
	}
	return U = !0, Z(r, c, u.rounding, e);
}, q.tangent = q.tan = function() {
	var e, t, n = this, r = n.constructor;
	return n.isFinite() ? n.isZero() ? new r(n) : (e = r.precision, t = r.rounding, r.precision = e + 10, r.rounding = 1, n = n.sin(), n.s = 1, n = X(n, new r(1).minus(n.times(n)).sqrt(), e + 10, 0), r.precision = e, r.rounding = t, Z(Mi == 2 || Mi == 4 ? n.neg() : n, e, t, !0)) : new r(NaN);
}, q.times = q.mul = function(e) {
	var t, n, r, i, a, o, s, c, l, u = this, d = u.constructor, f = u.d, p = (e = new d(e)).d;
	if (e.s *= u.s, !f || !f[0] || !p || !p[0]) return new d(!e.s || f && !f[0] && !p || p && !p[0] && !f ? NaN : !f || !p ? e.s / 0 : e.s * 0);
	for (n = W(u.e / K) + W(e.e / K), c = f.length, l = p.length, c < l && (a = f, f = p, p = a, o = c, c = l, l = o), a = [], o = c + l, r = o; r--;) a.push(0);
	for (r = l; --r >= 0;) {
		for (t = 0, i = c + r; i > r;) s = a[i] + p[r] * f[i - r - 1] + t, a[i--] = s % Hi | 0, t = s / Hi | 0;
		a[i] = (a[i] + t) % Hi | 0;
	}
	for (; !a[--o];) a.pop();
	return t ? ++n : a.shift(), e.d = a, e.e = Xi(a, n), U ? Z(e, d.precision, d.rounding) : e;
}, q.toBinary = function(e, t) {
	return pa(this, 2, e, t);
}, q.toDecimalPlaces = q.toDP = function(e, t) {
	var n = this, r = n.constructor;
	return n = new r(n), e === void 0 ? n : (Y(e, 0, Ei), t === void 0 ? t = r.rounding : Y(t, 0, 8), Z(n, e + n.e + 1, t));
}, q.toExponential = function(e, t) {
	var n, r = this, i = r.constructor;
	return e === void 0 ? n = Yi(r, !0) : (Y(e, 0, Ei), t === void 0 ? t = i.rounding : Y(t, 0, 8), r = Z(new i(r), e + 1, t), n = Yi(r, !0, e + 1)), r.isNeg() && !r.isZero() ? "-" + n : n;
}, q.toFixed = function(e, t) {
	var n, r, i = this, a = i.constructor;
	return e === void 0 ? n = Yi(i) : (Y(e, 0, Ei), t === void 0 ? t = a.rounding : Y(t, 0, 8), r = Z(new a(i), e + i.e + 1, t), n = Yi(r, !1, e + r.e + 1)), i.isNeg() && !i.isZero() ? "-" + n : n;
}, q.toFraction = function(e) {
	var t, n, r, i, a, o, s, c, l, u, d, f, p = this, m = p.d, h = p.constructor;
	if (!m) return new h(p);
	if (l = n = new h(1), r = c = new h(0), t = new h(r), a = t.e = $i(m) - p.e - 1, o = a % K, t.d[0] = G(10, o < 0 ? K + o : o), e == null) e = a > 0 ? t : l;
	else {
		if (s = new h(e), !s.isInt() || s.lt(l)) throw Error(Pi + s);
		e = s.gt(t) ? a > 0 ? t : l : s;
	}
	for (U = !1, s = new h(J(m)), u = h.precision, h.precision = a = m.length * K * 2; d = X(s, t, 0, 1, 1), i = n.plus(d.times(r)), i.cmp(e) != 1;) n = r, r = i, i = l, l = c.plus(d.times(i)), c = i, i = t, t = s.minus(d.times(i)), s = i;
	return i = X(e.minus(n), r, 0, 1, 1), c = c.plus(i.times(l)), n = n.plus(i.times(r)), c.s = l.s = p.s, f = X(l, r, a, 1).minus(p).abs().cmp(X(c, n, a, 1).minus(p).abs()) < 1 ? [l, r] : [c, n], h.precision = u, U = !0, f;
}, q.toHexadecimal = q.toHex = function(e, t) {
	return pa(this, 16, e, t);
}, q.toNearest = function(e, t) {
	var n = this, r = n.constructor;
	if (n = new r(n), e == null) {
		if (!n.d) return n;
		e = new r(1), t = r.rounding;
	} else {
		if (e = new r(e), t === void 0 ? t = r.rounding : Y(t, 0, 8), !n.d) return e.s ? n : e;
		if (!e.d) return e.s &&= n.s, e;
	}
	return e.d[0] ? (U = !1, n = X(n, e, 0, t, 1).times(e), U = !0, Z(n)) : (e.s = n.s, n = e), n;
}, q.toNumber = function() {
	return +this;
}, q.toOctal = function(e, t) {
	return pa(this, 8, e, t);
}, q.toPower = q.pow = function(e) {
	var t, n, r, i, a, o, s = this, c = s.constructor, l = +(e = new c(e));
	if (!s.d || !e.d || !s.d[0] || !e.d[0]) return new c(G(+s, l));
	if (s = new c(s), s.eq(1)) return s;
	if (r = c.precision, a = c.rounding, e.eq(1)) return Z(s, r, a);
	if (t = W(e.e / K), t >= e.d.length - 1 && (n = l < 0 ? -l : l) <= Ui) return i = ta(c, s, n, r), e.s < 0 ? new c(1).div(i) : Z(i, r, a);
	if (o = s.s, o < 0) {
		if (t < e.d.length - 1) return new c(NaN);
		if (e.d[t] & 1 || (o = 1), s.e == 0 && s.d[0] == 1 && s.d.length == 1) return s.s = o, s;
	}
	return n = G(+s, l), t = n == 0 || !isFinite(n) ? W(l * (Math.log("0." + J(s.d)) / Math.LN10 + s.e + 1)) : new c(n + "").e, t > c.maxE + 1 || t < c.minE - 1 ? new c(t > 0 ? o / 0 : 0) : (U = !1, c.rounding = s.s = 1, n = Math.min(12, (t + "").length), i = ia(e.times(aa(s, r + n)), r), i.d && (i = Z(i, r + 5, 1), Ki(i.d, r, a) && (t = r + 10, i = Z(ia(e.times(aa(s, t + n)), t), t + 5, 1), +J(i.d).slice(r + 1, r + 15) + 1 == 0x5af3107a4000 && (i = Z(i, r + 1, 0)))), i.s = o, U = !0, c.rounding = a, Z(i, r, a));
}, q.toPrecision = function(e, t) {
	var n, r = this, i = r.constructor;
	return e === void 0 ? n = Yi(r, r.e <= i.toExpNeg || r.e >= i.toExpPos) : (Y(e, 1, Ei), t === void 0 ? t = i.rounding : Y(t, 0, 8), r = Z(new i(r), e, t), n = Yi(r, e <= r.e || r.e <= i.toExpNeg, e)), r.isNeg() && !r.isZero() ? "-" + n : n;
}, q.toSignificantDigits = q.toSD = function(e, t) {
	var n = this, r = n.constructor;
	return e === void 0 ? (e = r.precision, t = r.rounding) : (Y(e, 1, Ei), t === void 0 ? t = r.rounding : Y(t, 0, 8)), Z(new r(n), e, t);
}, q.toString = function() {
	var e = this, t = e.constructor, n = Yi(e, e.e <= t.toExpNeg || e.e >= t.toExpPos);
	return e.isNeg() && !e.isZero() ? "-" + n : n;
}, q.truncated = q.trunc = function() {
	return Z(new this.constructor(this), this.e + 1, 1);
}, q.valueOf = q.toJSON = function() {
	var e = this, t = e.constructor, n = Yi(e, e.e <= t.toExpNeg || e.e >= t.toExpPos);
	return e.isNeg() ? "-" + n : n;
};
function J(e) {
	var t, n, r, i = e.length - 1, a = "", o = e[0];
	if (i > 0) {
		for (a += o, t = 1; t < i; t++) r = e[t] + "", n = K - r.length, n && (a += ea(n)), a += r;
		o = e[t], r = o + "", n = K - r.length, n && (a += ea(n));
	} else if (o === 0) return "0";
	for (; o % 10 == 0;) o /= 10;
	return a + o;
}
function Y(e, t, n) {
	if (e !== ~~e || e < t || e > n) throw Error(Pi + e);
}
function Ki(e, t, n, r) {
	var i, a, o, s;
	for (a = e[0]; a >= 10; a /= 10) --t;
	return --t < 0 ? (t += K, i = 0) : (i = Math.ceil((t + 1) / K), t %= K), a = G(10, K - t), s = e[i] % a | 0, r == null ? t < 3 ? (t == 0 ? s = s / 100 | 0 : t == 1 && (s = s / 10 | 0), o = n < 4 && s == 99999 || n > 3 && s == 49999 || s == 5e4 || s == 0) : o = (n < 4 && s + 1 == a || n > 3 && s + 1 == a / 2) && (e[i + 1] / a / 100 | 0) == G(10, t - 2) - 1 || (s == a / 2 || s == 0) && (e[i + 1] / a / 100 | 0) == 0 : t < 4 ? (t == 0 ? s = s / 1e3 | 0 : t == 1 ? s = s / 100 | 0 : t == 2 && (s = s / 10 | 0), o = (r || n < 4) && s == 9999 || !r && n > 3 && s == 4999) : o = ((r || n < 4) && s + 1 == a || !r && n > 3 && s + 1 == a / 2) && (e[i + 1] / a / 1e3 | 0) == G(10, t - 3) - 1, o;
}
function qi(e, t, n) {
	for (var r, i = [0], a, o = 0, s = e.length; o < s;) {
		for (a = i.length; a--;) i[a] *= t;
		for (i[0] += Di.indexOf(e.charAt(o++)), r = 0; r < i.length; r++) i[r] > n - 1 && (i[r + 1] === void 0 && (i[r + 1] = 0), i[r + 1] += i[r] / n | 0, i[r] %= n);
	}
	return i.reverse();
}
function Ji(e, t) {
	var n, r, i;
	if (t.isZero()) return t;
	r = t.d.length, r < 32 ? (n = Math.ceil(r / 3), i = (1 / da(4, n)).toString()) : (n = 16, i = "2.3283064365386962890625e-10"), e.precision += n, t = ua(e, 1, t.times(i), new e(1));
	for (var a = n; a--;) {
		var o = t.times(t);
		t = o.times(o).minus(o).times(8).plus(1);
	}
	return e.precision -= n, t;
}
var X = (function() {
	function e(e, t, n) {
		var r, i = 0, a = e.length;
		for (e = e.slice(); a--;) r = e[a] * t + i, e[a] = r % n | 0, i = r / n | 0;
		return i && e.unshift(i), e;
	}
	function t(e, t, n, r) {
		var i, a;
		if (n != r) a = n > r ? 1 : -1;
		else for (i = a = 0; i < n; i++) if (e[i] != t[i]) {
			a = e[i] > t[i] ? 1 : -1;
			break;
		}
		return a;
	}
	function n(e, t, n, r) {
		for (var i = 0; n--;) e[n] -= i, i = +(e[n] < t[n]), e[n] = i * r + e[n] - t[n];
		for (; !e[0] && e.length > 1;) e.shift();
	}
	return function(r, i, a, o, s, c) {
		var l, u, d, f, p, m, h, g, _, v, y, b, x, S, C, w, T, E, D, O, k = r.constructor, ee = r.s == i.s ? 1 : -1, A = r.d, j = i.d;
		if (!A || !A[0] || !j || !j[0]) return new k(!r.s || !i.s || (A ? j && A[0] == j[0] : !j) ? NaN : A && A[0] == 0 || !j ? ee * 0 : ee / 0);
		for (c ? (p = 1, u = r.e - i.e) : (c = Hi, p = K, u = W(r.e / p) - W(i.e / p)), D = j.length, T = A.length, _ = new k(ee), v = _.d = [], d = 0; j[d] == (A[d] || 0); d++);
		if (j[d] > (A[d] || 0) && u--, a == null ? (S = a = k.precision, o = k.rounding) : S = s ? a + (r.e - i.e) + 1 : a, S < 0) v.push(1), m = !0;
		else {
			if (S = S / p + 2 | 0, d = 0, D == 1) {
				for (f = 0, j = j[0], S++; (d < T || f) && S--; d++) C = f * c + (A[d] || 0), v[d] = C / j | 0, f = C % j | 0;
				m = f || d < T;
			} else {
				for (f = c / (j[0] + 1) | 0, f > 1 && (j = e(j, f, c), A = e(A, f, c), D = j.length, T = A.length), w = D, y = A.slice(0, D), b = y.length; b < D;) y[b++] = 0;
				O = j.slice(), O.unshift(0), E = j[0], j[1] >= c / 2 && ++E;
				do
					f = 0, l = t(j, y, D, b), l < 0 ? (x = y[0], D != b && (x = x * c + (y[1] || 0)), f = x / E | 0, f > 1 ? (f >= c && (f = c - 1), h = e(j, f, c), g = h.length, b = y.length, l = t(h, y, g, b), l == 1 && (f--, n(h, D < g ? O : j, g, c))) : (f == 0 && (l = f = 1), h = j.slice()), g = h.length, g < b && h.unshift(0), n(y, h, b, c), l == -1 && (b = y.length, l = t(j, y, D, b), l < 1 && (f++, n(y, D < b ? O : j, b, c))), b = y.length) : l === 0 && (f++, y = [0]), v[d++] = f, l && y[0] ? y[b++] = A[w] || 0 : (y = [A[w]], b = 1);
				while ((w++ < T || y[0] !== void 0) && S--);
				m = y[0] !== void 0;
			}
			v[0] || v.shift();
		}
		if (p == 1) _.e = u, ji = m;
		else {
			for (d = 1, f = v[0]; f >= 10; f /= 10) d++;
			_.e = d + u * p - 1, Z(_, s ? a + _.e + 1 : a, o, m);
		}
		return _;
	};
})();
function Z(e, t, n, r) {
	var i, a, o, s, c, l, u, d, f, p = e.constructor;
	out: if (t != null) {
		if (d = e.d, !d) return e;
		for (i = 1, s = d[0]; s >= 10; s /= 10) i++;
		if (a = t - i, a < 0) a += K, o = t, u = d[f = 0], c = u / G(10, i - o - 1) % 10 | 0;
		else if (f = Math.ceil((a + 1) / K), s = d.length, f >= s) if (r) {
			for (; s++ <= f;) d.push(0);
			u = c = 0, i = 1, a %= K, o = a - K + 1;
		} else break out;
		else {
			for (u = s = d[f], i = 1; s >= 10; s /= 10) i++;
			a %= K, o = a - K + i, c = o < 0 ? 0 : u / G(10, i - o - 1) % 10 | 0;
		}
		if (r = r || t < 0 || d[f + 1] !== void 0 || (o < 0 ? u : u % G(10, i - o - 1)), l = n < 4 ? (c || r) && (n == 0 || n == (e.s < 0 ? 3 : 2)) : c > 5 || c == 5 && (n == 4 || r || n == 6 && (a > 0 ? o > 0 ? u / G(10, i - o) : 0 : d[f - 1]) % 10 & 1 || n == (e.s < 0 ? 8 : 7)), t < 1 || !d[0]) return d.length = 0, l ? (t -= e.e + 1, d[0] = G(10, (K - t % K) % K), e.e = -t || 0) : d[0] = e.e = 0, e;
		if (a == 0 ? (d.length = f, s = 1, f--) : (d.length = f + 1, s = G(10, K - a), d[f] = o > 0 ? (u / G(10, i - o) % G(10, o) | 0) * s : 0), l) for (;;) if (f == 0) {
			for (a = 1, o = d[0]; o >= 10; o /= 10) a++;
			for (o = d[0] += s, s = 1; o >= 10; o /= 10) s++;
			a != s && (e.e++, d[0] == Hi && (d[0] = 1));
			break;
		} else {
			if (d[f] += s, d[f] != Hi) break;
			d[f--] = 0, s = 1;
		}
		for (a = d.length; d[--a] === 0;) d.pop();
	}
	return U && (e.e > p.maxE ? (e.d = null, e.e = NaN) : e.e < p.minE && (e.e = 0, e.d = [0])), e;
}
function Yi(e, t, n) {
	if (!e.isFinite()) return oa(e);
	var r, i = e.e, a = J(e.d), o = a.length;
	return t ? (n && (r = n - o) > 0 ? a = a.charAt(0) + "." + a.slice(1) + ea(r) : o > 1 && (a = a.charAt(0) + "." + a.slice(1)), a = a + (e.e < 0 ? "e" : "e+") + e.e) : i < 0 ? (a = "0." + ea(-i - 1) + a, n && (r = n - o) > 0 && (a += ea(r))) : i >= o ? (a += ea(i + 1 - o), n && (r = n - i - 1) > 0 && (a = a + "." + ea(r))) : ((r = i + 1) < o && (a = a.slice(0, r) + "." + a.slice(r)), n && (r = n - o) > 0 && (i + 1 === o && (a += "."), a += ea(r))), a;
}
function Xi(e, t) {
	var n = e[0];
	for (t *= K; n >= 10; n /= 10) t++;
	return t;
}
function Zi(e, t, n) {
	if (t > Wi) throw U = !0, n && (e.precision = n), Error(Fi);
	return Z(new e(Oi), t, 1, !0);
}
function Qi(e, t, n) {
	if (t > Gi) throw Error(Fi);
	return Z(new e(ki), t, n, !0);
}
function $i(e) {
	var t = e.length - 1, n = t * K + 1;
	if (t = e[t], t) {
		for (; t % 10 == 0; t /= 10) n--;
		for (t = e[0]; t >= 10; t /= 10) n++;
	}
	return n;
}
function ea(e) {
	for (var t = ""; e--;) t += "0";
	return t;
}
function ta(e, t, n, r) {
	var i, a = new e(1), o = Math.ceil(r / K + 4);
	for (U = !1;;) {
		if (n % 2 && (a = a.times(t), ma(a.d, o) && (i = !0)), n = W(n / 2), n === 0) {
			n = a.d.length - 1, i && a.d[n] === 0 && ++a.d[n];
			break;
		}
		t = t.times(t), ma(t.d, o);
	}
	return U = !0, a;
}
function na(e) {
	return e.d[e.d.length - 1] & 1;
}
function ra(e, t, n) {
	for (var r, i, a = new e(t[0]), o = 0; ++o < t.length;) {
		if (i = new e(t[o]), !i.s) {
			a = i;
			break;
		}
		r = a.cmp(i), (r === n || r === 0 && a.s === n) && (a = i);
	}
	return a;
}
function ia(e, t) {
	var n, r, i, a, o, s, c, l = 0, u = 0, d = 0, f = e.constructor, p = f.rounding, m = f.precision;
	if (!e.d || !e.d[0] || e.e > 17) return new f(e.d ? e.d[0] ? e.s < 0 ? 0 : Infinity : 1 : e.s ? e.s < 0 ? 0 : e : NaN);
	for (t == null ? (U = !1, c = m) : c = t, s = new f(.03125); e.e > -2;) e = e.times(s), d += 5;
	for (r = Math.log(G(2, d)) / Math.LN10 * 2 + 5 | 0, c += r, n = a = o = new f(1), f.precision = c;;) {
		if (a = Z(a.times(e), c, 1), n = n.times(++u), s = o.plus(X(a, n, c, 1)), J(s.d).slice(0, c) === J(o.d).slice(0, c)) {
			for (i = d; i--;) o = Z(o.times(o), c, 1);
			if (t == null) if (l < 3 && Ki(o.d, c - r, p, l)) f.precision = c += 10, n = a = s = new f(1), u = 0, l++;
			else return Z(o, f.precision = m, p, U = !0);
			else return f.precision = m, o;
		}
		o = s;
	}
}
function aa(e, t) {
	var n, r, i, a, o, s, c, l, u, d, f, p = 1, m = 10, h = e, g = h.d, _ = h.constructor, v = _.rounding, y = _.precision;
	if (h.s < 0 || !g || !g[0] || !h.e && g[0] == 1 && g.length == 1) return new _(g && !g[0] ? -Infinity : h.s == 1 ? g ? 0 : h : NaN);
	if (t == null ? (U = !1, u = y) : u = t, _.precision = u += m, n = J(g), r = n.charAt(0), Math.abs(a = h.e) < 0x5543df729c000) {
		for (; r < 7 && r != 1 || r == 1 && n.charAt(1) > 3;) h = h.times(e), n = J(h.d), r = n.charAt(0), p++;
		a = h.e, r > 1 ? (h = new _("0." + n), a++) : h = new _(r + "." + n.slice(1));
	} else return l = Zi(_, u + 2, y).times(a + ""), h = aa(new _(r + "." + n.slice(1)), u - m).plus(l), _.precision = y, t == null ? Z(h, y, v, U = !0) : h;
	for (d = h, c = o = h = X(h.minus(1), h.plus(1), u, 1), f = Z(h.times(h), u, 1), i = 3;;) {
		if (o = Z(o.times(f), u, 1), l = c.plus(X(o, new _(i), u, 1)), J(l.d).slice(0, u) === J(c.d).slice(0, u)) if (c = c.times(2), a !== 0 && (c = c.plus(Zi(_, u + 2, y).times(a + ""))), c = X(c, new _(p), u, 1), t == null) if (Ki(c.d, u - m, v, s)) _.precision = u += m, l = o = h = X(d.minus(1), d.plus(1), u, 1), f = Z(h.times(h), u, 1), i = s = 1;
		else return Z(c, _.precision = y, v, U = !0);
		else return _.precision = y, c;
		c = l, i += 2;
	}
}
function oa(e) {
	return String(e.s * e.s / 0);
}
function sa(e, t) {
	var n, r, i;
	for ((n = t.indexOf(".")) > -1 && (t = t.replace(".", "")), (r = t.search(/e/i)) > 0 ? (n < 0 && (n = r), n += +t.slice(r + 1), t = t.substring(0, r)) : n < 0 && (n = t.length), r = 0; t.charCodeAt(r) === 48; r++);
	for (i = t.length; t.charCodeAt(i - 1) === 48; --i);
	if (t = t.slice(r, i), t) {
		if (i -= r, e.e = n = n - r - 1, e.d = [], r = (n + 1) % K, n < 0 && (r += K), r < i) {
			for (r && e.d.push(+t.slice(0, r)), i -= K; r < i;) e.d.push(+t.slice(r, r += K));
			t = t.slice(r), r = K - t.length;
		} else r -= i;
		for (; r--;) t += "0";
		e.d.push(+t), U && (e.e > e.constructor.maxE ? (e.d = null, e.e = NaN) : e.e < e.constructor.minE && (e.e = 0, e.d = [0]));
	} else e.e = 0, e.d = [0];
	return e;
}
function ca(e, t) {
	var n, r, i, a, o, s, c, l, u;
	if (t.indexOf("_") > -1) {
		if (t = t.replace(/(\d)_(?=\d)/g, "$1"), Vi.test(t)) return sa(e, t);
	} else if (t === "Infinity" || t === "NaN") return +t || (e.s = NaN), e.e = NaN, e.d = null, e;
	if (zi.test(t)) n = 16, t = t.toLowerCase();
	else if (Ri.test(t)) n = 2;
	else if (Bi.test(t)) n = 8;
	else throw Error(Pi + t);
	for (a = t.search(/p/i), a > 0 ? (c = +t.slice(a + 1), t = t.substring(2, a)) : t = t.slice(2), a = t.indexOf("."), o = a >= 0, r = e.constructor, o && (t = t.replace(".", ""), s = t.length, a = s - a, i = ta(r, new r(n), a, a * 2)), l = qi(t, n, Hi), u = l.length - 1, a = u; l[a] === 0; --a) l.pop();
	return a < 0 ? new r(e.s * 0) : (e.e = Xi(l, u), e.d = l, U = !1, o && (e = X(e, i, s * 4)), c && (e = e.times(Math.abs(c) < 54 ? G(2, c) : Q.pow(2, c))), U = !0, e);
}
function la(e, t) {
	var n, r = t.d.length;
	if (r < 3) return t.isZero() ? t : ua(e, 2, t, t);
	n = 1.4 * Math.sqrt(r), n = n > 16 ? 16 : n | 0, t = t.times(1 / da(5, n)), t = ua(e, 2, t, t);
	for (var i, a = new e(5), o = new e(16), s = new e(20); n--;) i = t.times(t), t = t.times(a.plus(i.times(o.times(i).minus(s))));
	return t;
}
function ua(e, t, n, r, i) {
	var a, o, s, c, l = 1, u = e.precision, d = Math.ceil(u / K);
	for (U = !1, c = n.times(n), s = new e(r);;) {
		if (o = X(s.times(c), new e(t++ * t++), u, 1), s = i ? r.plus(o) : r.minus(o), r = X(o.times(c), new e(t++ * t++), u, 1), o = s.plus(r), o.d[d] !== void 0) {
			for (a = d; o.d[a] === s.d[a] && a--;);
			if (a == -1) break;
		}
		a = s, s = r, r = o, o = a, l++;
	}
	return U = !0, o.d.length = d + 1, o;
}
function da(e, t) {
	for (var n = e; --t;) n *= e;
	return n;
}
function fa(e, t) {
	var n, r = t.s < 0, i = Qi(e, e.precision, 1), a = i.times(.5);
	if (t = t.abs(), t.lte(a)) return Mi = r ? 4 : 1, t;
	if (n = t.divToInt(i), n.isZero()) Mi = r ? 3 : 2;
	else {
		if (t = t.minus(n.times(i)), t.lte(a)) return Mi = na(n) ? r ? 2 : 3 : r ? 4 : 1, t;
		Mi = na(n) ? r ? 1 : 4 : r ? 3 : 2;
	}
	return t.minus(i).abs();
}
function pa(e, t, n, r) {
	var i, a, o, s, c, l, u, d, f, p = e.constructor, m = n !== void 0;
	if (m ? (Y(n, 1, Ei), r === void 0 ? r = p.rounding : Y(r, 0, 8)) : (n = p.precision, r = p.rounding), !e.isFinite()) u = oa(e);
	else {
		for (u = Yi(e), o = u.indexOf("."), m ? (i = 2, t == 16 ? n = n * 4 - 3 : t == 8 && (n = n * 3 - 2)) : i = t, o >= 0 && (u = u.replace(".", ""), f = new p(1), f.e = u.length - o, f.d = qi(Yi(f), 10, i), f.e = f.d.length), d = qi(u, 10, i), a = c = d.length; d[--c] == 0;) d.pop();
		if (!d[0]) u = m ? "0p+0" : "0";
		else {
			if (o < 0 ? a-- : (e = new p(e), e.d = d, e.e = a, e = X(e, f, n, r, 0, i), d = e.d, a = e.e, l = ji), o = d[n], s = i / 2, l ||= d[n + 1] !== void 0, l = r < 4 ? (o !== void 0 || l) && (r === 0 || r === (e.s < 0 ? 3 : 2)) : o > s || o === s && (r === 4 || l || r === 6 && d[n - 1] & 1 || r === (e.s < 0 ? 8 : 7)), d.length = n, l) for (; ++d[--n] > i - 1;) d[n] = 0, n || (++a, d.unshift(1));
			for (c = d.length; !d[c - 1]; --c);
			for (o = 0, u = ""; o < c; o++) u += Di.charAt(d[o]);
			if (m) {
				if (c > 1) if (t == 16 || t == 8) {
					for (o = t == 16 ? 4 : 3, --c; c % o; c++) u += "0";
					for (d = qi(u, i, t), c = d.length; !d[c - 1]; --c);
					for (o = 1, u = "1."; o < c; o++) u += Di.charAt(d[o]);
				} else u = u.charAt(0) + "." + u.slice(1);
				u = u + (a < 0 ? "p" : "p+") + a;
			} else if (a < 0) {
				for (; ++a;) u = "0" + u;
				u = "0." + u;
			} else if (++a > c) for (a -= c; a--;) u += "0";
			else a < c && (u = u.slice(0, a) + "." + u.slice(a));
		}
		u = (t == 16 ? "0x" : t == 2 ? "0b" : t == 8 ? "0o" : "") + u;
	}
	return e.s < 0 ? "-" + u : u;
}
function ma(e, t) {
	if (e.length > t) return e.length = t, !0;
}
function ha(e) {
	return new this(e).abs();
}
function ga(e) {
	return new this(e).acos();
}
function _a(e) {
	return new this(e).acosh();
}
function va(e, t) {
	return new this(e).plus(t);
}
function ya(e) {
	return new this(e).asin();
}
function ba(e) {
	return new this(e).asinh();
}
function xa(e) {
	return new this(e).atan();
}
function Sa(e) {
	return new this(e).atanh();
}
function Ca(e, t) {
	e = new this(e), t = new this(t);
	var n, r = this.precision, i = this.rounding, a = r + 4;
	return !e.s || !t.s ? n = new this(NaN) : !e.d && !t.d ? (n = Qi(this, a, 1).times(t.s > 0 ? .25 : .75), n.s = e.s) : !t.d || e.isZero() ? (n = t.s < 0 ? Qi(this, r, i) : new this(0), n.s = e.s) : !e.d || t.isZero() ? (n = Qi(this, a, 1).times(.5), n.s = e.s) : t.s < 0 ? (this.precision = a, this.rounding = 1, n = this.atan(X(e, t, a, 1)), t = Qi(this, a, 1), this.precision = r, this.rounding = i, n = e.s < 0 ? n.minus(t) : n.plus(t)) : n = this.atan(X(e, t, a, 1)), n;
}
function wa(e) {
	return new this(e).cbrt();
}
function Ta(e) {
	return Z(e = new this(e), e.e + 1, 2);
}
function Ea(e, t, n) {
	return new this(e).clamp(t, n);
}
function Da(e) {
	if (!e || typeof e != "object") throw Error(Ni + "Object expected");
	var t, n, r, i = e.defaults === !0, a = [
		"precision",
		1,
		Ei,
		"rounding",
		0,
		8,
		"toExpNeg",
		-Ti,
		0,
		"toExpPos",
		0,
		Ti,
		"maxE",
		0,
		Ti,
		"minE",
		-Ti,
		0,
		"modulo",
		0,
		9
	];
	for (t = 0; t < a.length; t += 3) if (n = a[t], i && (this[n] = Ai[n]), (r = e[n]) !== void 0) if (W(r) === r && r >= a[t + 1] && r <= a[t + 2]) this[n] = r;
	else throw Error(Pi + n + ": " + r);
	if (n = "crypto", i && (this[n] = Ai[n]), (r = e[n]) !== void 0) if (r === !0 || r === !1 || r === 0 || r === 1) if (r) if (typeof crypto < "u" && crypto && (crypto.getRandomValues || crypto.randomBytes)) this[n] = !0;
	else throw Error(Ii);
	else this[n] = !1;
	else throw Error(Pi + n + ": " + r);
	return this;
}
function Oa(e) {
	return new this(e).cos();
}
function ka(e) {
	return new this(e).cosh();
}
function Aa(e) {
	var t, n, r;
	function i(e) {
		var t, n, r, a = this;
		if (!(a instanceof i)) return new i(e);
		if (a.constructor = i, Fa(e)) {
			a.s = e.s, U ? !e.d || e.e > i.maxE ? (a.e = NaN, a.d = null) : e.e < i.minE ? (a.e = 0, a.d = [0]) : (a.e = e.e, a.d = e.d.slice()) : (a.e = e.e, a.d = e.d ? e.d.slice() : e.d);
			return;
		}
		if (r = typeof e, r === "number") {
			if (e === 0) {
				a.s = 1 / e < 0 ? -1 : 1, a.e = 0, a.d = [0];
				return;
			}
			if (e < 0 ? (e = -e, a.s = -1) : a.s = 1, e === ~~e && e < 1e7) {
				for (t = 0, n = e; n >= 10; n /= 10) t++;
				U ? t > i.maxE ? (a.e = NaN, a.d = null) : t < i.minE ? (a.e = 0, a.d = [0]) : (a.e = t, a.d = [e]) : (a.e = t, a.d = [e]);
				return;
			}
			if (e * 0 != 0) {
				e || (a.s = NaN), a.e = NaN, a.d = null;
				return;
			}
			return sa(a, e.toString());
		}
		if (r === "string") return (n = e.charCodeAt(0)) === 45 ? (e = e.slice(1), a.s = -1) : (n === 43 && (e = e.slice(1)), a.s = 1), Vi.test(e) ? sa(a, e) : ca(a, e);
		if (r === "bigint") return e < 0 ? (e = -e, a.s = -1) : a.s = 1, sa(a, e.toString());
		throw Error(Pi + e);
	}
	if (i.prototype = q, i.ROUND_UP = 0, i.ROUND_DOWN = 1, i.ROUND_CEIL = 2, i.ROUND_FLOOR = 3, i.ROUND_HALF_UP = 4, i.ROUND_HALF_DOWN = 5, i.ROUND_HALF_EVEN = 6, i.ROUND_HALF_CEIL = 7, i.ROUND_HALF_FLOOR = 8, i.EUCLID = 9, i.config = i.set = Da, i.clone = Aa, i.isDecimal = Fa, i.abs = ha, i.acos = ga, i.acosh = _a, i.add = va, i.asin = ya, i.asinh = ba, i.atan = xa, i.atanh = Sa, i.atan2 = Ca, i.cbrt = wa, i.ceil = Ta, i.clamp = Ea, i.cos = Oa, i.cosh = ka, i.div = ja, i.exp = Ma, i.floor = Na, i.hypot = Pa, i.ln = Ia, i.log = La, i.log10 = za, i.log2 = Ra, i.max = Ba, i.min = Va, i.mod = Ha, i.mul = Ua, i.pow = Wa, i.random = Ga, i.round = Ka, i.sign = qa, i.sin = Ja, i.sinh = Ya, i.sqrt = Xa, i.sub = Za, i.sum = Qa, i.tan = $a, i.tanh = eo, i.trunc = to, e === void 0 && (e = {}), e && e.defaults !== !0) for (r = [
		"precision",
		"rounding",
		"toExpNeg",
		"toExpPos",
		"maxE",
		"minE",
		"modulo",
		"crypto"
	], t = 0; t < r.length;) e.hasOwnProperty(n = r[t++]) || (e[n] = this[n]);
	return i.config(e), i;
}
function ja(e, t) {
	return new this(e).div(t);
}
function Ma(e) {
	return new this(e).exp();
}
function Na(e) {
	return Z(e = new this(e), e.e + 1, 3);
}
function Pa() {
	var e, t, n = new this(0);
	for (U = !1, e = 0; e < arguments.length;) if (t = new this(arguments[e++]), t.d) n.d && (n = n.plus(t.times(t)));
	else {
		if (t.s) return U = !0, new this(Infinity);
		n = t;
	}
	return U = !0, n.sqrt();
}
function Fa(e) {
	return e instanceof Q || e && e.toStringTag === Li || !1;
}
function Ia(e) {
	return new this(e).ln();
}
function La(e, t) {
	return new this(e).log(t);
}
function Ra(e) {
	return new this(e).log(2);
}
function za(e) {
	return new this(e).log(10);
}
function Ba() {
	return ra(this, arguments, -1);
}
function Va() {
	return ra(this, arguments, 1);
}
function Ha(e, t) {
	return new this(e).mod(t);
}
function Ua(e, t) {
	return new this(e).mul(t);
}
function Wa(e, t) {
	return new this(e).pow(t);
}
function Ga(e) {
	var t, n, r, i, a = 0, o = new this(1), s = [];
	if (e === void 0 ? e = this.precision : Y(e, 1, Ei), r = Math.ceil(e / K), !this.crypto) for (; a < r;) s[a++] = Math.random() * 1e7 | 0;
	else if (crypto.getRandomValues) for (t = crypto.getRandomValues(new Uint32Array(r)); a < r;) i = t[a], i >= 429e7 ? t[a] = crypto.getRandomValues(new Uint32Array(1))[0] : s[a++] = i % 1e7;
	else if (crypto.randomBytes) {
		for (t = crypto.randomBytes(r *= 4); a < r;) i = t[a] + (t[a + 1] << 8) + (t[a + 2] << 16) + ((t[a + 3] & 127) << 24), i >= 214e7 ? crypto.randomBytes(4).copy(t, a) : (s.push(i % 1e7), a += 4);
		a = r / 4;
	} else throw Error(Ii);
	for (r = s[--a], e %= K, r && e && (i = G(10, K - e), s[a] = (r / i | 0) * i); s[a] === 0; a--) s.pop();
	if (a < 0) n = 0, s = [0];
	else {
		for (n = -1; s[0] === 0; n -= K) s.shift();
		for (r = 1, i = s[0]; i >= 10; i /= 10) r++;
		r < K && (n -= K - r);
	}
	return o.e = n, o.d = s, o;
}
function Ka(e) {
	return Z(e = new this(e), e.e + 1, this.rounding);
}
function qa(e) {
	return e = new this(e), e.d ? e.d[0] ? e.s : 0 * e.s : e.s || NaN;
}
function Ja(e) {
	return new this(e).sin();
}
function Ya(e) {
	return new this(e).sinh();
}
function Xa(e) {
	return new this(e).sqrt();
}
function Za(e, t) {
	return new this(e).sub(t);
}
function Qa() {
	var e = 0, t = arguments, n = new this(t[e]);
	for (U = !1; n.s && ++e < t.length;) n = n.plus(t[e]);
	return U = !0, Z(n, this.precision, this.rounding);
}
function $a(e) {
	return new this(e).tan();
}
function eo(e) {
	return new this(e).tanh();
}
function to(e) {
	return Z(e = new this(e), e.e + 1, 1);
}
q[Symbol.for("nodejs.util.inspect.custom")] = q.toString, q[Symbol.toStringTag] = "Decimal";
var Q = q.constructor = Aa(Ai);
Oi = new Q(Oi), ki = new Q(ki);
//#endregion
//#region src/utils/media-time-converter.ts
var no = class e {
	constructor() {}
	static create() {
		return new e();
	}
	hourMinSecMillisToSeconds(e, t, n, r) {
		let i = new Q(e), a = new Q(t), o = new Q(n), s = new Q(r).div(10 ** `${r}`.length);
		return i.mul(3600).plus(a.mul(60)).plus(o).plus(s).toNumber();
	}
	decimalTimeToHourMinSecMillis(e, t) {
		let n = e.div(3600).floor(), r = e.minus(n.mul(3600));
		t && n.gte(t) && (n = n.modulo(t));
		let i = r.div(60).floor();
		r = r.minus(i.times(60));
		let a = r.floor();
		r = r.minus(a);
		let o = r.mul(1e3).floor();
		return {
			hours: n.toNumber(),
			minutes: i.toNumber(),
			seconds: a.toNumber(),
			milliseconds: o.toNumber()
		};
	}
}, ro = class {
	static isNullUndefinedOrWhitespace(e) {
		return e == null ? !0 : `${e}`.replace(/\s/g, "").length < 1;
	}
	static isNonEmpty(e) {
		return !this.isNullUndefinedOrWhitespace(e);
	}
	static isEmpty(e) {
		return !this.isNonEmpty(e);
	}
};
//#endregion
//#region src/utils/util-functions.ts
function io(e) {
	return e == null;
}
//#endregion
//#region src/utils/frame-rate-resolver.ts
var ao = class {
	static {
		this._frameRateValuePrecision = 15;
	}
	static {
		this._frameRateValueForLooseKeyPrecision = 2;
	}
	static {
		this.FR_23_98 = this.createFrameRateModel({ fraction: {
			numerator: 24e3,
			denominator: 1001
		} });
	}
	static {
		this.FR_29_97 = this.createFrameRateModel({ fraction: {
			numerator: 3e4,
			denominator: 1001
		} });
	}
	static {
		this.FR_29_97_DF = this.createFrameRateModel({
			fraction: {
				numerator: 3e4,
				denominator: 1001
			},
			dropFrames: 2
		});
	}
	static {
		this.FR_59_94 = this.createFrameRateModel({ fraction: {
			numerator: 6e4,
			denominator: 1001
		} });
	}
	static {
		this.FR_59_94_DF = this.createFrameRateModel({
			fraction: {
				numerator: 6e4,
				denominator: 1001
			},
			dropFrames: 4
		});
	}
	static {
		this.FR_119_88 = this.createFrameRateModel({ fraction: {
			numerator: 12e4,
			denominator: 1001
		} });
	}
	static {
		this.FR_239_76 = this.createFrameRateModel({ fraction: {
			numerator: 24e4,
			denominator: 1001
		} });
	}
	static {
		this._presetFrameRateModels = [
			this.FR_23_98,
			this.FR_29_97,
			this.FR_29_97_DF,
			this.FR_59_94,
			this.FR_59_94_DF,
			this.FR_119_88,
			this.FR_239_76
		];
	}
	static {
		this._presetFrameRateModelsByLooseKey = new Map(this._presetFrameRateModels.map((e) => [this.createFrameRateModelLooseKey(e.value, !!e.dropFrames), e]));
	}
	static createFrameRateModelLooseKey(e, t) {
		let n = e.toFixed(this._frameRateValueForLooseKeyPrecision);
		return t === void 0 && n && n === this.FR_29_97.value.toFixed(this._frameRateValueForLooseKeyPrecision) && (t = !0), `${n}${t ? "_DF" : ""}`;
	}
	static createFrameRateModel(e) {
		let t = e.fraction.numerator, n = e.fraction.denominator;
		if (isNaN(t) || isNaN(n) || t < 1 || n < 0) throw Error("Numerator and denominator must be integers larger than 0");
		let r = e.value ? e.value : parseFloat((t / n).toFixed(this._frameRateValuePrecision)), i = Q.div(1, r).toNumber();
		return {
			...e,
			value: r,
			frameDuration: i
		};
	}
	static resolveFrameRateModel(e, t) {
		let n = "Frame rate must be number or fraction string in format \"numerator/denominator\"", r = `Provided frame rate not supported. Supported drop frame rates: ${this._presetFrameRateModels.filter((e) => !!e.dropFrames).map((e) => e.value.toFixed(this._frameRateValueForLooseKeyPrecision)).join(", ")}`, i = (e) => {
			let n = this.createFrameRateModelLooseKey(e, t), i = this._presetFrameRateModelsByLooseKey.get(n);
			if (!i && t) throw Error(r);
			return i || this.createFrameRateModel({ fraction: {
				numerator: e,
				denominator: 1
			} });
		}, a = (e) => {
			if (ro.isEmpty(e)) throw Error(n);
			let i = e.split("/");
			if (!i[0] || !i[1] || i.length !== 2) throw Error(n);
			let a = Number(i[0]), o = Number(i[1]), s = this.createFrameRateModelLooseKey(a / o, t), c = this._presetFrameRateModelsByLooseKey.get(s);
			if (!c && t) throw Error(r);
			return c || this.createFrameRateModel({ fraction: {
				numerator: a,
				denominator: o
			} });
		};
		if (io(e)) throw Error(n);
		if (typeof e == "number") return i(e);
		if (typeof e == "string") return a(e);
		throw Error(n);
	}
}, oo = class {
	static {
		this._vttCueTimingRegex = /^(((\d{2,}):)?(\d{2}):(\d{2})\.(\d{3}))\s+-->\s+(((\d{2,}):)?(\d{2}):(\d{2})\.(\d{3}))(\s+.*)?$/;
	}
	static {
		this._srtCueTimingRegex = /^((\d{2,}):(\d{2}):(\d{2}),(\d{3}))\s+-->\s+((\d{2,}):(\d{2}):(\d{2}),(\d{3}))(\s+.*)?$/;
	}
	static {
		this._minBeginTime = 0;
	}
	static {
		this._minEndTime = .001;
	}
	static slewImscContent(e, t) {
		let n = this.parseImscContent(e), r = n.documentElement, i = "http://www.w3.org/ns/ttml#parameter", a = () => {
			let e = r.hasAttributeNS(i, "frameRate") ? parseInt(r.getAttributeNS(i, "frameRate"), 10) : 30, n = r.getAttributeNS(i, "frameRateMultiplier")?.trim() ?? "1 1", a = r.hasAttributeNS(i, "tickRate") ? parseInt(r.getAttributeNS(i, "tickRate"), 10) : 1, o = n.split(/\s+/), s = `${e * parseInt(o[0])}/${parseInt(o[1])}`, c = ao.resolveFrameRateModel(s);
			return {
				expectedFrameRate: t.expectedFrameRate,
				effectiveFrameRate: c.value,
				tickRate: a
			};
		}, o = r.getAttributeNS(i, "timeBase") ?? "media";
		if (o === "clock" || o === "smpte") throw Error(`Slewing ttml with ${o} timeBase is not supported`);
		if (o === "media") this.slewMediaTimeBaseContent(r, t.timeSlew, a());
		else throw Error(`Unknown timeBase attribute: ${o}`);
		return this.serializeImscDocument(n);
	}
	static slewVttContent(e, t) {
		let n = e.split(/\r?\n/).map((e) => e.trim()), r = this._minBeginTime, i = this._minEndTime;
		return n.map((e) => {
			if (!this._vttCueTimingRegex.test(e)) return e;
			let n = this._vttCueTimingRegex.exec(e), a = n.at(1), o = n.at(7), s = n.at(13) ?? "", c = $.slewVttCueTimestamp(a, t.timeSlew, r), l = $.slewVttCueTimestamp(o, t.timeSlew, i);
			return c.oldValue + t.timeSlew < 0 && l.oldValue + t.timeSlew < 0 && (r = l.newValue, i = r + this._minEndTime), `${c.newValueText} --> ${l.newValueText}${s}`;
		}).join("\n");
	}
	static slewSrtContent(e, t) {
		let n = e.split(/\r?\n/).map((e) => e.trim()), r = this._minBeginTime, i = this._minEndTime;
		return n.map((e) => {
			if (!this._srtCueTimingRegex.test(e)) return e;
			let n = this._srtCueTimingRegex.exec(e), a = n.at(1), o = n.at(6), s = n.at(11) ?? "", c = $.slewSrtCueTimestamp(a, t.timeSlew, r), l = $.slewSrtCueTimestamp(o, t.timeSlew, i);
			return c.oldValue + t.timeSlew < 0 && l.oldValue + t.timeSlew < 0 && (r = l.newValue, i = r + this._minEndTime), `${c.newValueText} --> ${l.newValueText}${s}`;
		}).join("\n");
	}
	static slewAssContent(e, t) {
		let n = e.split(/\r?\n/).map((e) => e.trim()), r = [], i = [], a = !1;
		if (n.forEach((e) => {
			!a && e.startsWith("[Events]") && (a = !0), a ? r.push(e) : i.push(e);
		}), !a) return n.join("\n");
		let o = r.find((e) => e.startsWith("Format:"));
		if (!o) return n.join("\n");
		let s = this._minBeginTime, c = this._minEndTime, l = o.slice(7).split(",").map((e) => e.trim().toLowerCase()), u = l.indexOf("start"), d = l.indexOf("end"), f = r.map((e) => {
			if (!e.startsWith("Dialogue:")) return e;
			let n = e.slice(9).trim().split(","), r = n.at(u), i = n.at(d);
			if (!r || !i) return e;
			let a = $.slewAssCueTimestamp(r, t.timeSlew, s), o = $.slewAssCueTimestamp(i, t.timeSlew, c);
			return a.oldValue + t.timeSlew < 0 && o.oldValue + t.timeSlew < 0 && (s = o.newValue, c = s + this._minEndTime), n[u] = a.newValueText, n[d] = o.newValueText, "Dialogue: " + n.join(",");
		});
		return [...i, ...f].join("\n");
	}
	static updateImscContentStyling(e) {
		let t = this.parseImscContent(e), n = t.documentElement, r = "http://www.w3.org/ns/ttml#styling", i = n.getElementsByTagName("region"), a = n.getElementsByTagName("body");
		return [...i].forEach((e) => e.setAttributeNS(r, "overflow", "visible")), [...a].forEach((e) => e.setAttributeNS(r, "lineHeight", "127%")), this.serializeImscDocument(t);
	}
	static parseImscContent(e) {
		let t = new DOMParser().parseFromString(e, "application/xml"), n = t.querySelector("parsererror");
		if (n) throw Error(`Invalid TTML file: ${n.textContent}`);
		return t;
	}
	static serializeImscDocument(e) {
		return new XMLSerializer().serializeToString(e);
	}
	static slewMediaTimeBaseContent(e, t, n) {
		let r = e.getElementsByTagName("body");
		if (!t || !r.length) return;
		let i = r[0];
		t >= 0 ? (i.hasAttribute("begin") ? i.setAttribute("begin", $.slewImscCueTimestamp(i.getAttribute("begin"), n, t, this._minBeginTime).newValueText) : i.setAttribute("begin", $.secondsToImscMediaTimeCue(t)), i.hasAttribute("end") && i.setAttribute("end", $.slewImscCueTimestamp(i.getAttribute("end"), n, t, this._minEndTime).newValueText)) : this.recursivelySlewElements([i], n, t);
	}
	static recursivelySlewElements(e, t, n) {
		return e.length && e.forEach((e) => {
			let r = new Q(n);
			if (e.hasAttribute("begin")) {
				let i = $.slewImscCueTimestamp(e.getAttribute("begin"), t, n, this._minBeginTime);
				r = r.plus(i.oldValue).minus(i.newValue), e.setAttribute("begin", i.newValueText);
			}
			if (e.hasAttribute("end")) {
				let r = $.slewImscCueTimestamp(e.getAttribute("end"), t, n, this._minEndTime);
				e.setAttribute("end", r.newValueText);
			}
			if (r.lt(0)) {
				let n = this.recursivelySlewElements([...e.children].filter((e) => e.tagName.toLowerCase() === "div"), t, r.toNumber());
				if (n < 0) {
					let r = e.querySelectorAll(":scope > p[begin][end]"), i = this._minBeginTime, a = this._minEndTime;
					r.forEach((e) => {
						let r = $.slewImscCueTimestamp(e.getAttribute("begin"), t, n, i), o = $.slewImscCueTimestamp(e.getAttribute("end"), t, n, a);
						e.setAttribute("begin", r.newValueText), e.setAttribute("end", o.newValueText), r.oldValue + n < 0 && o.oldValue + n < 0 && (i = o.newValue, a = i + this._minEndTime);
					});
				}
			}
		}), n;
	}
}, $ = class {
	static {
		this._vttOrAssCueMediaTimeRegex = /^((\d{1,3}):)?(\d{2}):(\d{2})(\.(\d{1,3}))?$/;
	}
	static {
		this._srtCueMediaTimeRegex = /^(\d{1,3}):(\d{2}):(\d{2}),(\d{1,3})$/;
	}
	static {
		this._imscCueMediaTimeRegex = /^(\d{1,}):(\d{2}):(\d{2})(\.(\d{1,}))?$/;
	}
	static {
		this._imscCueMediaTimeWithFramesRegex = /^(\d{1,}):(\d{2}):(\d{2})(:(\d{1,}))?$/;
	}
	static {
		this._imscCueSecondsOffsetTimeRegex = /^(\d{1,})(\.(\d{1,}))?s$/;
	}
	static {
		this._imscCueFramesOffsetTimeRegex = /^(\d{1,})(\.(\d{1,}))?f$/;
	}
	static {
		this._imscCueTicksOffsetTimeRegex = /^(\d{1,})(\.(\d{1,}))?t$/;
	}
	static {
		this._mediaTimeConverter = no.create();
	}
	static {
		this._fillStringValue = "0";
	}
	static slewVttCueTimestamp(e, t, n) {
		if (!this._vttOrAssCueMediaTimeRegex.test(e)) throw Error(`Slewing vtt cue timestamp ${e} is not supported`);
		let r = this._vttOrAssCueMediaTimeRegex.exec(e), i = r.at(2) ? r.at(2) : this._fillStringValue, a = r.at(3), o = r.at(4), s = r.at(6) ?? this._fillStringValue, c = this._mediaTimeConverter.hourMinSecMillisToSeconds(i, a, o, s), l = this.clampTime(this.slewTime(c, t), n);
		return {
			oldValue: c,
			newValue: l,
			newValueText: this.secondsToVttMediaTimeCue(l)
		};
	}
	static slewSrtCueTimestamp(e, t, n) {
		if (!this._srtCueMediaTimeRegex.test(e)) throw Error(`Slewing srt cue timestamp ${e} is not supported`);
		let r = this._srtCueMediaTimeRegex.exec(e), i = r.at(1), a = r.at(2), o = r.at(3), s = r.at(4), c = this._mediaTimeConverter.hourMinSecMillisToSeconds(i, a, o, s), l = this.clampTime(this.slewTime(c, t), n);
		return {
			oldValue: c,
			newValue: l,
			newValueText: this.secondsToSrtMediaTimeCue(l)
		};
	}
	static slewImscCueTimestamp(e, t, n, r) {
		if (this._imscCueMediaTimeRegex.test(e)) {
			let t = this._imscCueMediaTimeRegex.exec(e), i = t.at(1), a = t.at(2), o = t.at(3), s = t.at(5) ?? this._fillStringValue, c = this._mediaTimeConverter.hourMinSecMillisToSeconds(i, a, o, s), l = this.clampTime(this.slewTime(c, n), r);
			return {
				oldValue: c,
				newValue: l,
				newValueText: this.secondsToImscMediaTimeCue(l)
			};
		} else if (this._imscCueMediaTimeWithFramesRegex.test(e)) {
			let { expectedFrameRate: i, effectiveFrameRate: a } = t;
			if (!io(i)) {
				let e = ao.resolveFrameRateModel(i);
				if (a !== e.value) throw Error(`Expected frame rate: ${e.value} is not equal to ttml file frame rate: ${a}`);
			}
			let o = this._imscCueMediaTimeWithFramesRegex.exec(e), s = o.at(1), c = o.at(2), l = o.at(3), u = o.at(5) ?? this._fillStringValue, d = new Q(s), f = new Q(c), p = new Q(l), m = new Q(u), h = d.mul(3600).plus(f.mul(60)).plus(p).plus(m.div(a)).toNumber(), g = this.clampTime(this.slewTime(h, n), r);
			return {
				oldValue: h,
				newValue: g,
				newValueText: this.secondsToImscMediaTimeWithFramesCue(g, a)
			};
		} else if (this._imscCueSecondsOffsetTimeRegex.test(e)) {
			let t = this._imscCueSecondsOffsetTimeRegex.exec(e), i = t.at(1), a = t.at(3) ?? this._fillStringValue, o = this._mediaTimeConverter.hourMinSecMillisToSeconds(this._fillStringValue, this._fillStringValue, i, a), s = this.clampTime(this.slewTime(o, n), r);
			return {
				oldValue: o,
				newValue: s,
				newValueText: this.secondsToImscSecondsOffsetCue(s)
			};
		} else if (this._imscCueFramesOffsetTimeRegex.test(e)) {
			let { expectedFrameRate: i, effectiveFrameRate: a } = t;
			if (!io(i)) {
				let e = ao.resolveFrameRateModel(i);
				if (a !== e.value) throw Error(`Expected frame rate: ${e.value} is not equal to ttml file frame rate: ${a}`);
			}
			let o = this._imscCueFramesOffsetTimeRegex.exec(e), s = o.at(1), c = o.at(3) ?? this._fillStringValue, l = new Q(s), u = new Q(c).div(10 ** `${c}`.length), d = l.plus(u).div(a).toNumber(), f = this.clampTime(this.slewTime(d, n), r);
			return {
				oldValue: d,
				newValue: f,
				newValueText: this.secondsToImscFramesOffsetCue(f, a)
			};
		} else if (this._imscCueTicksOffsetTimeRegex.test(e)) {
			let i = this._imscCueTicksOffsetTimeRegex.exec(e), a = i.at(1), o = i.at(3) ?? this._fillStringValue, s = new Q(a), c = new Q(o).div(10 ** `${o}`.length), l = s.plus(c).div(t.tickRate).toNumber(), u = this.clampTime(this.slewTime(l, n), r);
			return {
				oldValue: l,
				newValue: u,
				newValueText: this.secondsToImscTicksOffsetCue(u, t.tickRate)
			};
		} else throw Error(`Slewing imsc cue timestamp ${e} is not supported`);
	}
	static slewAssCueTimestamp(e, t, n) {
		if (!this._vttOrAssCueMediaTimeRegex.test(e)) throw Error(`Slewing ass/ssa cue timestamp ${e} is not supported`);
		let r = this._vttOrAssCueMediaTimeRegex.exec(e), i = r.at(2) ? r.at(2) : this._fillStringValue, a = r.at(3), o = r.at(4), s = r.at(6) ? r.at(6) : this._fillStringValue, c = this._mediaTimeConverter.hourMinSecMillisToSeconds(i, a, o, s), l = this.clampTime(this.slewTime(c, t), n);
		return {
			oldValue: c,
			newValue: l,
			newValueText: this.secondsToAssMediaTimeCue(l)
		};
	}
	static secondsToVttMediaTimeCue(e) {
		return this.formatMediaTimeCue(this._mediaTimeConverter.decimalTimeToHourMinSecMillis(new Q(e)), ".", 2, 3);
	}
	static secondsToSrtMediaTimeCue(e) {
		return this.formatMediaTimeCue(this._mediaTimeConverter.decimalTimeToHourMinSecMillis(new Q(e)), ",", 2, 3);
	}
	static secondsToAssMediaTimeCue(e) {
		return this.formatMediaTimeCue(this._mediaTimeConverter.decimalTimeToHourMinSecMillis(new Q(e), 10), ".", 1, 2);
	}
	static secondsToImscMediaTimeCue(e) {
		return this.formatMediaTimeCue(this._mediaTimeConverter.decimalTimeToHourMinSecMillis(new Q(e)), ".", 2, 3);
	}
	static secondsToImscMediaTimeWithFramesCue(e, t) {
		let n = new Q(e), r = n.div(3600).floor();
		n = n.minus(r.mul(3600));
		let i = n.div(60).floor();
		n = n.minus(i.times(60));
		let a = n.floor();
		n = n.minus(a);
		let o = n.mul(t).round();
		return `${r.toString().padStart(2, this._fillStringValue)}:${i.toString().padStart(2, this._fillStringValue)}:${a.toString().padStart(2, this._fillStringValue)}:${o.toString().padStart(2, this._fillStringValue)}`;
	}
	static secondsToImscSecondsOffsetCue(e) {
		return `${e}s`;
	}
	static secondsToImscFramesOffsetCue(e, t) {
		return `${Q.mul(t, e).toNumber()}f`;
	}
	static secondsToImscTicksOffsetCue(e, t) {
		return `${Q.mul(e, t).toNumber()}t`;
	}
	static formatMediaTimeCue(e, t, n, r) {
		return `${e.hours.toString().padStart(n, this._fillStringValue)}:${e.minutes.toString().padStart(2, this._fillStringValue)}:${e.seconds.toString().padStart(2, this._fillStringValue)}${t}${e.milliseconds.toString().padStart(r, this._fillStringValue)}`;
	}
	static clampTime(e, t) {
		return Math.max(t, e);
	}
	static slewTime(e, t) {
		return new Q(e).plus(t).toNumber();
	}
};
v(), F(), we(), Dr();
async function so(e, t, n) {
	let { sccToModel: r } = await Promise.resolve().then(() => (It(), Ot)), i = r(e, n);
	switch (t) {
		case "srt": {
			let { srtFromModel: e } = await Promise.resolve().then(() => ($r(), Yr));
			return e(i, n);
		}
		case "vtt": {
			let { vttFromModel: e } = await Promise.resolve().then(() => (mi(), li));
			return e(i, n);
		}
		case "imsc": {
			let { imscFromModel: e } = await Promise.resolve().then(() => (wi(), hi));
			return e(i, n);
		}
		default: throw Error(`Unknown format: ${t}`);
	}
}
async function co(e, t, n) {
	let { stlToModel: r } = await Promise.resolve().then(() => (un(), cn)), i = r(e, n);
	switch (t) {
		case "srt": {
			let { srtFromModel: e } = await Promise.resolve().then(() => ($r(), Yr));
			return e(i, n);
		}
		case "vtt": {
			let { vttFromModel: e } = await Promise.resolve().then(() => (mi(), li));
			return e(i, n);
		}
		case "imsc": {
			let { imscFromModel: e } = await Promise.resolve().then(() => (wi(), hi));
			return e(i, n);
		}
		default: throw Error(`Unknown format: ${t}`);
	}
}
function lo(e, t, n, r, i) {
	let a;
	switch (t) {
		case "scc":
			a = kt(e, r?.reader);
			break;
		case "stl":
			a = ln(e);
			break;
		case "srt":
			a = yn(e);
			break;
		case "vtt":
			a = In(e);
			break;
		case "ttml":
			a = hr(e);
			break;
		default: throw Error(`Unsupported input format: ${t}`);
	}
	switch (n) {
		case "srt":
			let o = t === n ? e : Qr(a, r?.writer, i);
			return r?.slewOptions?.timeSlew ? oo.slewSrtContent(o, r.slewOptions) : o;
		case "vtt":
			let s = t === n ? e : pi(a, r?.writer, i);
			return r?.slewOptions?.timeSlew ? oo.slewVttContent(s, r.slewOptions) : s;
		case "ttml":
			let c = t === n ? e : oo.updateImscContentStyling(xi(a, r?.writer, i));
			return r?.slewOptions?.timeSlew ? oo.slewImscContent(c, r.slewOptions) : c;
		default: throw Error(`Unsupported output format: ${n}`);
	}
}
function uo(e, t, n) {
	switch (t) {
		case "vtt": return oo.slewVttContent(e, n);
		case "srt": return oo.slewSrtContent(e, n);
		case "ttml": return oo.slewImscContent(e, n);
		case "ass":
		case "ssa": return oo.slewAssContent(e, n);
		default: throw Error(`Unsupported slew format: ${t}`);
	}
}
//#endregion
export { l as Body, p as Br, Se as ClockTime, _ as ContentDocument, ie as DirectionType, O as DisplayAlignType, ee as DisplayType, u as Div, me as FPS_23_98, he as FPS_24, ge as FPS_25, _e as FPS_29_97, ve as FPS_30, ye as FPS_50, be as FPS_59_94, xe as FPS_60, E as FontStyleType, T as FontWeightType, o as Fraction, Er as ISD, Tr as ISDElement, wr as ISDRegion, C as LengthUnits, w as NamedColors, j as OverflowType, d as P, h as Region, ne as ShowBackgroundType, Ce as SmpteTimeCode, f as Span, P as StyleProperties, m as Text, D as TextAlignType, re as UnicodeBidiType, A as VisibilityType, s as WhiteSpaceHandling, te as WrapOptionType, k as WritingModeType, lo as convert, so as convertScc, co as convertStl, xi as imscFromModel, x as makeColor, b as makeLengthType, S as makeTextDecoration, kt as sccToModel, uo as slew, Qr as srtFromModel, yn as srtToModel, ln as stlToModel, hr as ttmlToModel, pi as vttFromModel, In as vttToModel };

//# sourceMappingURL=omakase-ttconv-ts.es.js.map